// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary precision signed decimal */
  BigDecimal: { input: number; output: number; }
  /** Built-in scalar representing a local date */
  LocalDate: { input: LocalDate; output: LocalDate; }
  /** Custom scalar for LocalDateTime */
  LocalDateTime: { input: LocalDateTime; output: LocalDateTime; }
  /** Custom scalar for LocalTime */
  LocalTime: { input: LocalTime; output: LocalTime; }
};

export type AccountingMovementReportTypeDto = {
  __typename?: 'AccountingMovementReportTypeDTO';
  cityTax: Scalars['Boolean']['output'];
  documentType: Scalars['Boolean']['output'];
  holder: Scalars['Boolean']['output'];
  includeDeparturesInPeriodOnly: Scalars['Boolean']['output'];
  includePresencesBeforePeriodAndDepartureInPeriod: Scalars['Boolean']['output'];
  onlySummary: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  payment: Scalars['Boolean']['output'];
  paymentEffectiveUsername: Scalars['Boolean']['output'];
  psIstatGroup: Scalars['Boolean']['output'];
  type: AccountingMovementReportTypeEnumDto;
};

export enum AccountingMovementReportTypeEnumDto {
  AccountingSummary = 'ACCOUNTING_SUMMARY',
  Cash = 'CASH',
  CityTax = 'CITY_TAX',
  CityTaxByTaxDate = 'CITY_TAX_BY_TAX_DATE',
  Fee = 'FEE',
  FeeCategoryCash = 'FEE_CATEGORY_CASH',
  FeeWithInvoice = 'FEE_WITH_INVOICE',
  Outstanding = 'OUTSTANDING',
  OutstandingPaymentExpected = 'OUTSTANDING_PAYMENT_EXPECTED'
}

export type AgencyDto = {
  __typename?: 'AgencyDTO';
  EInvoicingCode: Maybe<Scalars['String']['output']>;
  address: Maybe<Scalars['String']['output']>;
  blue: Maybe<Scalars['Int']['output']>;
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  commission: Maybe<Scalars['BigDecimal']['output']>;
  corpName: Scalars['String']['output'];
  customerCode: Maybe<Scalars['String']['output']>;
  /** if present it is always > 0 */
  discount: Maybe<Scalars['BigDecimal']['output']>;
  district: Maybe<Scalars['String']['output']>;
  documentFolder: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoiceDefaultBuilding: Maybe<InvoiceDefaultBuildingDto>;
  invoiceType: Maybe<InvoiceDocumentTypeDto>;
  mail: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  password: Maybe<Scalars['String']['output']>;
  paymentTerms: Maybe<PaymentTermsDto>;
  pec: Maybe<Scalars['String']['output']>;
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  publicAdministration: Scalars['Boolean']['output'];
  red: Maybe<Scalars['Int']['output']>;
  referringName: Maybe<Scalars['String']['output']>;
  referringSurname: Maybe<Scalars['String']['output']>;
  site: Maybe<Scalars['String']['output']>;
  /** deprecated - use `stateId` instead */
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type AgencyListPaginatedDto = {
  __typename?: 'AgencyListPaginatedDTO';
  agencies: Array<AgencyDto>;
  pagination: PaginationDto;
};

export type AgencyPlannerDto = {
  __typename?: 'AgencyPlannerDTO';
  blue: Maybe<Scalars['Int']['output']>;
  corpName: Scalars['String']['output'];
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export enum AllotmentToShowEnumDto {
  Configured = 'CONFIGURED',
  Remainings = 'REMAININGS',
  RemainingsAndConfigured = 'REMAININGS_AND_CONFIGURED'
}

export type AstatDailyClosureDayDto = {
  __typename?: 'AstatDailyClosureDayDTO';
  date: Scalars['LocalDate']['output'];
  open: Scalars['Boolean']['output'];
};

export type AstatDailyLocalTaxInfoDto = {
  __typename?: 'AstatDailyLocalTaxInfoDTO';
  month: Scalars['Int']['output'];
  monthClosed: Scalars['Boolean']['output'];
  totalArrivals: Scalars['Int']['output'];
  totalDepartures: Scalars['Int']['output'];
  totalGuestsPresent: Scalars['Int']['output'];
  totalTaxAdults: Scalars['Int']['output'];
  totalTaxChildren: Scalars['Int']['output'];
  totalTaxExempted: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type AstatDailyMovementProtoDto = {
  __typename?: 'AstatDailyMovementProtoDTO';
  date: Scalars['LocalDate']['output'];
  occupiedUnits: Scalars['Int']['output'];
  open: Scalars['Boolean']['output'];
  totalArrivals: Scalars['Int']['output'];
  totalDepartures: Scalars['Int']['output'];
  totalGuestsPresent: Scalars['Int']['output'];
};

export type AtecoCodeDto = {
  __typename?: 'AtecoCodeDTO';
  cashRegisterCode: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
};

export enum BnplStatusEnumDto {
  GatewayAvailable = 'GATEWAY_AVAILABLE',
  GatewayMandatory = 'GATEWAY_MANDATORY',
  Holipay = 'HOLIPAY'
}

export enum BolImageEnumDto {
  FullImage_1 = 'FULL_IMAGE_1',
  FullImage_2 = 'FULL_IMAGE_2',
  FullImage_3 = 'FULL_IMAGE_3',
  FullImage_4 = 'FULL_IMAGE_4',
  FullImage_5 = 'FULL_IMAGE_5',
  FullImage_6 = 'FULL_IMAGE_6',
  FullImage_7 = 'FULL_IMAGE_7',
  FullImage_8 = 'FULL_IMAGE_8',
  FullImage_9 = 'FULL_IMAGE_9',
  FullImage_10 = 'FULL_IMAGE_10',
  MainImage = 'MAIN_IMAGE'
}

export type BuildCashRegisterCreditNoteRequestDtoInput = {
  creditNoteInvoiceId: Scalars['Int']['input'];
};

export type BuildCashRegisterReceiptRequestDtoInput = {
  invoiceId: Scalars['Int']['input'];
  language: Scalars['String']['input'];
};

export type BuildCreditNoteResponseDto = {
  __typename?: 'BuildCreditNoteResponseDTO';
  cancellableDocumentType: CancellableDocumentTypeEnumDto;
  cityTax: Maybe<Scalars['BigDecimal']['output']>;
  deposits: Array<DepositDto>;
  editMode: EditModeEnumDto;
  elements: Array<ElementDto>;
  invoiceId: Scalars['Int']['output'];
  linkedDeposits: Array<InvoiceToDepositDto>;
  notes: Maybe<Scalars['String']['output']>;
  originalInvoiceDate: Scalars['LocalDate']['output'];
  originalInvoiceType: InvoiceDocumentTypeDto;
  payment2Amount: Maybe<Scalars['BigDecimal']['output']>;
  payment2Id: Maybe<Scalars['Int']['output']>;
  paymentAmount: Maybe<Scalars['BigDecimal']['output']>;
  paymentId: Maybe<Scalars['Int']['output']>;
  vats: Array<Scalars['BigDecimal']['output']>;
};

export type BuildDepositInvoiceObjectRequestDtoInput = {
  depositId: Scalars['Int']['input'];
  invoiceHolderId: Scalars['Int']['input'];
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  today: Scalars['LocalDate']['input'];
};

export type BuildInvoiceObjectRequestDtoInput = {
  documentType: InvoiceDocumentTypeDto;
  ignoreCheckInDone: Scalars['Boolean']['input'];
  invoiceBuildElements: InvoiceBuildElementsDto;
  invoiceHolderId: Scalars['Int']['input'];
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
  reservationId: Scalars['Int']['input'];
  subAccountHolderId?: InputMaybe<Scalars['Int']['input']>;
  today: Scalars['LocalDate']['input'];
};

export type BulkItemErrorDto = {
  __typename?: 'BulkItemErrorDTO';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  translationKey: Maybe<Scalars['String']['output']>;
};

export type BulkItemResultDto = {
  __typename?: 'BulkItemResultDTO';
  error: Maybe<BulkItemErrorDto>;
  id: Maybe<Scalars['Int']['output']>;
};

export type BulkResultsDto = {
  __typename?: 'BulkResultsDTO';
  results: Array<BulkItemResultDto>;
};

export type ButtonStateDto = {
  __typename?: 'ButtonStateDTO';
  /** Set only when the button is visible and disabled: the frontend shows one generic message per value */
  disabledReason: Maybe<DisabledReasonDto>;
  /** Meaningful only when visible is true */
  enabled: Scalars['Boolean']['output'];
  /** False means the action makes no sense here and the button is not rendered at all */
  visible: Scalars['Boolean']['output'];
};

export type CalcFiscalCodeRequestDtoInput = {
  birthDate: Scalars['LocalDate']['input'];
  /** mandatory only for Italy */
  birthPlaceId?: InputMaybe<Scalars['Int']['input']>;
  birthStateId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  sex: SexDto;
  surname: Scalars['String']['input'];
};

export type CalculateCityTaxAmountRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  cityTaxExemptionId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['LocalDate']['input'];
  ownerCityTaxId: Scalars['Int']['input'];
  purchasedStayToCustomerId: Scalars['Int']['input'];
};

export type CalculatePriceListPriceRequestDtoInput = {
  /** must be >= 0 */
  addedBed: Scalars['Int']['input'];
  /** must be >= 0 */
  addedJuniorBed: Scalars['Int']['input'];
  /** must be >= 0 */
  addedJuniorBed2: Scalars['Int']['input'];
  /** must be >= 0 */
  addedJuniorBed3: Scalars['Int']['input'];
  /** must be >= 0 */
  basePrice: Scalars['BigDecimal']['input'];
  /** must be >= 0 */
  cradle: Scalars['Int']['input'];
  /** the price list to test, not necessarily already saved */
  priceList: UpsertPriceListDtoInput;
  /** must be >= 0 */
  standardBed: Scalars['Int']['input'];
  /** It is mandatory when priceList.extraMealParameters flag is set to true */
  treatment?: InputMaybe<TreatmentEnumDto>;
};

export type CalculatePriceRequestDtoInput = {
  addedBed: Scalars['Int']['input'];
  addedJuniorBed: Scalars['Int']['input'];
  addedJuniorBed2: Scalars['Int']['input'];
  addedJuniorBed3: Scalars['Int']['input'];
  allInclusive: Scalars['Boolean']['input'];
  beginDate: Scalars['LocalDate']['input'];
  breakfast: Scalars['Boolean']['input'];
  cradle: Scalars['Int']['input'];
  dinner: Scalars['Boolean']['input'];
  endDate: Scalars['LocalDate']['input'];
  lunch: Scalars['Boolean']['input'];
  numberOfGuests: Scalars['Int']['input'];
  /** set for include packet in price calculation */
  packetId?: InputMaybe<Scalars['Int']['input']>;
  priceListId: Scalars['Int']['input'];
  /** necessary for an already existent purchasedStay to calculate the price with SoldIndex, based on sold rooms, the calculation excludes room of the old purchasedStay */
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
  purchasedStayPeriods?: InputMaybe<Array<InputMaybe<UpsertPurchasedStayPeriodDtoInput>>>;
  stayId: Scalars['Int']['input'];
};

export type CalculatePurchasedProductPriceRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type CalendarPriceDto = {
  __typename?: 'CalendarPriceDTO';
  date: Scalars['LocalDate']['output'];
  price: Scalars['BigDecimal']['output'];
};

export type CancelTransactionRequestDtoInput = {
  /** Amount to cancel, never above the amount of the original transaction. Less is a partial cancel, which only a gateway transaction accepts: the cancel operations of the payment terminals carry no amount and release the whole transaction. Keep the field read only where amountEditable of that row is false, the server refuses a different amount there */
  amount: Scalars['BigDecimal']['input'];
  /** Omit it to get the causalCancelPreauth of getOwnerCreditCard on a preauthorization and the causalRefund on anything else, which is what the form prefills. An empty string is stored as such */
  causal?: InputMaybe<Scalars['String']['input']>;
  /** Free text, none by default */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The resource the window was opened from, the same one passed to getCreditCards, which is how the transaction is reached */
  resource: GetCreditCardsRequestDtoInput;
  /** CreditCardTransactionRowDTO.id of the transaction to cancel */
  transactionId: Scalars['Int']['input'];
};

export enum CancellableDocumentTypeEnumDto {
  DepositInvoice = 'DEPOSIT_INVOICE',
  Invoice = 'INVOICE',
  MasterInvoice = 'MASTER_INVOICE',
  Receipt = 'RECEIPT',
  ReceiptNotToPay = 'RECEIPT_NOT_TO_PAY'
}

export enum CancellationPolicyConditionEnumDto {
  FreeCancellation = 'FREE_CANCELLATION',
  Guaranteed = 'GUARANTEED',
  NotRefundable = 'NOT_REFUNDABLE',
  Refundable = 'REFUNDABLE'
}

export type CancellationPolicyDto = {
  __typename?: 'CancellationPolicyDTO';
  bnplStatus: Maybe<BnplStatusEnumDto>;
  chargeType: Maybe<ChargeTypeEnumDto>;
  chargeValue: Maybe<Scalars['BigDecimal']['output']>;
  condition: Maybe<CancellationPolicyConditionEnumDto>;
  creditCardPolicy: Maybe<CreditCardPolicyEnumDto>;
  daysBefore: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  fullRefundableDays: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastInstalment: Maybe<LastInstalmentEnumDto>;
  maxInstalments: Maybe<Scalars['Int']['output']>;
  minInstalments: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  partialRefundableDays: Maybe<Scalars['Int']['output']>;
  partialRefundableValue: Maybe<Scalars['BigDecimal']['output']>;
  penaltyType: Maybe<PenaltyTypeEnumDto>;
  penaltyValue: Maybe<Scalars['BigDecimal']['output']>;
  showDescriptionOnWeb: Scalars['Boolean']['output'];
  travelInsurancePolicyId: Maybe<Scalars['Int']['output']>;
};

export type CancellationPolicyInitParametersResponseDto = {
  __typename?: 'CancellationPolicyInitParametersResponseDTO';
  bnpl: Scalars['Boolean']['output'];
  maxInstalment: Scalars['Int']['output'];
  minInstalment: Scalars['Int']['output'];
  nexi: Scalars['Boolean']['output'];
};

export type CardUrlDto = {
  __typename?: 'CardUrlDTO';
  /** Page to open in an iframe. It never contains the alias of the card: the server resolves it internally. Single use, do not store it */
  url: Scalars['String']['output'];
};

export type CashRegisterConfigurablePaymentDto = {
  __typename?: 'CashRegisterConfigurablePaymentDTO';
  description: Scalars['String']['output'];
  type: CashRegisterPaymentTypeEnumDto;
};

export type CashRegisterCreditNoteDto = {
  __typename?: 'CashRegisterCreditNoteDTO';
  closure: Scalars['String']['output'];
  date: Scalars['LocalDateTime']['output'];
  documentNumber: Scalars['String']['output'];
};

export type CashRegisterDto = {
  __typename?: 'CashRegisterDTO';
  address: Scalars['String']['output'];
  cashRegisterType: CashRegisterTypeDto;
  description: Scalars['String']['output'];
  doubleCopy: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoiceBlocks: Array<Scalars['String']['output']>;
  localAddress: Maybe<Scalars['String']['output']>;
  ownerCorporateDataId: Scalars['Int']['output'];
  port: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type CashRegisterInvoiceHolderDto = {
  __typename?: 'CashRegisterInvoiceHolderDTO';
  fiscalCode: Maybe<Scalars['String']['output']>;
  lines: Array<Scalars['String']['output']>;
  lotteryCode: Maybe<Scalars['String']['output']>;
};

export type CashRegisterItemDto = {
  __typename?: 'CashRegisterItemDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  department: Maybe<DepartmentDto>;
  description: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  type: CashRegisterItemTypeEnumDto;
};

export enum CashRegisterItemTypeEnumDto {
  Comment = 'COMMENT',
  Discount = 'DISCOUNT',
  Standard = 'STANDARD',
  Surcharge = 'SURCHARGE'
}

export enum CashRegisterManufacturerEnumDto {
  Custom = 'CUSTOM',
  Epson = 'EPSON',
  Italretail = 'ITALRETAIL',
  Rch = 'RCH'
}

export enum CashRegisterModeDto {
  FiscalExternal = 'FISCAL_EXTERNAL',
  FiscalReceipt = 'FISCAL_RECEIPT',
  None = 'NONE',
  NotFiscal = 'NOT_FISCAL'
}

export enum CashRegisterPaperSizeEnumDto {
  Mm57 = 'MM57',
  Mm80 = 'MM80'
}

export type CashRegisterPaymentDto = {
  __typename?: 'CashRegisterPaymentDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  description: Maybe<Scalars['String']['output']>;
  type: CashRegisterPaymentTypeEnumDto;
};

export enum CashRegisterPaymentTypeEnumDto {
  Card = 'CARD',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  /** @deprecated Deprecated */
  Electronic = 'ELECTRONIC',
  NotCollected = 'NOT_COLLECTED',
  NotCollectedInvoice = 'NOT_COLLECTED_INVOICE',
  PayDiscount = 'PAY_DISCOUNT',
  WireTransfer = 'WIRE_TRANSFER'
}

export type CashRegisterReceiptDto = {
  __typename?: 'CashRegisterReceiptDTO';
  invoiceHolder: Maybe<CashRegisterInvoiceHolderDto>;
  items: Maybe<Array<Maybe<CashRegisterItemDto>>>;
  payments: Maybe<Array<Maybe<CashRegisterPaymentDto>>>;
};

export type CashRegisterTypeDto = {
  __typename?: 'CashRegisterTypeDTO';
  manufacturer: Maybe<CashRegisterManufacturerEnumDto>;
  paperSize: Maybe<CashRegisterPaperSizeEnumDto>;
  type: Maybe<CashRegisterTypeEnumDto>;
};

export enum CashRegisterTypeEnumDto {
  Custom = 'CUSTOM',
  Custom_7 = 'CUSTOM_7',
  EpsonFp_81_90 = 'EPSON_FP_81_90',
  EpsonFp_81_90_7 = 'EPSON_FP_81_90_7',
  Italretail = 'ITALRETAIL',
  Italretail_7 = 'ITALRETAIL_7',
  Printf = 'PRINTF',
  Printf_7 = 'PRINTF_7'
}

export type ChangeRoomRequestDtoInput = {
  customPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceMode: PriceModeEnumDto;
  purchasedStayId: Scalars['Int']['input'];
  targetRoomId: Scalars['Int']['input'];
};

export type ChangeRoomResponseDto = {
  __typename?: 'ChangeRoomResponseDTO';
  newStayHavingLessBeds: Scalars['Boolean']['output'];
};

export type ChannelDto = {
  __typename?: 'ChannelDTO';
  area: Maybe<Scalars['String']['output']>;
  blue: Maybe<Scalars['Int']['output']>;
  code: Maybe<Scalars['String']['output']>;
  commission: Maybe<Scalars['BigDecimal']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  internalCode: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  red: Maybe<Scalars['Int']['output']>;
  segmentId: Maybe<Scalars['Int']['output']>;
  typeOfBusinessId: Maybe<Scalars['Int']['output']>;
};

export type ChannelPlannerDto = {
  __typename?: 'ChannelPlannerDTO';
  blue: Maybe<Scalars['Int']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export type ChargeRequestDtoInput = {
  /** Amount to charge. getCreditCards suggests it in suggestedChargeAmount and the user may change it before confirming */
  amount: Scalars['BigDecimal']['input'];
  /** Omit it to get the causalCharge of getOwnerCreditCard. An empty string is stored as such: a user who clears the field wants no causal */
  causal?: InputMaybe<Scalars['String']['input']>;
  /** Gateway cards only, DELAYED when left out. A card from a terminal has no charge type: the operation is one */
  chargeType?: InputMaybe<TransactionChargeTypeDto>;
  /** CreditCardRowDTO.id of the card to charge */
  creditCardId: Scalars['Int']['input'];
  /** Free text, none by default */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Gateway cards only, from getActiveOwnerPaymentGateways. Left out, the default gateway of the property is used. Ignored for a card from a terminal */
  ownerPaymentGatewayId?: InputMaybe<Scalars['Int']['input']>;
  /** The resource the window was opened from, the same one passed to getCreditCards. It also decides the invoice the charge is attached to: from an invoice it is attached to it, from a reservation there is none */
  resource: GetCreditCardsRequestDtoInput;
};

export enum ChargeTypeEnumDto {
  Fixed = 'FIXED',
  Nights = 'NIGHTS',
  Percentage = 'PERCENTAGE'
}

export type CheckAstatDailyGuestsInClosurePeriodRequestDtoInput = {
  closureBeginDate: Scalars['LocalDate']['input'];
  closureEndDate: Scalars['LocalDate']['input'];
  ownerIstatId: Scalars['Int']['input'];
};

export type CheckAstatDailyGuestsInClosurePeriodResponseDto = {
  __typename?: 'CheckAstatDailyGuestsInClosurePeriodResponseDTO';
  movements: Array<AstatDailyMovementProtoDto>;
  zeroArrivesAndPresences: Scalars['Boolean']['output'];
};

export type CheckSimpleInventoryRequestDtoInput = {
  /** begin date of the period to check availability for (beginDate and endDate can be equal) */
  beginDate: Scalars['LocalDate']['input'];
  /** end date of the period to check availability for (beginDate and endDate can be equal) */
  endDate: Scalars['LocalDate']['input'];
  /** (MANDATORY) stay IDs to check availability for */
  stayIds: Array<Scalars['Int']['input']>;
};

export type CheckTransferServiceRequestDtoInput = {
  serviceId: Scalars['Int']['input'];
  sourceReservationId: Scalars['Int']['input'];
  targetReservationId: Scalars['Int']['input'];
};

export type CheckTransferServiceResponseDto = {
  __typename?: 'CheckTransferServiceResponseDTO';
  currentReservationWithoutPurchasedStaysAfterTransfer: Scalars['Boolean']['output'];
  depositPresent: Scalars['Boolean']['output'];
  purchasedStayAndLinkedToPurchasedPacket: Scalars['Boolean']['output'];
};

export type CheckTransferServicesItemDto = {
  __typename?: 'CheckTransferServicesItemDTO';
  currentReservationWithoutPurchasedStaysAfterTransfer: Scalars['Boolean']['output'];
  depositPresent: Scalars['Boolean']['output'];
  error: Maybe<BulkItemErrorDto>;
  purchasedStayAndLinkedToPurchasedPacket: Scalars['Boolean']['output'];
  serviceId: Scalars['Int']['output'];
  transferable: Scalars['Boolean']['output'];
};

export type CheckTransferServicesRequestDtoInput = {
  serviceIds: Array<Scalars['Int']['input']>;
  sourceReservationId: Scalars['Int']['input'];
  targetReservationId: Scalars['Int']['input'];
};

export type CheckVatRequestDtoInput = {
  /** deprecated - use stateId instead */
  state?: InputMaybe<Scalars['String']['input']>;
  /** at least one between `stateId` or `vatCountryCode` is required */
  stateId?: InputMaybe<Scalars['Int']['input']>;
  vat: Scalars['String']['input'];
  /** at least one between `stateId` or `vatCountryCode` is required */
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
};

export type CheckVatResponseDto = {
  __typename?: 'CheckVatResponseDTO';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  corpName: Maybe<Scalars['String']['output']>;
  district: Maybe<Scalars['String']['output']>;
  districtId: Maybe<Scalars['Int']['output']>;
  /** deprecated because it is unused; when Vat number is invalid in request, the API will simply launch a specific exception */
  valid: Scalars['Boolean']['output'];
  zip: Maybe<Scalars['String']['output']>;
};

export type CityDto = {
  __typename?: 'CityDTO';
  cityId: Maybe<Scalars['String']['output']>;
  district: Maybe<DistrictDto>;
  districtId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  nameDE: Maybe<Scalars['String']['output']>;
  psId: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  validFrom: Maybe<Scalars['LocalDate']['output']>;
  validTo: Maybe<Scalars['LocalDate']['output']>;
};

export type CityTaxCheckInformationDto = {
  __typename?: 'CityTaxCheckInformationDTO';
  customerInfoWithoutInvoicedCityTax: Array<CustomerInfoWithoutInvoicedCityTaxDto>;
  uncoveredDaysForCityTaxDefinition: Array<Scalars['LocalDate']['output']>;
};

export type CityTaxExemptionDto = {
  __typename?: 'CityTaxExemptionDTO';
  beginDate: Maybe<Scalars['LocalDate']['output']>;
  beginNights: Maybe<Scalars['Int']['output']>;
  code: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  endDate: Maybe<Scalars['LocalDate']['output']>;
  endNights: Maybe<Scalars['Int']['output']>;
  freeGroupLeader: Scalars['Boolean']['output'];
  freeGroupMember: Scalars['Boolean']['output'];
  freeSameCity: Scalars['Boolean']['output'];
  fullExemption: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  maxAge: Maybe<Scalars['Int']['output']>;
  maxNightsInMonth: Maybe<Scalars['Int']['output']>;
  maxNightsInYear: Maybe<Scalars['Int']['output']>;
  minAge: Maybe<Scalars['Int']['output']>;
  multiplier: Maybe<Scalars['BigDecimal']['output']>;
  newAmount: Maybe<Scalars['BigDecimal']['output']>;
  ownerCityTaxes: Array<OwnerCityTaxDto>;
  ownerId: Scalars['Int']['output'];
};

export enum CityTaxVatTypeEnumDto {
  N_1 = 'N_1',
  N_2 = 'N_2',
  N_2_1 = 'N_2_1',
  N_2_2 = 'N_2_2',
  N_3 = 'N_3',
  N_3_1 = 'N_3_1',
  N_3_2 = 'N_3_2',
  N_3_3 = 'N_3_3',
  N_3_4 = 'N_3_4',
  N_3_5 = 'N_3_5',
  N_3_6 = 'N_3_6',
  N_4 = 'N_4',
  N_5 = 'N_5',
  N_6 = 'N_6',
  N_6_1 = 'N_6_1',
  N_6_2 = 'N_6_2',
  N_6_3 = 'N_6_3',
  N_6_4 = 'N_6_4',
  N_6_5 = 'N_6_5',
  N_6_6 = 'N_6_6',
  N_6_7 = 'N_6_7',
  N_6_8 = 'N_6_8',
  N_6_9 = 'N_6_9',
  N_7 = 'N_7'
}

export type CloseAllWebAvailabilitiesRequestDtoInput = {
  /** begin date of the range to close (inclusive) */
  beginDate: Scalars['LocalDate']['input'];
  /** end date of the range to close (inclusive) */
  endDate: Scalars['LocalDate']['input'];
};

export type CompanyDto = {
  __typename?: 'CompanyDTO';
  EInvoicingCode: Maybe<Scalars['String']['output']>;
  address: Maybe<Scalars['String']['output']>;
  blue: Maybe<Scalars['Int']['output']>;
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  corpName: Scalars['String']['output'];
  customerCode: Maybe<Scalars['String']['output']>;
  /** if present it is always > 0 */
  discount: Maybe<Scalars['BigDecimal']['output']>;
  district: Maybe<Scalars['String']['output']>;
  documentFolder: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoiceDefaultBuilding: Maybe<InvoiceDefaultBuildingDto>;
  invoiceType: Maybe<InvoiceDocumentTypeDto>;
  mail: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  password: Maybe<Scalars['String']['output']>;
  paymentTerms: Maybe<PaymentTermsDto>;
  pec: Maybe<Scalars['String']['output']>;
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  privacyAuth: Scalars['Boolean']['output'];
  publicAdministration: Scalars['Boolean']['output'];
  red: Maybe<Scalars['Int']['output']>;
  referringName: Maybe<Scalars['String']['output']>;
  referringSurname: Maybe<Scalars['String']['output']>;
  site: Maybe<Scalars['String']['output']>;
  /** deprecated - use `stateId` instead */
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type CompanyListPaginatedDto = {
  __typename?: 'CompanyListPaginatedDTO';
  companies: Array<CompanyDto>;
  pagination: PaginationDto;
};

export type CompanyPlannerDto = {
  __typename?: 'CompanyPlannerDTO';
  blue: Maybe<Scalars['Int']['output']>;
  corpName: Scalars['String']['output'];
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export type ConfirmTransactionRequestDtoInput = {
  /** Amount to collect. Never above maxConfirmAmount of that row, which already counts the top-ups; less is a partial collection */
  amount: Scalars['BigDecimal']['input'];
  /** Omit it to get the causalConfirm of getOwnerCreditCard, which is what the form prefills. An empty string is stored as such: a user who clears the field wants no causal */
  causal?: InputMaybe<Scalars['String']['input']>;
  /** Free text, none by default */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The resource the window was opened from, the same one passed to getCreditCards. It also decides the invoice the collection is attached to: from an invoice it is attached to it, from a reservation there is none */
  resource: GetCreditCardsRequestDtoInput;
  /** CreditCardTransactionRowDTO.id of the preauthorization to collect */
  transactionId: Scalars['Int']['input'];
};

export type CostAttributionDto = {
  __typename?: 'CostAttributionDTO';
  percentage: Scalars['BigDecimal']['output'];
  primaryCostId: Scalars['Int']['output'];
  secondaryCostId: Scalars['Int']['output'];
};

export type CostCenterDto = {
  __typename?: 'CostCenterDTO';
  costAttributions: Array<CostAttributionDto>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: CostCenterTypeDto;
};

export enum CostCenterTypeDto {
  PrimaryCost = 'PRIMARY_COST',
  SecondaryCost = 'SECONDARY_COST'
}

export type CreateCreditNoteRequestDtoInput = {
  amount: Scalars['BigDecimal']['input'];
  elementIdsToReopen: Array<Scalars['String']['input']>;
  includeCityTax: Scalars['Boolean']['input'];
  includeDeposit: Scalars['Boolean']['input'];
  invoiceId: Scalars['Int']['input'];
  issueDate: Scalars['LocalDate']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  payment2Amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  payment2Id?: InputMaybe<Scalars['Int']['input']>;
  paymentAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  resetPrice: Scalars['Boolean']['input'];
  vat: Scalars['BigDecimal']['input'];
};

export type CreateMasterInvoiceResponseDto = {
  __typename?: 'CreateMasterInvoiceResponseDTO';
  bolloRequired: Scalars['Boolean']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type CreateReservationDtoInput = {
  /** at least one of mainCustomerId, agencyId and companyId is required */
  agencyId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerId?: InputMaybe<Scalars['String']['input']>;
  /** at least one of mainCustomerId, agencyId and companyId is required */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  /** at least one of mainCustomerId, agencyId and companyId is required */
  mainCustomerId?: InputMaybe<Scalars['Int']['input']>;
  /** format: YYYY-MM-DD */
  optionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  otaId?: InputMaybe<Scalars['String']['input']>;
  purchasedStays: Array<CreateReservationPurchasedStayDtoInput>;
  resStatusId?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateReservationPurchasedStayDtoInput = {
  addedBed: Scalars['Int']['input'];
  addedBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed: Scalars['Int']['input'];
  addedJuniorBed2: Scalars['Int']['input'];
  addedJuniorBed2Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed3: Scalars['Int']['input'];
  addedJuniorBed3Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  agencyVoucher?: InputMaybe<Scalars['String']['input']>;
  allInclusive: Scalars['Boolean']['input'];
  /** check-in date - format: YYYY-MM-DD */
  beginDate: Scalars['LocalDate']['input'];
  breakfast: Scalars['Boolean']['input'];
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  cradle: Scalars['Int']['input'];
  cradleCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** if dayPrices are present, the record number must equal the number of nights and the sum of single day prices must be equal to the price field of purchasedStay */
  dayPrices?: InputMaybe<Array<InputMaybe<UpsertDayPriceDtoInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dinner: Scalars['Boolean']['input'];
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountFixed: Scalars['Boolean']['input'];
  divideBed: Scalars['Boolean']['input'];
  /** check-out date - format: YYYY-MM-DD */
  endDate: Scalars['LocalDate']['input'];
  housekeeperNotes?: InputMaybe<Scalars['String']['input']>;
  lunch: Scalars['Boolean']['input'];
  /** must be equal to the standard number of beds + all added bed, cradles included */
  numberOfGuests: Scalars['Int']['input'];
  originalStayId: Scalars['Int']['input'];
  /** useful to create and link a purchasedPacket to the purchasedStay */
  packetId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) if dayPrices are present, the sum of single day prices must be equal to the price field of purchasedStay */
  price: Scalars['BigDecimal']['input'];
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  priceLocked: Scalars['Boolean']['input'];
  /** always an item for each guest in the room */
  purchasedStayToCustomers: Array<UpsertPurchasedStayToCustomerDtoInput>;
  rackMessage?: InputMaybe<Scalars['String']['input']>;
  restaurantNotes?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  stayId: Scalars['Int']['input'];
};

export type CreateWizardInvoiceProductDtoInput = {
  price: Scalars['BigDecimal']['input'];
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreateWizardInvoiceRequestDtoInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  date: Scalars['LocalDate']['input'];
  documentType: InvoiceDocumentTypeDto;
  holder?: InputMaybe<UpsertInvoiceHolderDtoInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paid: Scalars['BigDecimal']['input'];
  /** (MANDATORY - if payment2Id is set) - the paid + payment2Amount must be equal or less than the total amount of all products */
  payment2Amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  payment2Id?: InputMaybe<Scalars['Int']['input']>;
  paymentDone: Scalars['Boolean']['input'];
  /** format: YYYY-MM-DD */
  paymentExpected?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (MANDATORY - if owner.paymentMandatoryOnInvoice) */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  products: Array<CreateWizardInvoiceProductDtoInput>;
};

export type CreateWizardInvoiceResponseDto = {
  __typename?: 'CreateWizardInvoiceResponseDTO';
  bolloRequired: Scalars['Boolean']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type CreditCardButtonStatesDto = {
  __typename?: 'CreditCardButtonStatesDTO';
  /** Charge an amount on the card */
  charge: Maybe<ButtonStateDto>;
  /** Verify the balance of a prepaid card */
  check: Maybe<ButtonStateDto>;
  /** Delete the card */
  delete: Maybe<ButtonStateDto>;
  /** Preauthorize an amount on the card, only from a reservation */
  preauthorize: Maybe<ButtonStateDto>;
  /** Refund an amount on the card */
  refund: Maybe<ButtonStateDto>;
  /** Show the PAN of the card */
  view: Maybe<ButtonStateDto>;
};

export enum CreditCardContextDto {
  /** Opened from a deleted reservation: goes with deletedReservationId */
  DeletedReservation = 'DELETED_RESERVATION',
  /** Opened from the first payment of an invoice: goes with invoiceId, and drives suggestedChargeAmount */
  InvoicePayment1 = 'INVOICE_PAYMENT1',
  /** Opened from the second payment of the same invoice: goes with invoiceId, and drives suggestedChargeAmount */
  InvoicePayment2 = 'INVOICE_PAYMENT2',
  /** Opened from a reservation: goes with reservationId */
  Reservation = 'RESERVATION'
}

export enum CreditCardImageTypeDto {
  CreditCard = 'CREDIT_CARD',
  CreditCardPreauthKo = 'CREDIT_CARD_PREAUTH_KO',
  CreditCardPreauthOk = 'CREDIT_CARD_PREAUTH_OK',
  CreditCardPrepaid = 'CREDIT_CARD_PREPAID',
  NoCreditCard = 'NO_CREDIT_CARD'
}

export enum CreditCardPolicyEnumDto {
  Charge = 'CHARGE',
  Guarantee = 'GUARANTEE',
  NoCc = 'NO_CC',
  Preauth = 'PREAUTH'
}

export type CreditCardRowDto = {
  __typename?: 'CreditCardRowDTO';
  buttonStates: Maybe<CreditCardButtonStatesDto>;
  /** True for a card dismissed by the retention policy. The row is shown as any other, with its actions disabled */
  deleted: Scalars['Boolean']['output'];
  /** Raw label of the provider, not a date */
  expireDate: Maybe<Scalars['String']['output']>;
  holder: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insertion: Maybe<Scalars['LocalDateTime']['output']>;
  /** Already masked by the server */
  pan: Maybe<Scalars['String']['output']>;
  prepaid: Scalars['Boolean']['output'];
  source: Maybe<TokenSourceDto>;
  /** Size of transactions, for the Transazioni column */
  transactionCount: Scalars['Int']['output'];
  /** Transactions of this card, already ordered by date: no second call is needed when a card is selected */
  transactions: Array<CreditCardTransactionRowDto>;
  /** Raw label of the provider, not a fixed set of values */
  type: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
  vccChargeLimit: Maybe<Scalars['BigDecimal']['output']>;
  vccValidFrom: Maybe<Scalars['LocalDate']['output']>;
  vccValidTo: Maybe<Scalars['LocalDate']['output']>;
  /** Only meaningful when the table shows the VCC columns */
  virtual: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCardTransactionButtonStatesDto = {
  __typename?: 'CreditCardTransactionButtonStatesDTO';
  /** Cancel the transaction, or release an open preauthorization. The amount of the form is editable only where amountEditable is true */
  cancel: Maybe<ButtonStateDto>;
  /** Collect an open preauthorization */
  confirm: Maybe<ButtonStateDto>;
  /** Charge a preauthorization that has already been closed */
  delayedChargeOnPreauth: Maybe<ButtonStateDto>;
  /** Raise the amount of an open preauthorization */
  topUp: Maybe<ButtonStateDto>;
};

export type CreditCardTransactionRowDto = {
  __typename?: 'CreditCardTransactionRowDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** False means the cancel form must show the amount as a read only label: the provider requires the cancel to carry the amount of the original transaction */
  amountEditable: Scalars['Boolean']['output'];
  buttonStates: Maybe<CreditCardTransactionButtonStatesDto>;
  causal: Maybe<Scalars['String']['output']>;
  chargeType: Maybe<TransactionChargeTypeDto>;
  currency: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['LocalDateTime']['output']>;
  expiration: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  /** Most that confirmTransaction accepts on this row, the hold plus its top-ups: what the collection form prefills, and its ceiling. Only a preauthorization carries it */
  maxConfirmAmount: Maybe<Scalars['BigDecimal']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  processorStatus: Maybe<Scalars['String']['output']>;
  /** Origin column: the description of the payment terminal for a card taken from a terminal, the description of the gateway otherwise. Empty when the terminal or the gateway cannot be resolved */
  sourceDescription: Maybe<Scalars['String']['output']>;
  /** Origin id column: the internal reference for a terminal, the gateway transaction id otherwise */
  sourceReference: Maybe<Scalars['String']['output']>;
  status: Maybe<TransactionStatusDto>;
  type: Maybe<TransactionTypeDto>;
  username: Maybe<Scalars['String']['output']>;
};

export type CustomerDto = {
  __typename?: 'CustomerDTO';
  EInvoicingCode: Maybe<Scalars['String']['output']>;
  /** the difference between the current date and the entered date must be >= 7 */
  birthDate: Maybe<Scalars['LocalDate']['output']>;
  birthDistrict: Maybe<Scalars['String']['output']>;
  birthPlace: Maybe<Scalars['String']['output']>;
  birthPlaceId: Maybe<Scalars['Int']['output']>;
  /** deprecated - use `birthStateId` instead */
  birthState: Maybe<Scalars['String']['output']>;
  birthStateId: Maybe<Scalars['Int']['output']>;
  creditCardId: Maybe<Scalars['Int']['output']>;
  customerCode: Maybe<Scalars['String']['output']>;
  customerData: CustomerDataDto;
  customerDataId: Maybe<Scalars['Int']['output']>;
  documentDeadlineDate: Maybe<Scalars['LocalDate']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  documentReleaseDate: Maybe<Scalars['LocalDate']['output']>;
  documentReleaser: Maybe<Scalars['String']['output']>;
  documentReleaserCityId: Maybe<Scalars['Int']['output']>;
  documentReleaserState: Scalars['Boolean']['output'];
  documentReleaserStateId: Maybe<Scalars['Int']['output']>;
  documentType: Maybe<Scalars['String']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** if set it must be 8 characters long */
  lotteryCode: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  multidbDocumentTypeId: Maybe<Scalars['Int']['output']>;
  /** if set it must not contain: #, &, $, £, %, <, > */
  name: Maybe<Scalars['String']['output']>;
  /** deprecated - use `nationalityId` instead */
  nationality: Maybe<Scalars['String']['output']>;
  nationalityId: Maybe<Scalars['Int']['output']>;
  password: Maybe<Scalars['String']['output']>;
  pec: Maybe<Scalars['String']['output']>;
  sex: Scalars['Boolean']['output'];
  /** deprecated - use `stateId` instead */
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  /** it must not contain: #, &, $, £, %, <, > */
  surname: Scalars['String']['output'];
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type CustomerDataDto = {
  __typename?: 'CustomerDataDTO';
  address: Maybe<Scalars['String']['output']>;
  blacklist: Scalars['Boolean']['output'];
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  cityTaxExemption: Maybe<CityTaxExemptionDto>;
  cityTaxExemptionId: Maybe<Scalars['Int']['output']>;
  clubMember: Scalars['Boolean']['output'];
  company: Maybe<CompanyDto>;
  companyId: Maybe<Scalars['Int']['output']>;
  /** if present it is always > 0 */
  discount: Maybe<Scalars['BigDecimal']['output']>;
  district: Maybe<Scalars['String']['output']>;
  doNotPreauthorize: Scalars['Boolean']['output'];
  documentFolder: Maybe<Scalars['String']['output']>;
  familyRepId: Maybe<Scalars['Int']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  interests: Array<ParameterValueDto>;
  lastStay: Maybe<Scalars['LocalDate']['output']>;
  lastStayEnd: Maybe<Scalars['LocalDate']['output']>;
  mail: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  numberplate: Maybe<Scalars['String']['output']>;
  privacyAuth: Scalars['Boolean']['output'];
  privacyAuth2: Scalars['Boolean']['output'];
  privacyAuth3: Scalars['Boolean']['output'];
  profession: Maybe<ParameterValueDto>;
  professionId: Maybe<Scalars['Int']['output']>;
  sendCheckInMail: Scalars['Boolean']['output'];
  sendCheckOutMail: Scalars['Boolean']['output'];
  telephone: Maybe<Scalars['String']['output']>;
  title: Maybe<ParameterValueDto>;
  titleId: Maybe<Scalars['Int']['output']>;
  transport: Maybe<ParameterValueDto>;
  transportId: Maybe<Scalars['Int']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type CustomerInfoWithoutInvoicedCityTaxDto = {
  __typename?: 'CustomerInfoWithoutInvoicedCityTaxDTO';
  checkInDate: Scalars['LocalDate']['output'];
  checkOutDate: Scalars['LocalDate']['output'];
  name: Maybe<Scalars['String']['output']>;
  reservationId: Scalars['Int']['output'];
  roomNumber: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type CustomerListPaginatedDto = {
  __typename?: 'CustomerListPaginatedDTO';
  customers: Array<CustomerDto>;
  pagination: PaginationDto;
};

export type CustomerPlannerDto = {
  __typename?: 'CustomerPlannerDTO';
  customerDataId: Scalars['Int']['output'];
  familyRepId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mobile: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
  telephone: Maybe<Scalars['String']['output']>;
};

export type DailyActivityDto = ServiceDto & {
  __typename?: 'DailyActivityDTO';
  beginDate: Scalars['LocalDate']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  dailyResource: DailyResourceDto;
  dailyResourceId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  endDate: Scalars['LocalDate']['output'];
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
};

export type DailyAllotmentValueDto = {
  __typename?: 'DailyAllotmentValueDTO';
  date: Scalars['LocalDate']['output'];
  value: Scalars['Int']['output'];
};

export type DailyResourceDto = ResourceDto & {
  __typename?: 'DailyResourceDTO';
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  category2Id: Maybe<Scalars['Int']['output']>;
  categoryId: Maybe<Scalars['Int']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  plannerDetailId: Maybe<Scalars['Int']['output']>;
  priceLists: Array<PriceListDto>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
};

export type DailyWebAvailabilityDto = {
  __typename?: 'DailyWebAvailabilityDTO';
  availableRooms: Maybe<Scalars['Int']['output']>;
  availableRoomsOta: Maybe<Scalars['Int']['output']>;
  date: Scalars['LocalDate']['output'];
  mode: WebAvailabilityModeEnumDto;
};

export type DailyWebAvailabilityInfoDtoInput = {
  availability?: InputMaybe<Scalars['Int']['input']>;
  availabilityOta?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['LocalDate']['input'];
  mode: WebAvailabilityUpdateModeEnumDto;
};

export type DamageDto = {
  __typename?: 'DamageDTO';
  assignedTo: Maybe<Scalars['String']['output']>;
  closedBy: Maybe<Scalars['String']['output']>;
  closureDate: Maybe<Scalars['LocalDate']['output']>;
  damageType: Maybe<ParameterValueDto>;
  damageTypeId: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['LocalDate']['output']>;
  description: Scalars['String']['output'];
  floor: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  insertedBy: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  reportedBy: Maybe<Scalars['String']['output']>;
  roomId: Maybe<Scalars['Int']['output']>;
};

export type DataGroupedByOwnerCorporateDataDto = {
  __typename?: 'DataGroupedByOwnerCorporateDataDTO';
  cashRegisterFiscalClosureAllowed: Scalars['Boolean']['output'];
  cashRegisters: Array<CashRegisterDto>;
  ownerCorporateDataId: Scalars['Int']['output'];
};

export enum DayDisplayedDto {
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}

export type DayPriceDto = {
  __typename?: 'DayPriceDTO';
  day: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['BigDecimal']['output'];
  purchasedStayId: Scalars['Int']['output'];
};

export type DayToInventoryDto = {
  __typename?: 'DayToInventoryDTO';
  date: Scalars['LocalDate']['output'];
  inventory: Scalars['Int']['output'];
};

export type DayToPriceDto = {
  __typename?: 'DayToPriceDTO';
  date: Scalars['LocalDate']['output'];
  price: Scalars['BigDecimal']['output'];
};

export type DayToPriceDtoInput = {
  date: Scalars['LocalDate']['input'];
  price: Scalars['BigDecimal']['input'];
};

export type DayToSoldRoomsDto = {
  __typename?: 'DayToSoldRoomsDTO';
  date: Scalars['LocalDate']['output'];
  soldRooms: Scalars['Int']['output'];
};

export enum DefaultVatChargeabilityEnumDto {
  Deferred = 'DEFERRED',
  Immediate = 'IMMEDIATE',
  SplitPayment = 'SPLIT_PAYMENT'
}

export type DepartmentDto = {
  __typename?: 'DepartmentDTO';
  atecoCode: Maybe<AtecoCodeDto>;
  atecoCodeId: Maybe<Scalars['Int']['output']>;
  cashRegisterCode: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  sellGoods: Scalars['Boolean']['output'];
  vatRate: VatRateDto;
  vatRateId: Scalars['Int']['output'];
};

export type DepositDto = {
  __typename?: 'DepositDTO';
  amount: Scalars['BigDecimal']['output'];
  block: Maybe<Scalars['String']['output']>;
  date: Scalars['LocalDate']['output'];
  depositInvoiceId: Maybe<Scalars['Int']['output']>;
  depositUseId: Maybe<Scalars['Int']['output']>;
  holderId: Maybe<Scalars['Int']['output']>;
  /** deprecated */
  holderType: Maybe<InvoiceHolderTypeDto>;
  id: Scalars['Int']['output'];
  ownerCorporateDataId: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['Int']['output'];
  payment: Maybe<ParameterValueDto>;
  paymentId: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export enum DisabledReasonDto {
  /** The card was dismissed by the retention policy: the row is still listed, but the actions that use the token are blocked, and the user cannot recover it. Top up and delayed charge on a closed preauthorization never carry this reason: the desktop leaves them available on a deleted card and the server replicates it */
  CardDeleted = 'CARD_DELETED',
  /** The card cannot be deleted because it already has transactions, which must stay traceable */
  CardHasTransactions = 'CARD_HAS_TRANSACTIONS',
  /** The structure has no active payment gateway. Fixed in Dati Struttura, Carte e pagamenti, not in this window */
  NoGateway = 'NO_GATEWAY',
  /** Charging needs an invoice: the window was opened from a reservation and the structure does not allow charging without one */
  NoInvoice = 'NO_INVOICE',
  /** A card is always acquired for a reservation, and the resource the window was opened from has none: a deleted reservation, or an invoice whose elements do not come from any reservation */
  NoReservation = 'NO_RESERVATION',
  /** The action runs only through a physical payment terminal, and either no terminal is active or the terminal behind this card or transaction does not support it. Refund, top up and charge on a closed preauthorization are terminal only */
  NoTerminal = 'NO_TERMINAL',
  /** The tokenizer of this card does not offer the operation: Complior can show the PAN and verify a prepaid card, Planet and ZPAY cannot. It depends on the card, not on the configuration */
  TokenizerNotSupported = 'TOKENIZER_NOT_SUPPORTED',
  /** The preauthorization has already been captured or released: it cannot be collected, cancelled or topped up again */
  TransactionCompletedOrCanceled = 'TRANSACTION_COMPLETED_OR_CANCELED',
  /** The opposite case: charging a closed preauthorization needs it captured or cancelled first, and this one is still open */
  TransactionNotClosed = 'TRANSACTION_NOT_CLOSED'
}

export enum DisplayLanguageDto {
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Italian = 'ITALIAN',
  Spanish = 'SPANISH'
}

export type DistrictDto = {
  __typename?: 'DistrictDTO';
  code: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  fullNameDE: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  shortName: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
};

export type DividePurchasedStayRequestDtoInput = {
  /** must be between beginDate and endDate of the PurchasedStay extremes excluded */
  divideDate: Scalars['LocalDate']['input'];
  /** Set both firstPrice and secondPrice to indicate manual prices. They must be greater than zero. */
  firstPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  purchasedStayId: Scalars['Int']['input'];
  /** Set both firstPrice and secondPrice to indicate manual prices. They must be greater than zero. */
  secondPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type DocumentTypeDto = {
  __typename?: 'DocumentTypeDTO';
  id: Scalars['Int']['output'];
  nameDE: Maybe<Scalars['String']['output']>;
  nameEN: Maybe<Scalars['String']['output']>;
  nameES: Maybe<Scalars['String']['output']>;
  nameFR: Maybe<Scalars['String']['output']>;
  nameIT: Maybe<Scalars['String']['output']>;
  psId: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  visibleInCheckInOnline: Maybe<Scalars['Boolean']['output']>;
};

export enum EInvoiceManagerProviderEnumDto {
  DigitalHubZucchetti = 'DIGITAL_HUB_ZUCCHETTI',
  DocEasy = 'DOC_EASY',
  FattureInCloud = 'FATTURE_IN_CLOUD',
  Systems = 'SYSTEMS'
}

export enum EInvoiceStatusEnumDto {
  AccettataCommittente = 'ACCETTATA_COMMITTENTE',
  Archivio = 'ARCHIVIO',
  Attesa = 'ATTESA',
  ConsegnatoDestinatario = 'CONSEGNATO_DESTINATARIO',
  DaInviare = 'DA_INVIARE',
  DecorrenzaTermini = 'DECORRENZA_TERMINI',
  ImpossibileRecapitare = 'IMPOSSIBILE_RECAPITARE',
  InviataCommittenteEMail = 'INVIATA_COMMITTENTE_E_MAIL',
  InviatoSdi = 'INVIATO_SDI',
  MancataConsegna = 'MANCATA_CONSEGNA',
  RifiutataCommittente = 'RIFIUTATA_COMMITTENTE',
  ScartoSdi = 'SCARTO_SDI',
  Sconosciuto = 'SCONOSCIUTO'
}

export enum EInvoicingModeEnumDto {
  AutoSend = 'AUTO_SEND',
  Export = 'EXPORT',
  ManualSend = 'MANUAL_SEND',
  None = 'NONE'
}

export enum EditModeEnumDto {
  Editable = 'EDITABLE',
  NotEditable = 'NOT_EDITABLE'
}

export type ElectronicInvoiceDataDto = {
  __typename?: 'ElectronicInvoiceDataDTO';
  eInvoiceSendTimestamp: Maybe<Scalars['LocalDateTime']['output']>;
  eInvoiceStatus: Maybe<EInvoiceStatusEnumDto>;
  invoice: InvoiceDto;
  invoiceId: Scalars['Int']['output'];
  resourceValidationResults: Array<ResourceValidationResultDto>;
  xsdValidationError: Maybe<Scalars['String']['output']>;
};

export enum ElectronicInvoiceDataOrderByEnumDto {
  Amount = 'AMOUNT',
  Date = 'DATE',
  Id = 'ID',
  Progressive = 'PROGRESSIVE'
}

export type ElementDto = {
  __typename?: 'ElementDTO';
  amount: Scalars['BigDecimal']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  quantity: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type FindInvoicesByElementOrCityTaxServiceIdRequestDtoInput = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  elementOrCityTaxServiceId: Scalars['Int']['input'];
  includeCreditNotes: Scalars['Boolean']['input'];
  isPurchasedStay: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export enum FiscalSystemEnumDto {
  Agriculture = 'AGRICULTURE',
  Farmhouse = 'FARMHOUSE',
  Flat = 'FLAT',
  Ordinary = 'ORDINARY',
  Other = 'OTHER',
  Tourism = 'TOURISM'
}

export type GeneratedDayPriceDto = {
  __typename?: 'GeneratedDayPriceDTO';
  day: Scalars['Int']['output'];
  id: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  purchasedStayId: Maybe<Scalars['Int']['output']>;
};

export type GeneratedInvoiceDto = {
  __typename?: 'GeneratedInvoiceDTO';
  amount: Scalars['BigDecimal']['output'];
  block: Maybe<Scalars['String']['output']>;
  cityTax: Maybe<Scalars['BigDecimal']['output']>;
  /** Flag that defines if it is a credit note */
  creditNote: Scalars['Boolean']['output'];
  /** Invoice associated with this credit note */
  creditNoteInvoiceId: Maybe<Scalars['Int']['output']>;
  /** VAT applied if we have a credit note (attention: the VAT is intended to be applied to the "amount" field) */
  creditNoteVat: Maybe<Scalars['BigDecimal']['output']>;
  date: Scalars['LocalDate']['output'];
  /** Deposit coming from the Reservations that compose this Invoice */
  deposit: Scalars['BigDecimal']['output'];
  /** Flag that defines if it is a deposit invoice (a deposit invoice is linked to a Reservation) */
  depositInvoice: Scalars['Boolean']['output'];
  /** Department id for a deposit Invoice */
  depositInvoiceDepartmentId: Maybe<Scalars['Int']['output']>;
  /** VAT type if the VAT is zero in a deposit Invoice */
  depositInvoiceNaturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  /** Reference to regulations if the VAT is zero in a deposit Invoice */
  depositInvoiceReferenceOnZeroVat: Maybe<Scalars['String']['output']>;
  /** Deprecated - use `depositInvoiceNaturaTypeOnZeroVat` instead */
  depositInvoiceTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  /** VAT applied if we have a deposit Invoice (attention: the VAT is intended to be applied to the "amount" field) */
  depositInvoiceVat: Maybe<Scalars['BigDecimal']['output']>;
  documentType: InvoiceDocumentTypeDto;
  holder: Maybe<InvoiceHolderDto>;
  /** This enum substitutes old field "showExtra". Value indicating how to show extras on Invoice */
  invoiceExtraDisplayMode: Maybe<InvoiceExtraDisplayModeDto>;
  invoicePurchasedProducts: Array<GeneratedInvoiceToPurchasedProductDto>;
  invoicePurchasedStays: Array<GeneratedInvoiceToPurchasedStayDto>;
  /** This enum substitutes old field "showRooms". Value indicating how to show Rooms on Invoice */
  invoiceRoomDisplayMode: Maybe<InvoiceRoomDisplayModeDto>;
  /** Type of invoice (at the moment used for T17, T18, T19 values of Italian e-invoicing) */
  invoiceType: Maybe<Scalars['String']['output']>;
  invoicedCityTaxes: Array<GeneratedInvoicedCityTaxDto>;
  invoicedDeposit: Maybe<DepositDto>;
  invoicedDepositId: Maybe<Scalars['Int']['output']>;
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  linkedDeposits: Array<GeneratedInvoiceToDepositDto>;
  /** Flag that defines if it is a master invoice (a master invoice has n receipts "not to pay" linked) */
  masterInvoice: Scalars['Boolean']['output'];
  masterInvoiceId: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  ownerCorporateDataId: Scalars['Int']['output'];
  /** Part of the Invoice that has been paid the same day the invoice has been created */
  paid: Scalars['BigDecimal']['output'];
  partialPayments: Array<GeneratedPartialPaymentDto>;
  payment2Amount: Maybe<Scalars['BigDecimal']['output']>;
  payment2Id: Maybe<Scalars['Int']['output']>;
  paymentCityTaxId: Maybe<Scalars['Int']['output']>;
  paymentEffective: Maybe<Scalars['LocalDate']['output']>;
  paymentEffectiveUsername: Maybe<Scalars['String']['output']>;
  paymentExpected: Maybe<Scalars['LocalDate']['output']>;
  paymentId: Maybe<Scalars['Int']['output']>;
  progressive: Maybe<Scalars['Int']['output']>;
  /** Flag that defines if this invoice is a self Invoice */
  selfInvoice: Scalars['Boolean']['output'];
  /** VAT type if the VAT is zero in a self Invoice */
  selfInvoiceNaturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  /** Reference to regulations if the VAT is zero in a self Invoice */
  selfInvoiceReferenceOnZeroVat: Maybe<Scalars['String']['output']>;
  selfInvoiceSellerId: Maybe<Scalars['Int']['output']>;
  /** Deprecated - use `selfInvoiceNaturaTypeOnZeroVat` instead */
  selfInvoiceTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  /** VAT applied if we have a self Invoice (attention: the VAT is intended to be applied to the "amount" field) */
  selfInvoiceVat: Maybe<Scalars['BigDecimal']['output']>;
  /** Flag that defines if customers must be shown */
  showCustomers: Scalars['Boolean']['output'];
  /** deprecated - use invoiceExtraDisplayMode instead. Value indicating how to show extra on Invoice */
  showExtra: Maybe<Scalars['Int']['output']>;
  /** Flag that defines if reservation id must be shown */
  showId: Scalars['Boolean']['output'];
  /** deprecated - use invoiceRoomDisplayMode instead. Value indicating how to show Rooms on Invoice */
  showRooms: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
  /** Flag that defines this invoice/receipt has been generated with a wizard */
  wizardInvoice: Scalars['Boolean']['output'];
};

export type GeneratedInvoiceToDepositDto = {
  __typename?: 'GeneratedInvoiceToDepositDTO';
  amount: Scalars['BigDecimal']['output'];
  deposit: DepositDto;
  depositId: Scalars['Int']['output'];
};

export type GeneratedInvoiceToPurchasedProductDto = {
  __typename?: 'GeneratedInvoiceToPurchasedProductDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  naturaTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  originalBeginDate: Maybe<Scalars['LocalDate']['output']>;
  originalDescription: Maybe<Scalars['String']['output']>;
  originalEndDate: Maybe<Scalars['LocalDate']['output']>;
  originalQuantity: Maybe<Scalars['Int']['output']>;
  originalResourceId: Maybe<Scalars['Int']['output']>;
  partiallyInvoiced: Scalars['Boolean']['output'];
  purchasedProduct: PurchasedProductDto;
  purchasedProductId: Scalars['Int']['output'];
  referenceOnZeroVat: Maybe<Scalars['String']['output']>;
  typeOnZeroVat: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type GeneratedInvoiceToPurchasedStayDto = {
  __typename?: 'GeneratedInvoiceToPurchasedStayDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  naturaTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  originalBeginDate: Maybe<Scalars['LocalDate']['output']>;
  originalDescription: Maybe<Scalars['String']['output']>;
  originalEndDate: Maybe<Scalars['LocalDate']['output']>;
  originalQuantity: Maybe<Scalars['Int']['output']>;
  originalResourceId: Maybe<Scalars['Int']['output']>;
  partiallyInvoiced: Scalars['Boolean']['output'];
  purchasedStay: PurchasedStayDto;
  purchasedStayId: Scalars['Int']['output'];
  referenceOnZeroVat: Maybe<Scalars['String']['output']>;
  typeOnZeroVat: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type GeneratedInvoicedCityTaxDto = {
  __typename?: 'GeneratedInvoicedCityTaxDTO';
  amount: Scalars['BigDecimal']['output'];
  /** Begin validity */
  beginDate: Scalars['LocalDate']['output'];
  /** TRACE FIELD: Begin number of nights to apply the tax */
  beginNights: Maybe<Scalars['Int']['output']>;
  /** Exemption linked to the CityTax */
  cityTaxExemption: Maybe<CityTaxExemptionDto>;
  /** TRACE FIELD: CityTaxExemption description */
  cityTaxExemptionDescription: Maybe<Scalars['String']['output']>;
  cityTaxExemptionId: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Code of this exemption, useful for export */
  code: Maybe<Scalars['String']['output']>;
  /** Customer linked to the CityTax */
  customer: Maybe<CustomerDto>;
  customerId: Maybe<Scalars['Int']['output']>;
  /** End validity */
  endDate: Scalars['LocalDate']['output'];
  /** TRACE FIELD: End number of nights to apply the tax */
  endNights: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Flag that indicates if a Group leader is free from tax */
  freeGroupLeader: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a Group member is free from tax */
  freeGroupMember: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a Customer resident in the same city is free */
  freeSameCity: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a the exemption is full (the Customer pays zero) */
  fullExemption: Scalars['Boolean']['output'];
  /** Id of invoice linked to the CityTax */
  invoiceId: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max age to apply the tax */
  maxAge: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max number of nights in a month to apply the tax */
  maxNightsInMonth: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max number of nights in a year to apply the tax */
  maxNightsInYear: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Min age to apply the tax */
  minAge: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Multiplier for the base city tax amount. If null, the exemption is complete */
  multiplier: Maybe<Scalars['BigDecimal']['output']>;
  /** TRACE FIELD: New amount for the city tax amount. If null, the exemption is complete */
  newAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** OwnerCityTax linked to the CityTax */
  ownerCityTax: Maybe<OwnerCityTaxDto>;
  /** TRACE FIELD: OwnerCityTax amount */
  ownerCityTaxAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** TRACE FIELD: OwnerCityTax amountFixed */
  ownerCityTaxAmountFixed: Scalars['Boolean']['output'];
  /** TRACE FIELD: OwnerCityTax description */
  ownerCityTaxDescription: Maybe<Scalars['String']['output']>;
  ownerCityTaxId: Maybe<Scalars['Int']['output']>;
  /** PurchasedStay linked to this CityTax */
  purchasedStay: Maybe<PurchasedStayDto>;
  purchasedStayId: Maybe<Scalars['Int']['output']>;
  /** PurchasedStayToCustomer linked to this CityTax */
  purchasedStayToCustomer: Maybe<PurchasedStayToCustomerDto>;
  purchasedStayToCustomerId: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type GeneratedPartialPaymentDto = {
  __typename?: 'GeneratedPartialPaymentDTO';
  amount: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  notes: Maybe<Scalars['String']['output']>;
  paymentId: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type GetAccountingMovementReportGenerationParametersResponseDto = {
  __typename?: 'GetAccountingMovementReportGenerationParametersResponseDTO';
  allUsersFilterAllowed: Scalars['Boolean']['output'];
  filterableUsers: Array<IdpUserInfoDto>;
  maxReportDays: Scalars['Int']['output'];
  types: Array<AccountingMovementReportTypeDto>;
  visibilityPastDaysLimit: Maybe<Scalars['Int']['output']>;
};

export type GetAccountingReportGenerationParametersResponseDto = {
  __typename?: 'GetAccountingReportGenerationParametersResponseDTO';
  allUsersFilterAllowed: Scalars['Boolean']['output'];
  filterableUsers: Array<IdpUserInfoDto>;
  maxReportDays: Scalars['Int']['output'];
  visibilityPastDaysLimit: Maybe<Scalars['Int']['output']>;
};

export type GetAstatDailyClosureDayRequestDtoInput = {
  ownerIstatId: Scalars['Int']['input'];
  referenceDate: Scalars['LocalDate']['input'];
};

export type GetAstatDailyClosureDayResponseDto = {
  __typename?: 'GetAstatDailyClosureDayResponseDTO';
  astatDailyClosureDay: Maybe<AstatDailyClosureDayDto>;
};

export type GetAstatDailyLocalTaxInfoRequestDtoInput = {
  month: Scalars['Int']['input'];
  ownerIstatId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GetCityTaxCheckInformationRequestDtoInput = {
  istatCustomerIdsToInclude: Array<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  ownerIstatId: Scalars['Int']['input'];
  referenceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCreditCardsRequestDtoInput = {
  context: CreditCardContextDto;
  /** Mutually exclusive with reservationId and invoiceId */
  deletedReservationId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutually exclusive with reservationId and deletedReservationId */
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutually exclusive with invoiceId and deletedReservationId */
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCreditCardsResponseDto = {
  __typename?: 'GetCreditCardsResponseDTO';
  /** State of the section button Add card, which shows even when there is no card at all. Only source for the state of that button: it currently mirrors the addCards flag of getOwnerCreditCard, but do not rebuild it from that flag, so that a new condition can be added server side alone */
  addCard: Maybe<ButtonStateDto>;
  /** Ordered by insertion date, deleted cards included */
  rows: Array<CreditCardRowDto>;
  /** Amount to prefill the charge and refund forms with: the payment the window was opened from, zero outside the two invoice contexts */
  suggestedChargeAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Amount to prefill the preauthorization form with. Zero outside the RESERVATION context, where the action is not available */
  suggestedPreauthAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** True when at least one card of the list is virtual: the two VCC columns are shown for every row or for none */
  virtualCardPresent: Scalars['Boolean']['output'];
};

export type GetDailyAllotmentValuesRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  channelId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['LocalDate']['input'];
  stayId?: InputMaybe<Scalars['Int']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetDailyAllotmentValuesResponseDto = {
  __typename?: 'GetDailyAllotmentValuesResponseDTO';
  dailyAllotmentValues: Array<DailyAllotmentValueDto>;
};

export type GetDailyWebAvailabilitiesRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  stayIds: Array<Scalars['Int']['input']>;
};

export type GetDailyWebAvailabilitiesResponseDto = {
  __typename?: 'GetDailyWebAvailabilitiesResponseDTO';
  stayDailyAvailabilities: Array<StayDailyWebAvailabilityDto>;
};

export type GetFiscalClosureParametersResponseDto = {
  __typename?: 'GetFiscalClosureParametersResponseDTO';
  dataGroupedByOwnerCorporateData: Array<DataGroupedByOwnerCorporateDataDto>;
  departments: Array<DepartmentDto>;
};

export type GetIstatCustomerRequestDtoInput = {
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  ownerIstatId: Scalars['Int']['input'];
  referenceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetNaturaTypesRequestDtoInput = {
  invoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type GetNotIncludedDepositsRequestDtoInput = {
  includedReservationIds: Array<Scalars['Int']['input']>;
  invoiceHolderId: Scalars['Int']['input'];
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  linkedDeposits: Array<UpsertInvoiceToDepositDtoInput>;
  ownerCorporateDataId: Scalars['Int']['input'];
};

export type GetRoomInStillOutReportGenerationParametersResponseDto = {
  __typename?: 'GetRoomInStillOutReportGenerationParametersResponseDTO';
  maxReportDays: Scalars['Int']['output'];
  noteDisplayModes: Array<RoomInStillOutReportNoteDisplayModeEnumDto>;
  orderByFields: Array<RoomInStillOutReportOrderByEnumDto>;
  priceDisplayModes: Array<RoomInStillOutReportPriceDisplayModeEnumDto>;
  types: Array<RoomInStillOutReportTypeDto>;
};

export type GetRoomPrepareReportGenerationParametersResponseDto = {
  __typename?: 'GetRoomPrepareReportGenerationParametersResponseDTO';
  maxReportDays: Scalars['Int']['output'];
  noteDisplayModes: Array<RoomPrepareReportNoteDisplayModeEnumDto>;
  types: Array<RoomPrepareReportTypeDto>;
};

export type GetSellReportGenerationParametersResponseDto = {
  __typename?: 'GetSellReportGenerationParametersResponseDTO';
  maxReportDays: Scalars['Int']['output'];
  /** This list contains dynamic infos about stays used by some reports. Some reports use all available stays (real or not, depending on the report itself) but if there are too many stays configured (typically more than 9), the user may be asked to select a subset of stays */
  staysSelection: Array<StaysSelectionDto>;
  types: Array<SellReportTypeDto>;
};

export type GetServiceTransferInfoRequestDtoInput = {
  serviceId: Scalars['Int']['input'];
  targetReservationId: Scalars['Int']['input'];
};

export type GetServiceTransferInfoResponseDto = {
  __typename?: 'GetServiceTransferInfoResponseDTO';
  currentReservationWithoutPurchasedStaysAfterTransfer: Scalars['Boolean']['output'];
  depositPresent: Scalars['Boolean']['output'];
  depositTotal: Maybe<Scalars['BigDecimal']['output']>;
  purchasedStayAndLinkedToPurchasedPacket: Scalars['Boolean']['output'];
};

export type GetSoldRoomsInOptionRequestDtoInput = {
  /** begin date of the period to check sold rooms for (beginDate and endDate can be equal) */
  beginDate: Scalars['LocalDate']['input'];
  /** end date of the period to check sold rooms for (beginDate and endDate can be equal) */
  endDate: Scalars['LocalDate']['input'];
  /** (MANDATORY) stay IDs to check sold rooms for */
  stayIds: Array<Scalars['Int']['input']>;
};

export type GridPricesRevenueValuesDto = {
  __typename?: 'GridPricesRevenueValuesDTO';
  adr: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  revpar: Scalars['BigDecimal']['output'];
  toc: Scalars['BigDecimal']['output'];
};

export type GroupDto = {
  __typename?: 'GroupDTO';
  description: Scalars['String']['output'];
  discount: Maybe<Scalars['BigDecimal']['output']>;
  endDate: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  insertionDate: Maybe<Scalars['LocalDate']['output']>;
  leader: Maybe<CustomerDto>;
  leaderId: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
};

export type GroupPlannerDto = {
  __typename?: 'GroupPlannerDTO';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leaderId: Maybe<Scalars['Int']['output']>;
};

export type GuestCardProviderDto = {
  __typename?: 'GuestCardProviderDTO';
  guestCardCredentialsCheckAvailable: Scalars['Boolean']['output'];
  guestCardDefaultTypeUsed: Scalars['Boolean']['output'];
  guestCardHotelCodeUsed: Scalars['Boolean']['output'];
  guestCardPasswordUsed: Scalars['Boolean']['output'];
  guestCardTypeListToRetrieve: Scalars['Boolean']['output'];
  guestCardUsernameUsed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  type: GuestCardProviderEnum;
};

export enum GuestCardProviderEnum {
  AltoAdigeGuestCard = 'ALTO_ADIGE_GUEST_CARD',
  TrentinoGuestCard = 'TRENTINO_GUEST_CARD'
}

export type HealthDto = {
  __typename?: 'HealthDTO';
  UP: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type HoursActivityDto = ServiceDto & {
  __typename?: 'HoursActivityDTO';
  beginDate: Scalars['LocalDate']['output'];
  beginHour: Scalars['LocalTime']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['LocalDate']['output']>;
  endHour: Maybe<Scalars['LocalTime']['output']>;
  hoursOperator: Maybe<HoursOperatorDto>;
  hoursOperatorId: Maybe<Scalars['Int']['output']>;
  hoursResource: HoursResourceDto;
  hoursResourceId: Scalars['Int']['output'];
  hoursSlot: HoursSlotDto;
  hoursSlotId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type HoursOperatorDto = {
  __typename?: 'HoursOperatorDTO';
  available: Scalars['Boolean']['output'];
  blue: Maybe<Scalars['Int']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export type HoursResourceDto = ResourceDto & {
  __typename?: 'HoursResourceDTO';
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  category2Id: Maybe<Scalars['Int']['output']>;
  categoryId: Maybe<Scalars['Int']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  divisible: Scalars['Boolean']['output'];
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  minutesToSell: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  openingHours: Array<OpeningHourDto>;
  ownerId: Scalars['Int']['output'];
  priceLists: Array<PriceListDto>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
};

export type HoursSlotDto = {
  __typename?: 'HoursSlotDTO';
  hoursResources: Array<HoursResourceDto>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  plannerDetailId: Maybe<Scalars['Int']['output']>;
};

export enum HousekeepingStatusDto {
  Clean = 'CLEAN',
  Dirty = 'DIRTY',
  Inspected = 'INSPECTED'
}

export type IdpUserInfoDto = {
  __typename?: 'IdpUserInfoDTO';
  /** deprecated - use `fullName` instead */
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** deprecated - use `fullName` instead */
  lastName: Maybe<Scalars['String']['output']>;
  mail: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type IncludedResourceDto = {
  __typename?: 'IncludedResourceDTO';
  id: Scalars['Int']['output'];
  inclusionMode: InclusionModeDto;
  perPerson: Scalars['Boolean']['output'];
  priceListId: Scalars['Int']['output'];
  resource: ResourceReferenceDto;
};

export enum InclusionModeDto {
  /** Hidden, included price: the Resource is hidden. Its price is included in the sell price */
  HiddenIncludedPrice = 'HIDDEN_INCLUDED_PRICE',
  /** Public, added price: the Resource is visible. Its price is added to the base price */
  PublicAddedPrice = 'PUBLIC_ADDED_PRICE',
  /** Public, included price: the Resource is visible. Its price is included in the sell price */
  PublicIncludedPrice = 'PUBLIC_INCLUDED_PRICE'
}

export type InvoiceBlockRulesDto = {
  __typename?: 'InvoiceBlockRulesDTO';
  blockOptional: Scalars['Boolean']['output'];
  blocks: Array<Scalars['String']['output']>;
};

export enum InvoiceBuildElementsDto {
  All = 'ALL',
  CityTax = 'CITY_TAX',
  Extra = 'EXTRA',
  ExtraAndCityTax = 'EXTRA_AND_CITY_TAX',
  GroupAll = 'GROUP_ALL',
  GroupAllCityTax = 'GROUP_ALL_CITY_TAX',
  GroupCityTax = 'GROUP_CITY_TAX',
  GroupExtra = 'GROUP_EXTRA',
  GroupExtraCityTax = 'GROUP_EXTRA_CITY_TAX',
  GroupRoom = 'GROUP_ROOM',
  GroupRoomCityTax = 'GROUP_ROOM_CITY_TAX',
  None = 'NONE',
  Room = 'ROOM',
  RoomAndCityTax = 'ROOM_AND_CITY_TAX',
  RoomAndExtra = 'ROOM_AND_EXTRA',
  RoomAndSubaccount = 'ROOM_AND_SUBACCOUNT',
  Subaccount = 'SUBACCOUNT'
}

export type InvoiceCheckProgressiveRequestDtoInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['LocalDate']['input'];
  documentType: InvoiceDocumentTypeDto;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  ownerCorporateDataId: Scalars['Int']['input'];
  progressive: Scalars['Int']['input'];
};

export type InvoiceDto = {
  __typename?: 'InvoiceDTO';
  amount: Scalars['BigDecimal']['output'];
  block: Maybe<Scalars['String']['output']>;
  cityTax: Maybe<Scalars['BigDecimal']['output']>;
  /** Flag that defines if it is a credit note */
  creditNote: Scalars['Boolean']['output'];
  /** Invoice associated with this credit note */
  creditNoteInvoiceId: Maybe<Scalars['Int']['output']>;
  /** VAT applied if we have a credit note (attention: the VAT is intended to be applied to the "amount" field) */
  creditNoteVat: Maybe<Scalars['BigDecimal']['output']>;
  date: Maybe<Scalars['LocalDate']['output']>;
  /** Deposit coming from the Reservations that compose this Invoice */
  deposit: Scalars['BigDecimal']['output'];
  /** Flag that defines if it is a deposit invoice (a deposit invoice is linked to a Reservation) */
  depositInvoice: Scalars['Boolean']['output'];
  /** Department id for a deposit Invoice */
  depositInvoiceDepartmentId: Maybe<Scalars['Int']['output']>;
  /** VAT type if the VAT is zero in a deposit Invoice */
  depositInvoiceNaturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  /** Reference to regulations if the VAT is zero in a deposit Invoice */
  depositInvoiceReferenceOnZeroVat: Maybe<Scalars['String']['output']>;
  /** Deprecated - use `depositInvoiceNaturaTypeOnZeroVat` instead */
  depositInvoiceTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  /** VAT applied if we have a deposit Invoice (attention: the VAT is intended to be applied to the "amount" field) */
  depositInvoiceVat: Maybe<Scalars['BigDecimal']['output']>;
  documentType: InvoiceDocumentTypeDto;
  holder: Maybe<InvoiceHolderDto>;
  id: Scalars['Int']['output'];
  /** This enum substitutes old field "showExtra". Value indicating how to show extras on Invoice */
  invoiceExtraDisplayMode: Maybe<InvoiceExtraDisplayModeDto>;
  invoicePurchasedProducts: Array<InvoiceToPurchasedProductDto>;
  invoicePurchasedStays: Array<InvoiceToPurchasedStayDto>;
  /** This enum substitutes old field "showRooms". Value indicating how to show Rooms on Invoice */
  invoiceRoomDisplayMode: Maybe<InvoiceRoomDisplayModeDto>;
  /** Type of invoice (at the moment used for T17, T18, T19 values of Italian e-invoicing) */
  invoiceType: Maybe<Scalars['String']['output']>;
  invoicedCityTaxes: Array<InvoicedCityTaxDto>;
  invoicedDeposit: Maybe<DepositDto>;
  invoicedDepositId: Maybe<Scalars['Int']['output']>;
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  linkedDeposits: Array<InvoiceToDepositDto>;
  /** Flag that defines if it is a master invoice (a master invoice has n receipts "not to pay" linked) */
  masterInvoice: Scalars['Boolean']['output'];
  masterInvoiceId: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  ownerCorporateDataId: Scalars['Int']['output'];
  /** Part of the Invoice that has been paid the same day the invoice has been created */
  paid: Scalars['BigDecimal']['output'];
  partialPayments: Array<PartialPaymentDto>;
  payment2Amount: Maybe<Scalars['BigDecimal']['output']>;
  payment2Id: Maybe<Scalars['Int']['output']>;
  paymentCityTaxId: Maybe<Scalars['Int']['output']>;
  paymentEffective: Maybe<Scalars['LocalDate']['output']>;
  paymentEffectiveUsername: Maybe<Scalars['String']['output']>;
  paymentExpected: Maybe<Scalars['LocalDate']['output']>;
  paymentId: Maybe<Scalars['Int']['output']>;
  progressive: Scalars['Int']['output'];
  /** Flag that defines if this invoice is a self Invoice */
  selfInvoice: Scalars['Boolean']['output'];
  /** VAT type if the VAT is zero in a self Invoice */
  selfInvoiceNaturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  /** Reference to regulations if the VAT is zero in a self Invoice */
  selfInvoiceReferenceOnZeroVat: Maybe<Scalars['String']['output']>;
  /** deprecated */
  selfInvoiceSeller: Maybe<InvoiceHolderDto>;
  selfInvoiceSellerId: Maybe<Scalars['Int']['output']>;
  /** Deprecated - use `selfInvoiceNaturaTypeOnZeroVat` instead */
  selfInvoiceTypeOnZeroVat: Maybe<Scalars['String']['output']>;
  /** VAT applied if we have a self Invoice (attention: the VAT is intended to be applied to the "amount" field) */
  selfInvoiceVat: Maybe<Scalars['BigDecimal']['output']>;
  /** Flag that defines if customers must be shown */
  showCustomers: Scalars['Boolean']['output'];
  /** deprecated - use invoiceExtraDisplayMode instead. Value indicating how to show Rooms on Invoice */
  showExtra: Maybe<Scalars['Int']['output']>;
  /** Flag that defines if reservation id must be shown */
  showId: Scalars['Boolean']['output'];
  /** deprecated - use invoiceRoomDisplayMode instead. Value indicating how to show Rooms on Invoice */
  showRooms: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
  /** Flag that defines this invoice/receipt has been generated with a wizard */
  wizardInvoice: Scalars['Boolean']['output'];
};

export type InvoiceDataDto = {
  __typename?: 'InvoiceDataDTO';
  bolloAmount: Maybe<Scalars['BigDecimal']['output']>;
  cashRegisterClosure: Maybe<Scalars['String']['output']>;
  cashRegisterCode: Maybe<Scalars['String']['output']>;
  cashRegisterNumber: Maybe<Scalars['String']['output']>;
  cashRegisterPrintTimestamp: Maybe<Scalars['LocalDateTime']['output']>;
  cigCode: Maybe<Scalars['String']['output']>;
  codiceCommessaConvenzione: Maybe<Scalars['String']['output']>;
  cupCode: Maybe<Scalars['String']['output']>;
  dataDocumento: Maybe<Scalars['LocalDate']['output']>;
  eInvoiceSendTimestamp: Maybe<Scalars['LocalDateTime']['output']>;
  eInvoiceStatus: Maybe<EInvoiceStatusEnumDto>;
  /** deprecated - use eInvoiceStatus instead */
  eInvoiceStatusId: Maybe<Scalars['Int']['output']>;
  externalCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  idDocumento: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['Int']['output'];
  relatedDocumentType: Maybe<RelatedDocumentTypeDto>;
  vatChargeability: Maybe<Scalars['String']['output']>;
};

export enum InvoiceDefaultBuildingDto {
  AllBill = 'ALL_BILL',
  AllBillAndCityTax = 'ALL_BILL_AND_CITY_TAX',
  Nothing = 'NOTHING',
  Room = 'ROOM',
  RoomAndCityTax = 'ROOM_AND_CITY_TAX'
}

export enum InvoiceDocumentTypeDto {
  Invoice = 'INVOICE',
  Receipt = 'RECEIPT',
  ReceiptNotToPay = 'RECEIPT_NOT_TO_PAY'
}

export enum InvoiceExtraDisplayModeDto {
  ShowExtraAll = 'SHOW_EXTRA_ALL',
  ShowExtraCategory = 'SHOW_EXTRA_CATEGORY',
  ShowExtraOne = 'SHOW_EXTRA_ONE'
}

export type InvoiceGenerateProgressiveRequestDtoInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  documentType: InvoiceDocumentTypeDto;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceHolderDto = {
  __typename?: 'InvoiceHolderDTO';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  corpName: Maybe<Scalars['String']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoiceDocumentType: Maybe<InvoiceDocumentTypeDto>;
  invoiceHolderType: InvoiceHolderTypeDto;
  mail: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  surname: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export enum InvoiceHolderTypeDto {
  Agency = 'AGENCY',
  Company = 'COMPANY',
  Customer = 'CUSTOMER'
}

export type InvoiceListPaginatedDto = {
  __typename?: 'InvoiceListPaginatedDTO';
  invoices: Array<InvoiceDto>;
  pagination: PaginationDto;
};

export enum InvoiceRoomDisplayModeDto {
  ShowRoomGeneric = 'SHOW_ROOM_GENERIC',
  ShowRoomName = 'SHOW_ROOM_NAME',
  ShowRoomOneStay = 'SHOW_ROOM_ONE_STAY',
  ShowRoomPriceDivided = 'SHOW_ROOM_PRICE_DIVIDED',
  ShowRoomType = 'SHOW_ROOM_TYPE'
}

export type InvoiceToDepositDto = {
  __typename?: 'InvoiceToDepositDTO';
  amount: Scalars['BigDecimal']['output'];
  deposit: DepositDto;
  depositId: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type InvoiceToPurchasedProductDto = {
  __typename?: 'InvoiceToPurchasedProductDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['Int']['output'];
  naturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  originalBeginDate: Maybe<Scalars['LocalDate']['output']>;
  originalDescription: Maybe<Scalars['String']['output']>;
  originalEndDate: Maybe<Scalars['LocalDate']['output']>;
  originalQuantity: Maybe<Scalars['Int']['output']>;
  originalResourceId: Maybe<Scalars['Int']['output']>;
  partiallyInvoiced: Scalars['Boolean']['output'];
  purchasedProduct: PurchasedProductDto;
  purchasedProductId: Scalars['Int']['output'];
  referenceOnZeroVat: Maybe<Scalars['String']['output']>;
  typeOnZeroVat: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type InvoiceToPurchasedStayDto = {
  __typename?: 'InvoiceToPurchasedStayDTO';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['Int']['output'];
  naturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  originalBeginDate: Maybe<Scalars['LocalDate']['output']>;
  originalDescription: Maybe<Scalars['String']['output']>;
  originalEndDate: Maybe<Scalars['LocalDate']['output']>;
  originalQuantity: Maybe<Scalars['Int']['output']>;
  originalResourceId: Maybe<Scalars['Int']['output']>;
  partiallyInvoiced: Scalars['Boolean']['output'];
  purchasedStay: PurchasedStayDto;
  purchasedStayId: Scalars['Int']['output'];
  referenceOnZeroVat: Maybe<Scalars['String']['output']>;
  typeOnZeroVat: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type InvoicedCityTaxDto = {
  __typename?: 'InvoicedCityTaxDTO';
  amount: Scalars['BigDecimal']['output'];
  /** Begin validity */
  beginDate: Scalars['LocalDate']['output'];
  /** TRACE FIELD: Begin number of nights to apply the tax */
  beginNights: Maybe<Scalars['Int']['output']>;
  /** Exemption linked to the CityTax */
  cityTaxExemption: Maybe<CityTaxExemptionDto>;
  /** TRACE FIELD: CityTaxExemption description */
  cityTaxExemptionDescription: Maybe<Scalars['String']['output']>;
  cityTaxExemptionId: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Code of this exemption, useful for export */
  code: Maybe<Scalars['String']['output']>;
  /** Customer linked to the CityTax */
  customer: Maybe<CustomerDto>;
  customerId: Maybe<Scalars['Int']['output']>;
  /** End validity */
  endDate: Scalars['LocalDate']['output'];
  /** TRACE FIELD: End number of nights to apply the tax */
  endNights: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Flag that indicates if a Group leader is free from tax */
  freeGroupLeader: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a Group member is free from tax */
  freeGroupMember: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a Customer resident in the same city is free */
  freeSameCity: Scalars['Boolean']['output'];
  /** TRACE FIELD: Flag that indicates if a the exemption is full (the Customer pays zero) */
  fullExemption: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Id of invoice linked to the CityTax */
  invoiceId: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max age to apply the tax */
  maxAge: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max number of nights in a month to apply the tax */
  maxNightsInMonth: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Max number of nights in a year to apply the tax */
  maxNightsInYear: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Min age to apply the tax */
  minAge: Maybe<Scalars['Int']['output']>;
  /** TRACE FIELD: Multiplier for the base city tax amount. If null, the exemption is complete */
  multiplier: Maybe<Scalars['BigDecimal']['output']>;
  /** TRACE FIELD: New amount for the city tax amount. If null, the exemption is complete */
  newAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** OwnerCityTax linked to the CityTax */
  ownerCityTax: Maybe<OwnerCityTaxDto>;
  /** TRACE FIELD: OwnerCityTax amount */
  ownerCityTaxAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** TRACE FIELD: OwnerCityTax amountFixed */
  ownerCityTaxAmountFixed: Scalars['Boolean']['output'];
  /** TRACE FIELD: OwnerCityTax description */
  ownerCityTaxDescription: Maybe<Scalars['String']['output']>;
  ownerCityTaxId: Maybe<Scalars['Int']['output']>;
  /** PurchasedStay linked to this CityTax */
  purchasedStay: Maybe<PurchasedStayDto>;
  purchasedStayId: Maybe<Scalars['Int']['output']>;
  /** PurchasedStayToCustomer linked to this CityTax */
  purchasedStayToCustomer: Maybe<PurchasedStayToCustomerDto>;
  purchasedStayToCustomerId: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type IstatCustomerDto = {
  __typename?: 'IstatCustomerDTO';
  EInvoicingCode: Maybe<Scalars['String']['output']>;
  /** the difference between the current date and the entered date must be >= 7 */
  birthDate: Maybe<Scalars['LocalDate']['output']>;
  birthDistrict: Maybe<Scalars['String']['output']>;
  birthPlace: Maybe<Scalars['String']['output']>;
  birthPlaceId: Maybe<Scalars['Int']['output']>;
  birthStateId: Maybe<Scalars['Int']['output']>;
  creditCardId: Maybe<Scalars['Int']['output']>;
  customerCode: Maybe<Scalars['String']['output']>;
  customerData: CustomerDataDto;
  customerDataId: Maybe<Scalars['Int']['output']>;
  customerId: Scalars['Int']['output'];
  documentDeadlineDate: Maybe<Scalars['LocalDate']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  documentReleaseDate: Maybe<Scalars['LocalDate']['output']>;
  documentReleaser: Maybe<Scalars['String']['output']>;
  documentReleaserCityId: Maybe<Scalars['Int']['output']>;
  documentReleaserState: Scalars['Boolean']['output'];
  documentReleaserStateId: Maybe<Scalars['Int']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  /** unique identifier for istatCustomer */
  id: Scalars['String']['output'];
  involvedPurchasedStayIds: Array<Scalars['Int']['output']>;
  /** deprecated - use id instead */
  istatCustomerId: Scalars['String']['output'];
  istatCustomerMode: IstatCustomerModeDto;
  istatMode: IstatModeDto;
  istatSendStatus: IstatSendStatusDto;
  istatStatus: Maybe<IstatStatusDto>;
  leader: Scalars['Boolean']['output'];
  /** if set it must be 8 characters long */
  lotteryCode: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  multidbDocumentTypeId: Maybe<Scalars['Int']['output']>;
  /** if set it must not contain: #, &, $, £, %, <, > */
  name: Maybe<Scalars['String']['output']>;
  nationalityId: Maybe<Scalars['Int']['output']>;
  password: Maybe<Scalars['String']['output']>;
  pec: Maybe<Scalars['String']['output']>;
  purchasedStayToCustomer: PurchasedStayToCustomerDto;
  relativePurchasedStayToCustomers: Array<PurchasedStayToCustomerDto>;
  /** deprecated - use relativePurchasedStayToCustomers instead */
  relatives: Array<CustomerDto>;
  reservationId: Scalars['Int']['output'];
  room: Scalars['String']['output'];
  sex: Scalars['Boolean']['output'];
  stateId: Maybe<Scalars['Int']['output']>;
  /** it must not contain: #, &, $, £, %, <, > */
  surname: Scalars['String']['output'];
  takenRooms: Maybe<Scalars['Int']['output']>;
  validationResults: Array<ResourceValidationResultDto>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export enum IstatCustomerModeDto {
  IstatCustomerModeIn = 'ISTAT_CUSTOMER_MODE_IN',
  IstatCustomerModeOut = 'ISTAT_CUSTOMER_MODE_OUT',
  IstatCustomerModeStill = 'ISTAT_CUSTOMER_MODE_STILL',
  IstatCustomerModeTax = 'ISTAT_CUSTOMER_MODE_TAX'
}

export type IstatGenerationParametersDto = {
  __typename?: 'IstatGenerationParametersDTO';
  availableBeds: Scalars['Int']['output'];
  availableRooms: Scalars['Int']['output'];
  availableToilets: Scalars['Int']['output'];
};

export enum IstatModeDto {
  IstatModeDelete = 'ISTAT_MODE_DELETE',
  IstatModeEdit = 'ISTAT_MODE_EDIT',
  IstatModeNew = 'ISTAT_MODE_NEW',
  IstatModeStill = 'ISTAT_MODE_STILL',
  IstatModeTax = 'ISTAT_MODE_TAX'
}

export enum IstatSendStatusDto {
  IstatSendStatusCityTax = 'ISTAT_SEND_STATUS_CITY_TAX',
  IstatSendStatusNotSent = 'ISTAT_SEND_STATUS_NOT_SENT',
  IstatSendStatusNotValid = 'ISTAT_SEND_STATUS_NOT_VALID',
  IstatSendStatusValid = 'ISTAT_SEND_STATUS_VALID'
}

export enum IstatStatusDto {
  IstatStatusCheckInSentError = 'ISTAT_STATUS_CHECK_IN_SENT_ERROR',
  IstatStatusCheckInSentOk = 'ISTAT_STATUS_CHECK_IN_SENT_OK',
  IstatStatusCheckOutSentError = 'ISTAT_STATUS_CHECK_OUT_SENT_ERROR',
  IstatStatusCheckOutSentOk = 'ISTAT_STATUS_CHECK_OUT_SENT_OK',
  IstatStatusStillSentError = 'ISTAT_STATUS_STILL_SENT_ERROR',
  IstatStatusStillSentOk = 'ISTAT_STATUS_STILL_SENT_OK'
}

export type IstatTypeDto = {
  __typename?: 'IstatTypeDTO';
  beds: Scalars['Boolean']['output'];
  cityTax: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  daily: Scalars['Boolean']['output'];
  fromTo: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  istatCode: Scalars['Boolean']['output'];
  istatPassword: Scalars['Boolean']['output'];
  istatUrl: Scalars['Boolean']['output'];
  istatUser: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  needSearch: Scalars['Boolean']['output'];
  openingDays: Scalars['Boolean']['output'];
  paidCasualWorkers: Scalars['Boolean']['output'];
  paidRegularWorkers: Scalars['Boolean']['output'];
  printable: Scalars['Boolean']['output'];
  rooms: Scalars['Boolean']['output'];
  /** deprecated - just check if `IstatType.ASTAT_DAILY` is selected from ownerIstat combo-box */
  sendFacilityClosure: Scalars['Boolean']['output'];
  sendFile: Scalars['Boolean']['output'];
  /** deprecated - just check if `IstatType.ASTAT_DAILY` is selected from ownerIstat combo-box */
  sendIstatClosure: Scalars['Boolean']['output'];
  sendOnline: Scalars['Boolean']['output'];
  toilets: Scalars['Boolean']['output'];
  type: IstatTypeEnum;
  unpaidWorkers: Scalars['Boolean']['output'];
};

export enum IstatTypeEnum {
  AstatDaily = 'ASTAT_DAILY',
  Basilicata = 'BASILICATA',
  DailyMidap = 'DAILY_MIDAP',
  DailyRicestatWithTax = 'DAILY_RICESTAT_WITH_TAX',
  DailyTurismo5 = 'DAILY_TURISMO5',
  DailyTurismo5WithCityTax = 'DAILY_TURISMO5_WITH_CITY_TAX',
  Eptnapoli = 'EPTNAPOLI',
  Friuli = 'FRIULI',
  FriuliAppartamenti = 'FRIULI_APPARTAMENTI',
  HestaStatisticaRicettivitaSvizzera = 'HESTA_STATISTICA_RICETTIVITA_SVIZZERA',
  Ine = 'INE',
  Insee = 'INSEE',
  Ispat = 'ISPAT',
  Midap = 'MIDAP',
  MonthlyMidapWithCityTax = 'MONTHLY_MIDAP_WITH_CITY_TAX',
  MonthlyRicestat = 'MONTHLY_RICESTAT',
  MonthlyRicestatWithCityTax = 'MONTHLY_RICESTAT_WITH_CITY_TAX',
  MonthlyTurismo5 = 'MONTHLY_TURISMO5',
  MonthlyTurismo5WithCityTax = 'MONTHLY_TURISMO5_WITH_CITY_TAX',
  Mtweb = 'MTWEB',
  Piemonte = 'PIEMONTE',
  Presenze = 'PRESENZE',
  Radar = 'RADAR',
  RadarXml = 'RADAR_XML',
  Ricestat = 'RICESTAT',
  RiepilogoPeriodo = 'RIEPILOGO_PERIODO',
  Rimovcli = 'RIMOVCLI',
  Sicilia = 'SICILIA',
  Sondrio = 'SONDRIO',
  Spot = 'SPOT',
  Tolm = 'TOLM',
  Turistat = 'TURISTAT',
  Turiweb = 'TURIWEB',
  Valledaosta = 'VALLEDAOSTA'
}

export type JoinPurchasedStaysRequestDtoInput = {
  firstPurchasedStayId: Scalars['Int']['input'];
  secondPurchasedStayId: Scalars['Int']['input'];
};

export enum LastInstalmentEnumDto {
  BeforeStay = 'BEFORE_STAY',
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT'
}

export enum LiquidationProcessEnumDto {
  InLiquidation = 'IN_LIQUIDATION',
  NotInLiquidation = 'NOT_IN_LIQUIDATION'
}

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Cancels or releases a transaction and returns the id of the transaction created. Which operation runs follows from the channel of the original transaction and from its type, and the frontend does not choose it. A partial cancel is accepted only where amountEditable of that row is true. Reload getCreditCards afterwards. Not repeatable: keep the form disabled until this answers */
  cancelTransaction: Scalars['Int']['output'];
  changeRoom: ChangeRoomResponseDto;
  /** Charges the card and returns the id of the transaction created. Which channel runs it is decided by the server from the card: a card taken from a payment terminal goes through that terminal, any other through a gateway, and ownerPaymentGatewayId and chargeType are ignored for the first. Reload getCreditCards afterwards. Not repeatable: keep the form disabled until this answers */
  charge: Scalars['Int']['output'];
  closeAllWebAvailabilities: Scalars['Boolean']['output'];
  /** Collects a preauthorization, in full or in part, and returns the id of the transaction created. The channel is decided by the server: a hold is collected where it was taken. amount is capped by maxConfirmAmount of that row, which already counts the top-ups. Reload getCreditCards afterwards: the hold closes and its buttons move. Not repeatable: keep the form disabled until this answers */
  confirmTransaction: Scalars['Int']['output'];
  createAgency: Maybe<Scalars['Int']['output']>;
  createCancellationPolicy: Maybe<Scalars['Int']['output']>;
  createCashRegister: Maybe<Scalars['Int']['output']>;
  createChannel: Maybe<Scalars['Int']['output']>;
  createCompany: Maybe<Scalars['Int']['output']>;
  createCreditNote: Scalars['Int']['output'];
  createCustomer: Maybe<Scalars['Int']['output']>;
  createDamage: Maybe<Scalars['Int']['output']>;
  createDeposit: Maybe<Scalars['Int']['output']>;
  createInvoice: Maybe<Scalars['Int']['output']>;
  createInvoiceData: Maybe<Scalars['Int']['output']>;
  createMasterInvoice: CreateMasterInvoiceResponseDto;
  createOptional: Maybe<Scalars['Int']['output']>;
  createOwnerCorporateData: Maybe<Scalars['Int']['output']>;
  createPacket: Maybe<Scalars['Int']['output']>;
  createParameterValue: Scalars['Boolean']['output'];
  createPriceList: Maybe<Scalars['Int']['output']>;
  createPrimaryCost: Maybe<Scalars['Int']['output']>;
  createProduct: Maybe<Scalars['Int']['output']>;
  createPurchasedProduct: Maybe<Scalars['Int']['output']>;
  createPurchasedProducts: BulkResultsDto;
  createPurchasedStay: Maybe<Scalars['Int']['output']>;
  createPurchasedStayToCustomer: Scalars['Int']['output'];
  createResStatus: Maybe<Scalars['Int']['output']>;
  createReservation: Maybe<Scalars['Int']['output']>;
  createReservations: Array<Scalars['Int']['output']>;
  createRoom: Maybe<Scalars['Int']['output']>;
  createRoomStatus: Maybe<Scalars['Int']['output']>;
  createSecondaryCost: Maybe<Scalars['Int']['output']>;
  createSegment: Maybe<Scalars['Int']['output']>;
  createStay: Maybe<Scalars['Int']['output']>;
  createWebPacket: Maybe<Scalars['Int']['output']>;
  createWizardInvoice: CreateWizardInvoiceResponseDto;
  deleteAgency: Scalars['Boolean']['output'];
  deleteCancellationPolicy: Scalars['Boolean']['output'];
  deleteCashRegister: Scalars['Boolean']['output'];
  deleteChannel: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteCostCenter: Scalars['Boolean']['output'];
  /** Deletes the card: the row goes and the token is destroyed at the tokenizer, so this cannot be undone. Ask the user to confirm first. creditCardId is CreditCardRowDTO.id. Refused when the card has transactions, which buttonStates.delete already reports. Reload getCreditCards afterwards: the card disappears from the list, it does not come back marked as deleted */
  deleteCreditCard: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  deleteDamage: Scalars['Boolean']['output'];
  deleteDeposit: Scalars['Boolean']['output'];
  deleteInvoice: Scalars['Boolean']['output'];
  deleteMasterInvoice: Scalars['Boolean']['output'];
  deleteOptional: Scalars['Boolean']['output'];
  deleteOwnerCorporateData: Scalars['Boolean']['output'];
  deletePacket: Scalars['Boolean']['output'];
  deleteParameterValue: Scalars['Boolean']['output'];
  deletePriceList: Scalars['Boolean']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deletePurchasedProduct: Scalars['Boolean']['output'];
  deletePurchasedProducts: BulkResultsDto;
  deletePurchasedStay: Scalars['Boolean']['output'];
  deletePurchasedStayToCustomer: Scalars['Boolean']['output'];
  deleteResStatus: Scalars['Boolean']['output'];
  deleteReservation: Scalars['Boolean']['output'];
  deleteRoom: Scalars['Boolean']['output'];
  deleteRoomStatus: Scalars['Boolean']['output'];
  deleteSegment: Scalars['Boolean']['output'];
  deleteStay: Scalars['Boolean']['output'];
  dividePurchasedStay: Scalars['Int']['output'];
  doCheckIn: Scalars['Boolean']['output'];
  doCheckOut: Scalars['Boolean']['output'];
  doDoorLockCodeReset: Scalars['Boolean']['output'];
  doDoorLockCodeSet: Scalars['Boolean']['output'];
  joinPurchasedStays: Scalars['Int']['output'];
  /** Puts a hold on the card through a payment gateway and returns the id of the transaction created. Reload getCreditCards afterwards: the new transaction is not the only thing that changed. Not repeatable, a second call is a second hold on a real card: keep the form disabled until this answers */
  preauthorize: Scalars['Int']['output'];
  purchasedStayMoveAndStretch: Scalars['Boolean']['output'];
  removeOptionalImage: Scalars['Boolean']['output'];
  removePacketImage: Scalars['Boolean']['output'];
  removeProductImage: Scalars['Boolean']['output'];
  removeStayImage: Scalars['Boolean']['output'];
  /** Add familyRep to all customers */
  saveCustomersWithFamilyRep: Scalars['Boolean']['output'];
  saveGridPrices: Scalars['Boolean']['output'];
  saveGridWebAvailabilities: Scalars['Boolean']['output'];
  savePrices: Scalars['Boolean']['output'];
  /** Save printed document data from cash register */
  savePrintedDocumentData: Scalars['Boolean']['output'];
  saveWebAvailabilities: Scalars['Boolean']['output'];
  sendAstatDailyFacilityClosure: Maybe<Scalars['String']['output']>;
  /** Returns a payment PDF URL to which browser should be redirected */
  sendAstatDailyIstatClosure: Maybe<Scalars['String']['output']>;
  sendElectronicInvoice: Scalars['Boolean']['output'];
  sendElectronicInvoices: SendAllResponseDto;
  sendIstat: Maybe<Scalars['String']['output']>;
  sendPsCustomers: Scalars['Boolean']['output'];
  transferService: Scalars['Boolean']['output'];
  transferServices: Array<TransferServicesResultItemDto>;
  undoCheckIn: Scalars['Boolean']['output'];
  undoCheckOut: Scalars['Boolean']['output'];
  unlinkPurchasedStay: Scalars['Int']['output'];
  updateAgency: Scalars['Boolean']['output'];
  updateAndReturnInvoice: Maybe<InvoiceDto>;
  updateCancellationPolicy: Scalars['Boolean']['output'];
  updateCashRegister: Scalars['Boolean']['output'];
  updateChannel: Scalars['Boolean']['output'];
  updateCompany: Scalars['Boolean']['output'];
  updateCustomer: Scalars['Boolean']['output'];
  updateDamage: Scalars['Boolean']['output'];
  updateDeposit: Scalars['Boolean']['output'];
  updateIdpUserInfo: Scalars['Boolean']['output'];
  updateInvoice: Scalars['Boolean']['output'];
  updateInvoiceData: Scalars['Boolean']['output'];
  updateMasterInvoice: Scalars['Boolean']['output'];
  updateOptional: Scalars['Boolean']['output'];
  updateOptionalData: Scalars['Boolean']['output'];
  updateOwnerCorporateData: Scalars['Boolean']['output'];
  updatePacket: Scalars['Boolean']['output'];
  updateParameter: Scalars['Boolean']['output'];
  updateParameterValue: Scalars['Boolean']['output'];
  updatePriceList: Scalars['Boolean']['output'];
  updatePrimaryCost: Scalars['Boolean']['output'];
  updateProduct: Scalars['Boolean']['output'];
  updateProductData: Scalars['Boolean']['output'];
  updatePurchasedProduct: Scalars['Boolean']['output'];
  updatePurchasedStay: Scalars['Boolean']['output'];
  updatePurchasedStayToCustomer: Scalars['Boolean']['output'];
  updateResStatus: Scalars['Boolean']['output'];
  updateReservation: Scalars['Boolean']['output'];
  updateRoom: Scalars['Boolean']['output'];
  updateRoomStatus: Scalars['Boolean']['output'];
  updateSecondaryCost: Scalars['Boolean']['output'];
  updateSegment: Scalars['Boolean']['output'];
  updateStatusElectronicInvoice: Maybe<EInvoiceStatusEnumDto>;
  updateStatusElectronicInvoices: UpdateStatusAllResponseDto;
  updateStay: Scalars['Boolean']['output'];
  updateStayData: Scalars['Boolean']['output'];
  updateStayRoomAmenity: Scalars['Boolean']['output'];
  updateUserPreferences: Scalars['Boolean']['output'];
  updateWebPacket: Scalars['Boolean']['output'];
  /** Asks the tokenizer whether the card is prepaid and stores the answer, which is also what it returns. creditCardId is CreditCardRowDTO.id, the row the user picked in getCreditCards. Reload getCreditCards afterwards: the Prepagata column comes from there, not from here */
  verifyPrepaid: Scalars['Boolean']['output'];
};


/** Mutation root */
export type MutationCancelTransactionArgs = {
  request: CancelTransactionRequestDtoInput;
};


/** Mutation root */
export type MutationChangeRoomArgs = {
  request: ChangeRoomRequestDtoInput;
};


/** Mutation root */
export type MutationChargeArgs = {
  request: ChargeRequestDtoInput;
};


/** Mutation root */
export type MutationCloseAllWebAvailabilitiesArgs = {
  request: CloseAllWebAvailabilitiesRequestDtoInput;
};


/** Mutation root */
export type MutationConfirmTransactionArgs = {
  request: ConfirmTransactionRequestDtoInput;
};


/** Mutation root */
export type MutationCreateAgencyArgs = {
  upsertAgencyDTO: UpsertAgencyDtoInput;
};


/** Mutation root */
export type MutationCreateCancellationPolicyArgs = {
  upsertCancellationPolicyDTO: UpsertCancellationPolicyDtoInput;
};


/** Mutation root */
export type MutationCreateCashRegisterArgs = {
  upsertCashRegisterDTO: UpsertCashRegisterDtoInput;
};


/** Mutation root */
export type MutationCreateChannelArgs = {
  upsertChannelDTO: UpsertChannelDtoInput;
};


/** Mutation root */
export type MutationCreateCompanyArgs = {
  upsertCompanyDTO: UpsertCompanyDtoInput;
};


/** Mutation root */
export type MutationCreateCreditNoteArgs = {
  request: InputMaybe<CreateCreditNoteRequestDtoInput>;
};


/** Mutation root */
export type MutationCreateCustomerArgs = {
  upsertCustomerDTO: UpsertCustomerDtoInput;
};


/** Mutation root */
export type MutationCreateDamageArgs = {
  upsertDamageDTO: UpsertDamageDtoInput;
};


/** Mutation root */
export type MutationCreateDepositArgs = {
  upsertDepositDTO: UpsertDepositDtoInput;
};


/** Mutation root */
export type MutationCreateInvoiceArgs = {
  additionalProducts: InputMaybe<Array<InputMaybe<UpsertInvoiceAdditionalProductDtoInput>>>;
  upsertInvoiceDTO: UpsertInvoiceDtoInput;
};


/** Mutation root */
export type MutationCreateInvoiceDataArgs = {
  upsertInvoiceDataDTO: UpsertInvoiceDataDtoInput;
};


/** Mutation root */
export type MutationCreateMasterInvoiceArgs = {
  linkedReceiptIds: Array<Scalars['Int']['input']>;
  upsertInvoiceDTO: UpsertInvoiceDtoInput;
};


/** Mutation root */
export type MutationCreateOptionalArgs = {
  upsertOptionalDTO: UpsertOptionalDtoInput;
};


/** Mutation root */
export type MutationCreateOwnerCorporateDataArgs = {
  upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDtoInput;
};


/** Mutation root */
export type MutationCreatePacketArgs = {
  upsertPacketDTO: UpsertPacketDtoInput;
};


/** Mutation root */
export type MutationCreateParameterValueArgs = {
  upsertParameterValueDTO: UpsertParameterValueDtoInput;
};


/** Mutation root */
export type MutationCreatePriceListArgs = {
  upsertPriceListDTO: UpsertPriceListDtoInput;
};


/** Mutation root */
export type MutationCreatePrimaryCostArgs = {
  upsertPrimaryCostDTO: UpsertPrimaryCostDtoInput;
};


/** Mutation root */
export type MutationCreateProductArgs = {
  upsertProductDTO: UpsertProductDtoInput;
};


/** Mutation root */
export type MutationCreatePurchasedProductArgs = {
  upsertPurchasedProductDTO: UpsertPurchasedProductDtoInput;
};


/** Mutation root */
export type MutationCreatePurchasedProductsArgs = {
  upsertPurchasedProductDTOs: Array<UpsertPurchasedProductDtoInput>;
};


/** Mutation root */
export type MutationCreatePurchasedStayArgs = {
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Mutation root */
export type MutationCreatePurchasedStayToCustomerArgs = {
  upsertPurchasedStayToCustomerDTO: UpsertPurchasedStayToCustomerDtoInput;
};


/** Mutation root */
export type MutationCreateResStatusArgs = {
  upsertResStatusDTO: UpsertResStatusDtoInput;
};


/** Mutation root */
export type MutationCreateReservationArgs = {
  createReservationDTO: CreateReservationDtoInput;
};


/** Mutation root */
export type MutationCreateReservationsArgs = {
  createReservationDTOs: Array<CreateReservationDtoInput>;
};


/** Mutation root */
export type MutationCreateRoomArgs = {
  upsertRoomDTO: UpsertRoomDtoInput;
};


/** Mutation root */
export type MutationCreateRoomStatusArgs = {
  upsertRoomStatusDTO: UpsertRoomStatusDtoInput;
};


/** Mutation root */
export type MutationCreateSecondaryCostArgs = {
  upsertSecondaryCostDTO: UpsertSecondaryCostDtoInput;
};


/** Mutation root */
export type MutationCreateSegmentArgs = {
  upsertSegmentDTO: UpsertSegmentDtoInput;
};


/** Mutation root */
export type MutationCreateStayArgs = {
  upsertStayDTO: UpsertStayDtoInput;
};


/** Mutation root */
export type MutationCreateWebPacketArgs = {
  upsertWebPacketDTO: UpsertWebPacketDtoInput;
};


/** Mutation root */
export type MutationCreateWizardInvoiceArgs = {
  request: InputMaybe<CreateWizardInvoiceRequestDtoInput>;
};


/** Mutation root */
export type MutationDeleteAgencyArgs = {
  resourceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCancellationPolicyArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCashRegisterArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteChannelArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCompanyArgs = {
  resourceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCostCenterArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCreditCardArgs = {
  creditCardId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteCustomerArgs = {
  resourceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteDamageArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteInvoiceArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteMasterInvoiceArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteOptionalArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteOwnerCorporateDataArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePacketArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteParameterValueArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePriceListArgs = {
  resourceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteProductArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePurchasedProductArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePurchasedProductsArgs = {
  purchasedProductIds: Array<Scalars['Int']['input']>;
  reservationId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePurchasedStayArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeletePurchasedStayToCustomerArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteResStatusArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteReservationArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteRoomArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteRoomStatusArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteSegmentArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteStayArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDividePurchasedStayArgs = {
  dividePurchasedStayRequestDTO: DividePurchasedStayRequestDtoInput;
};


/** Mutation root */
export type MutationDoCheckInArgs = {
  purchasedStayId: Scalars['Int']['input'];
  reservationId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationDoCheckOutArgs = {
  purchasedStayId: Scalars['Int']['input'];
  reservationId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationDoDoorLockCodeResetArgs = {
  purchasedStayId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDoDoorLockCodeSetArgs = {
  doorLockCode: InputMaybe<Scalars['String']['input']>;
  purchasedStayId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationJoinPurchasedStaysArgs = {
  request: JoinPurchasedStaysRequestDtoInput;
};


/** Mutation root */
export type MutationPreauthorizeArgs = {
  request: PreauthorizeRequestDtoInput;
};


/** Mutation root */
export type MutationPurchasedStayMoveAndStretchArgs = {
  purchasedStayMoveAndStretchRequest: InputMaybe<PurchasedStayMoveAndStretchRequestDtoInput>;
};


/** Mutation root */
export type MutationRemoveOptionalImageArgs = {
  optionalId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRemovePacketImageArgs = {
  packetId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRemoveProductImageArgs = {
  productId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRemoveStayImageArgs = {
  request: RemoveStayImageRequestDtoInput;
};


/** Mutation root */
export type MutationSaveCustomersWithFamilyRepArgs = {
  saveCustomersWithFamilyRepRequestDTO: InputMaybe<SaveCustomersWithFamilyRepRequestDtoInput>;
};


/** Mutation root */
export type MutationSaveGridPricesArgs = {
  saveGridPricesRequestDTO: SaveGridPricesRequestDtoInput;
};


/** Mutation root */
export type MutationSaveGridWebAvailabilitiesArgs = {
  request: SaveGridWebAvailabilitiesRequestDtoInput;
};


/** Mutation root */
export type MutationSavePricesArgs = {
  savePricesRequestDTO: SavePricesRequestDtoInput;
};


/** Mutation root */
export type MutationSavePrintedDocumentDataArgs = {
  saveCashRegisterPrintRequestDTO: SavePrintedDocumentDataRequestDtoInput;
};


/** Mutation root */
export type MutationSaveWebAvailabilitiesArgs = {
  request: SaveWebAvailabilitiesRequestDtoInput;
};


/** Mutation root */
export type MutationSendAstatDailyFacilityClosureArgs = {
  sendAstatDailyFacilityClosureRequestDTO: InputMaybe<SendAstatDailyFacilityClosureRequestDtoInput>;
};


/** Mutation root */
export type MutationSendAstatDailyIstatClosureArgs = {
  sendAstatDailyIstatClosureRequestDTO: InputMaybe<SendAstatDailyIstatClosureRequestDtoInput>;
};


/** Mutation root */
export type MutationSendElectronicInvoiceArgs = {
  invoiceId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSendElectronicInvoicesArgs = {
  invoiceIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSendIstatArgs = {
  sendIstatRequestDTO: InputMaybe<SendIstatRequestDtoInput>;
};


/** Mutation root */
export type MutationSendPsCustomersArgs = {
  sendPsCustomersRequestDTO: InputMaybe<SendPsCustomersRequestDtoInput>;
};


/** Mutation root */
export type MutationTransferServiceArgs = {
  request: TransferServiceRequestDtoInput;
};


/** Mutation root */
export type MutationTransferServicesArgs = {
  request: TransferServicesRequestDtoInput;
};


/** Mutation root */
export type MutationUndoCheckInArgs = {
  purchasedStayId: Scalars['Int']['input'];
  reservationId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUndoCheckOutArgs = {
  purchasedStayId: Scalars['Int']['input'];
  reservationId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUnlinkPurchasedStayArgs = {
  purchasedStayId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateAgencyArgs = {
  upsertAgencyDTO: UpsertAgencyDtoInput;
};


/** Mutation root */
export type MutationUpdateAndReturnInvoiceArgs = {
  additionalProducts: InputMaybe<Array<InputMaybe<UpsertInvoiceAdditionalProductDtoInput>>>;
  upsertInvoiceDTO: UpsertInvoiceDtoInput;
};


/** Mutation root */
export type MutationUpdateCancellationPolicyArgs = {
  upsertCancellationPolicyDTO: UpsertCancellationPolicyDtoInput;
};


/** Mutation root */
export type MutationUpdateCashRegisterArgs = {
  upsertCashRegisterDTO: UpsertCashRegisterDtoInput;
};


/** Mutation root */
export type MutationUpdateChannelArgs = {
  upsertChannelDTO: UpsertChannelDtoInput;
};


/** Mutation root */
export type MutationUpdateCompanyArgs = {
  upsertCompanyDTO: UpsertCompanyDtoInput;
};


/** Mutation root */
export type MutationUpdateCustomerArgs = {
  upsertCustomerDTO: UpsertCustomerDtoInput;
};


/** Mutation root */
export type MutationUpdateDamageArgs = {
  upsertDamageDTO: UpsertDamageDtoInput;
};


/** Mutation root */
export type MutationUpdateDepositArgs = {
  upsertDepositDTO: UpsertDepositDtoInput;
};


/** Mutation root */
export type MutationUpdateInvoiceArgs = {
  additionalProducts: InputMaybe<Array<InputMaybe<UpsertInvoiceAdditionalProductDtoInput>>>;
  upsertInvoiceDTO: UpsertInvoiceDtoInput;
};


/** Mutation root */
export type MutationUpdateInvoiceDataArgs = {
  upsertInvoiceDataDTO: UpsertInvoiceDataDtoInput;
};


/** Mutation root */
export type MutationUpdateMasterInvoiceArgs = {
  linkedReceiptIds: Array<Scalars['Int']['input']>;
  upsertInvoiceDTO: UpsertInvoiceDtoInput;
};


/** Mutation root */
export type MutationUpdateOptionalArgs = {
  upsertOptionalDTO: UpsertOptionalDtoInput;
};


/** Mutation root */
export type MutationUpdateOptionalDataArgs = {
  upsertOptionalDataDTO: UpsertOptionalDataDtoInput;
};


/** Mutation root */
export type MutationUpdateOwnerCorporateDataArgs = {
  upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDtoInput;
};


/** Mutation root */
export type MutationUpdatePacketArgs = {
  upsertPacketDTO: UpsertPacketDtoInput;
};


/** Mutation root */
export type MutationUpdateParameterArgs = {
  upsertParameterDTO: UpsertParameterDtoInput;
};


/** Mutation root */
export type MutationUpdateParameterValueArgs = {
  upsertParameterValueDTO: UpsertParameterValueDtoInput;
};


/** Mutation root */
export type MutationUpdatePriceListArgs = {
  upsertPriceListDTO: UpsertPriceListDtoInput;
};


/** Mutation root */
export type MutationUpdatePrimaryCostArgs = {
  upsertPrimaryCostDTO: UpsertPrimaryCostDtoInput;
};


/** Mutation root */
export type MutationUpdateProductArgs = {
  upsertProductDTO: UpsertProductDtoInput;
};


/** Mutation root */
export type MutationUpdateProductDataArgs = {
  upsertProductDataDTO: UpsertProductDataDtoInput;
};


/** Mutation root */
export type MutationUpdatePurchasedProductArgs = {
  upsertPurchasedProductDTO: UpsertPurchasedProductDtoInput;
};


/** Mutation root */
export type MutationUpdatePurchasedStayArgs = {
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Mutation root */
export type MutationUpdatePurchasedStayToCustomerArgs = {
  upsertPurchasedStayToCustomerDTO: UpsertPurchasedStayToCustomerDtoInput;
};


/** Mutation root */
export type MutationUpdateResStatusArgs = {
  upsertResStatusDTO: UpsertResStatusDtoInput;
};


/** Mutation root */
export type MutationUpdateReservationArgs = {
  updateReservationDTO: UpdateReservationDtoInput;
};


/** Mutation root */
export type MutationUpdateRoomArgs = {
  upsertRoomDTO: UpsertRoomDtoInput;
};


/** Mutation root */
export type MutationUpdateRoomStatusArgs = {
  upsertRoomStatusDTO: UpsertRoomStatusDtoInput;
};


/** Mutation root */
export type MutationUpdateSecondaryCostArgs = {
  upsertSecondaryCostDTO: UpsertSecondaryCostDtoInput;
};


/** Mutation root */
export type MutationUpdateSegmentArgs = {
  upsertSegmentDTO: UpsertSegmentDtoInput;
};


/** Mutation root */
export type MutationUpdateStatusElectronicInvoiceArgs = {
  invoiceId: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateStatusElectronicInvoicesArgs = {
  invoiceIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateStayArgs = {
  upsertStayDTO: UpsertStayDtoInput;
};


/** Mutation root */
export type MutationUpdateStayDataArgs = {
  upsertStayDataDTO: UpsertStayDataDtoInput;
};


/** Mutation root */
export type MutationUpdateStayRoomAmenityArgs = {
  roomAmenityIds: Array<Scalars['Int']['input']>;
  stayId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateUserPreferencesArgs = {
  upsertUserPreferencesDTO: UpsertUserPreferencesDtoInput;
};


/** Mutation root */
export type MutationUpdateWebPacketArgs = {
  upsertWebPacketDTO: UpsertWebPacketDtoInput;
};


/** Mutation root */
export type MutationVerifyPrepaidArgs = {
  creditCardId: Scalars['Int']['input'];
};

export enum NaturaTypeEnumDto {
  N_1 = 'N_1',
  /** @deprecated Deprecated */
  N_2 = 'N_2',
  N_2_1 = 'N_2_1',
  N_2_2 = 'N_2_2',
  /** @deprecated Deprecated */
  N_3 = 'N_3',
  N_3_1 = 'N_3_1',
  N_3_2 = 'N_3_2',
  N_3_3 = 'N_3_3',
  N_3_4 = 'N_3_4',
  N_3_5 = 'N_3_5',
  N_3_6 = 'N_3_6',
  N_4 = 'N_4',
  N_5 = 'N_5',
  /** @deprecated Deprecated */
  N_6 = 'N_6',
  N_6_1 = 'N_6_1',
  N_6_2 = 'N_6_2',
  N_6_3 = 'N_6_3',
  N_6_4 = 'N_6_4',
  N_6_5 = 'N_6_5',
  N_6_6 = 'N_6_6',
  N_6_7 = 'N_6_7',
  N_6_8 = 'N_6_8',
  N_6_9 = 'N_6_9',
  N_7 = 'N_7'
}

export type OpeningHourDto = {
  __typename?: 'OpeningHourDTO';
  closeHour: Scalars['LocalTime']['output'];
  id: Scalars['Int']['output'];
  openHour: Scalars['LocalTime']['output'];
  resourceId: Scalars['Int']['output'];
};

export type OptionalDto = ResourceDto & {
  __typename?: 'OptionalDTO';
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  category2Id: Maybe<Scalars['Int']['output']>;
  categoryId: Maybe<Scalars['Int']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  priceLists: Array<PriceListDto>;
  stays: Maybe<Array<Maybe<StayDto>>>;
  travelInsurancePolicyId: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
  webAvailable: Scalars['Boolean']['output'];
  /** deprecated - moved to OptionalDataDTO */
  webMandatory: Scalars['Boolean']['output'];
  /** deprecated - moved to OptionalDataDTO */
  webOrder: Maybe<Scalars['Int']['output']>;
};

export type OptionalDataDto = {
  __typename?: 'OptionalDataDTO';
  mainImageMaxHeight: Maybe<Scalars['Int']['output']>;
  mainImageMaxWidth: Maybe<Scalars['Int']['output']>;
  mainImageUrl: Maybe<Scalars['String']['output']>;
  optionalId: Scalars['Int']['output'];
  webMandatory: Maybe<Scalars['Boolean']['output']>;
  webMandatoryPerNight: Maybe<Scalars['Boolean']['output']>;
  webMandatoryRule: Maybe<WebMandatoryRuleEnumDto>;
  webMaxPurchasableRule: Maybe<WebMaxPurchasableRuleEnumDto>;
  webOrder: Maybe<Scalars['Int']['output']>;
  webPurchasableWithCustomDates: Maybe<Scalars['Boolean']['output']>;
};

export type OwnerCityTaxDto = {
  __typename?: 'OwnerCityTaxDTO';
  amount: Scalars['BigDecimal']['output'];
  amountFixed: Scalars['Boolean']['output'];
  beginDate: Scalars['LocalDate']['output'];
  beginRoomPrice: Maybe<Scalars['BigDecimal']['output']>;
  calculatePerRoom: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  descriptionInInvoice: Maybe<Scalars['String']['output']>;
  endDate: Scalars['LocalDate']['output'];
  endRoomPrice: Maybe<Scalars['BigDecimal']['output']>;
  id: Scalars['Int']['output'];
  includedInRoomPrice: Scalars['Boolean']['output'];
  ownerId: Scalars['Int']['output'];
  psIstatGroup: Maybe<Scalars['Int']['output']>;
  roomPricePerPerson: Scalars['Boolean']['output'];
  vat: Maybe<Scalars['BigDecimal']['output']>;
};

export type OwnerCorporateDataDto = {
  __typename?: 'OwnerCorporateDataDTO';
  address: Maybe<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  cashRegisterMode: Maybe<CashRegisterModeDto>;
  city: Maybe<Scalars['String']['output']>;
  cityId: Maybe<Scalars['Int']['output']>;
  cityTaxDepartment: Maybe<DepartmentDto>;
  cityTaxDepartmentId: Maybe<Scalars['Int']['output']>;
  cityTaxVatReference: Maybe<Scalars['String']['output']>;
  cityTaxVatType: Maybe<CityTaxVatTypeEnumDto>;
  corpName: Scalars['String']['output'];
  defaultOwnerCorporateData: Scalars['Boolean']['output'];
  defaultVatChargeability: Maybe<DefaultVatChargeabilityEnumDto>;
  depositDepartment: Maybe<DepartmentDto>;
  depositDepartmentId: Maybe<Scalars['Int']['output']>;
  district: Maybe<Scalars['String']['output']>;
  eInvoiceManagerAncillaryField1: Maybe<Scalars['String']['output']>;
  eInvoiceManagerAncillaryField2: Maybe<Scalars['String']['output']>;
  eInvoiceManagerHotelCode: Maybe<Scalars['String']['output']>;
  eInvoiceManagerPasswordSet: Scalars['Boolean']['output'];
  eInvoiceManagerProvider: Maybe<EInvoiceManagerProviderEnumDto>;
  eInvoiceManagerUsername: Maybe<Scalars['String']['output']>;
  eInvoiceNotificationThreshold: Maybe<Scalars['BigDecimal']['output']>;
  eInvoiceTransmitterMail: Maybe<Scalars['String']['output']>;
  eInvoiceTransmitterState: Maybe<Scalars['String']['output']>;
  eInvoiceTransmitterStateId: Maybe<Scalars['Int']['output']>;
  eInvoiceTransmitterTelephone: Maybe<Scalars['String']['output']>;
  eInvoiceTransmitterVATNumber: Maybe<Scalars['String']['output']>;
  eInvoicingAutoCheck: Scalars['Boolean']['output'];
  eInvoicingMode: Maybe<EInvoicingModeEnumDto>;
  fax: Maybe<Scalars['String']['output']>;
  fiscalAddress: Maybe<Scalars['String']['output']>;
  fiscalCity: Maybe<Scalars['String']['output']>;
  fiscalCityId: Maybe<Scalars['Int']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  fiscalDistrict: Maybe<Scalars['String']['output']>;
  /** deprecated - use `fiscalStateId` instead */
  fiscalState: Maybe<Scalars['String']['output']>;
  fiscalStateId: Maybe<Scalars['Int']['output']>;
  fiscalSystem: Maybe<FiscalSystemEnumDto>;
  fiscalZip: Maybe<Scalars['String']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceBlockRules: Maybe<InvoiceBlockRulesDto>;
  liquidationProcess: Maybe<LiquidationProcessEnumDto>;
  mail: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  place: Maybe<Scalars['String']['output']>;
  reaNumber: Maybe<Scalars['String']['output']>;
  reaOffice: Maybe<Scalars['String']['output']>;
  shareCapital: Maybe<Scalars['BigDecimal']['output']>;
  site: Maybe<Scalars['String']['output']>;
  stars: Maybe<Scalars['Int']['output']>;
  /** deprecated - use `stateId` instead */
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
  visualizationOrder: Maybe<Scalars['Int']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type OwnerCreditCardDto = {
  __typename?: 'OwnerCreditCardDTO';
  addCards: Scalars['Boolean']['output'];
  causalCancelPreauth: Maybe<Scalars['String']['output']>;
  causalCharge: Maybe<Scalars['String']['output']>;
  causalConfirm: Maybe<Scalars['String']['output']>;
  causalPreautorization: Maybe<Scalars['String']['output']>;
  causalRefund: Maybe<Scalars['String']['output']>;
  chargeWithoutInvoice: Scalars['Boolean']['output'];
  checkCards: Scalars['Boolean']['output'];
  currencyIsoCode: Scalars['String']['output'];
  defaultOwnerPaymentGatewayId: Maybe<Scalars['Int']['output']>;
  deleteCards: Scalars['Boolean']['output'];
  viewCards: Scalars['Boolean']['output'];
  viewCardsCvv: Scalars['Boolean']['output'];
};

export type OwnerDto = {
  __typename?: 'OwnerDTO';
  aggregateExtraFromPOSInDefaultProduct: Scalars['Boolean']['output'];
  allInclusiveDeduction: Maybe<Scalars['BigDecimal']['output']>;
  allInclusiveDeductionJunior: Maybe<Scalars['BigDecimal']['output']>;
  allInclusiveLunchDeduction: Maybe<Scalars['BigDecimal']['output']>;
  allInclusiveLunchDeductionJunior: Maybe<Scalars['BigDecimal']['output']>;
  allowUnassignedRoom: Scalars['Boolean']['output'];
  alwaysShowGroupDescriptionOnPlanner: Scalars['Boolean']['output'];
  autoCheckOutOnInvoice: Scalars['Boolean']['output'];
  blockFollowsRoomGroup: Scalars['Boolean']['output'];
  blockInvoiceProgressive: Scalars['Boolean']['output'];
  blockInvoicedService: Scalars['Boolean']['output'];
  blockPastService: Scalars['Boolean']['output'];
  blockSavedInvoice: Scalars['Boolean']['output'];
  breakfastDeduction: Maybe<Scalars['BigDecimal']['output']>;
  breakfastDeductionJunior: Maybe<Scalars['BigDecimal']['output']>;
  breakfastVATRate: Maybe<Scalars['BigDecimal']['output']>;
  buildIstatIgnoreDividedStays: Scalars['Boolean']['output'];
  channelManagerAvailability: Scalars['Boolean']['output'];
  /** deprecated */
  channelManagerHotelCode: Maybe<Scalars['String']['output']>;
  channelManagerNotifyMail: Scalars['Boolean']['output'];
  channelManagerNotifyProblemMail: Scalars['Boolean']['output'];
  /** deprecated */
  channelManagerPassword: Maybe<Scalars['String']['output']>;
  channelManagerPrice: Scalars['Boolean']['output'];
  channelManagerProvider: Maybe<Scalars['String']['output']>;
  channelManagerReservation: Scalars['Boolean']['output'];
  channelManagerReservationUpdate: Scalars['Boolean']['output'];
  channelManagerRestriction: Scalars['Boolean']['output'];
  /** deprecated */
  channelManagerUsername: Maybe<Scalars['String']['output']>;
  channelMandatoryOnReservation: Scalars['Boolean']['output'];
  cityTaxDescriptionOnInvoice: Maybe<Scalars['String']['output']>;
  cityTaxMandatoryFields: Scalars['Boolean']['output'];
  conciergeDays1: Maybe<Scalars['Int']['output']>;
  conciergeDays2: Maybe<Scalars['Int']['output']>;
  corpName: Scalars['String']['output'];
  createProductOnCharge: Scalars['Boolean']['output'];
  createProductOnChargeByDescription: Scalars['Boolean']['output'];
  customerCode: Scalars['String']['output'];
  dateFormat: Maybe<Scalars['String']['output']>;
  dateFormatMedium: Maybe<Scalars['String']['output']>;
  dateFormatShort: Maybe<Scalars['String']['output']>;
  defaultFiscalPrinter: Maybe<Scalars['String']['output']>;
  defaultFiscalTray: Maybe<Scalars['Int']['output']>;
  defaultInvoicePrinter: Maybe<Scalars['String']['output']>;
  defaultInvoiceTray: Maybe<Scalars['Int']['output']>;
  defaultPaymentCityTaxId: Maybe<Scalars['Int']['output']>;
  defaultPrinter: Maybe<Scalars['String']['output']>;
  defaultStartFbWithLunch: Scalars['Boolean']['output'];
  defaultTray: Maybe<Scalars['Int']['output']>;
  defaultVATRate: Scalars['BigDecimal']['output'];
  depositHeaderOnInvoice: Maybe<Scalars['String']['output']>;
  dinnerDeduction: Maybe<Scalars['BigDecimal']['output']>;
  dinnerDeductionJunior: Maybe<Scalars['BigDecimal']['output']>;
  dinnerVATRate: Maybe<Scalars['BigDecimal']['output']>;
  disableInvoiceTemporaryProgressive: Scalars['Boolean']['output'];
  disableModifyFromChannelIfOriginalStayChanged: Scalars['Boolean']['output'];
  divideBed: Scalars['Boolean']['output'];
  dividedBedsManagement: Scalars['Boolean']['output'];
  documentFolderOnReservation: Scalars['Boolean']['output'];
  editPriceOnPurchasedStayExtension: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  extraChargeOrderByDate: Scalars['Boolean']['output'];
  fixPriceOnReservationWizard: Scalars['Boolean']['output'];
  generateInvoiceAsDefault: Scalars['Boolean']['output'];
  genericRoomDescriptionOnInvoice: Maybe<Scalars['String']['output']>;
  housekeeperNotesOnReservationWizard: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeImagesOnInvoice: Scalars['Boolean']['output'];
  invoiceExtraDisplayMode: Maybe<InvoiceExtraDisplayModeDto>;
  invoiceRoomDisplayMode: Maybe<InvoiceRoomDisplayModeDto>;
  lastISTATC59Progressive: Maybe<Scalars['Int']['output']>;
  lastPSProgressive: Maybe<Scalars['Int']['output']>;
  limitInvoiceProgressiveAndDate: Scalars['Boolean']['output'];
  lunchDeduction: Maybe<Scalars['BigDecimal']['output']>;
  lunchDeductionJunior: Maybe<Scalars['BigDecimal']['output']>;
  lunchVATRate: Maybe<Scalars['BigDecimal']['output']>;
  mail: Maybe<Scalars['String']['output']>;
  mailAddressFrom: Maybe<Scalars['String']['output']>;
  mailAlias: Maybe<Scalars['String']['output']>;
  mailAuth: Scalars['Boolean']['output'];
  mailBcc: Maybe<Scalars['String']['output']>;
  mailBccCM: Maybe<Scalars['String']['output']>;
  mailCredentialsExternal: Scalars['Boolean']['output'];
  mailEncryptedPassword: Maybe<Scalars['String']['output']>;
  mailOnZeroAvailability: Scalars['Boolean']['output'];
  mailUsername: Maybe<Scalars['String']['output']>;
  masterBillOnFastExtra: Scalars['Boolean']['output'];
  multidbCurrencyId: Maybe<Scalars['Int']['output']>;
  multipleResevationOnGroupWizard: Scalars['Boolean']['output'];
  nf525: Scalars['Boolean']['output'];
  onlyFixedIndexOnPurchasedStay: Scalars['Boolean']['output'];
  otaMessaging: Scalars['Boolean']['output'];
  otaReporting: Scalars['Boolean']['output'];
  ownerCorporateData: Array<OwnerCorporateDataDto>;
  ownerGuestCard: Maybe<OwnerGuestCardDto>;
  ownerHousekeeping: Maybe<OwnerHousekeepingDto>;
  ownerPlanner: Maybe<OwnerPlannerDto>;
  ownerPrivateData: Maybe<OwnerPrivateDataDto>;
  paymentMandatoryOnInvoice: Scalars['Boolean']['output'];
  popupOnSwitchRead: Scalars['Boolean']['output'];
  preselectRoomOnGroupWizard: Scalars['Boolean']['output'];
  psMandatoryDocumentDeadline: Scalars['Boolean']['output'];
  rackMessageMode: Maybe<RackMessageModeDto>;
  receiptDescriptionOnInvoice: Maybe<Scalars['String']['output']>;
  reservationWithDepositStatusId: Maybe<Scalars['Int']['output']>;
  restaurantNotesOnReservationWizard: Scalars['Boolean']['output'];
  roomClientEnabled: Scalars['Boolean']['output'];
  roomNotReadyDays: Maybe<Scalars['Int']['output']>;
  roomNotReadyMode: Maybe<Scalars['Int']['output']>;
  segmentMandatoryOnReservation: Scalars['Boolean']['output'];
  showCityTaxOnBillPreview: Scalars['Boolean']['output'];
  showCouponOnFastExtra: Scalars['Boolean']['output'];
  showCustomersOnInvoice: Scalars['Boolean']['output'];
  showCustomersOnMasterInvoice: Maybe<Scalars['Int']['output']>;
  showDeletedReservationOnlyFromChannelManager: Scalars['Boolean']['output'];
  showDiscountOnInvoice: Scalars['Boolean']['output'];
  /** deprecated - use invoiceExtraDisplayMode instead. Value indicating how to show extra on Invoice */
  showExtraOnInvoice: Maybe<Scalars['Int']['output']>;
  showIbanOnReceipts: Scalars['Boolean']['output'];
  showIdOnInvoice: Scalars['Boolean']['output'];
  showInOutOnMasterInvoice: Scalars['Boolean']['output'];
  showMultilanguageInvoice: Scalars['Boolean']['output'];
  showNotInvoicedDepositDescription: Scalars['Boolean']['output'];
  showPaymentOnReceipt: Scalars['Boolean']['output'];
  showPopupOnGenerateInvoice: Scalars['Boolean']['output'];
  /** deprecated - use invoiceRoomDisplayMode instead. Value indicating how to show Rooms on Invoice */
  showRoomsOnInvoice: Maybe<Scalars['Int']['output']>;
  showTreatmentOnInvoice: Scalars['Boolean']['output'];
  showTreatmentOnMasterInvoice: Scalars['Boolean']['output'];
  showVatOnReceipts: Scalars['Boolean']['output'];
  showZeroRoomOnExtraReceipt: Scalars['Boolean']['output'];
  smtpHost: Maybe<Scalars['String']['output']>;
  smtpPort: Maybe<Scalars['String']['output']>;
  startTls: Scalars['Boolean']['output'];
  stayOnGridsOrderBy: Maybe<StayOrderByDto>;
  /** deprecated - use stayOnGridsOrderBy instead. Value indicating the order of Stay visualization in grids */
  stayOrderOnGrids: Maybe<Scalars['Int']['output']>;
  switchExcludeNumbersFrom: Maybe<Scalars['String']['output']>;
  switchExcludeNumbersTo: Maybe<Scalars['String']['output']>;
  switchHost: Maybe<Scalars['String']['output']>;
  switchModelId: Maybe<Scalars['Int']['output']>;
  switchPort: Maybe<Scalars['String']['output']>;
  switchProductName: Maybe<Scalars['String']['output']>;
  switchType: Maybe<Scalars['Int']['output']>;
  trackAddedBedPriceOnPurchasedStay: Scalars['Boolean']['output'];
  unassignedRoomFromWeb: Scalars['Boolean']['output'];
  useSubAccountOnExtraInsert: Scalars['Boolean']['output'];
  voucherNotes: Maybe<Scalars['Int']['output']>;
};

export type OwnerGridDto = {
  __typename?: 'OwnerGridDTO';
  daysOnAllotmentGrid: Maybe<Scalars['Int']['output']>;
  daysOnPriceGrid: Maybe<Scalars['Int']['output']>;
  daysOnRestrictionGrid: Maybe<Scalars['Int']['output']>;
  daysOnRoomWebGrid: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inventoryOnPriceGrid: Scalars['Boolean']['output'];
  optionOnPriceGrid: Scalars['Boolean']['output'];
  optionOnRoomWebGrid: Scalars['Boolean']['output'];
  ownerId: Scalars['Int']['output'];
  revenueOnPriceGrid: Scalars['Boolean']['output'];
  searchOnAllotmentGrid: Scalars['Boolean']['output'];
  searchOnPriceGrid: Scalars['Boolean']['output'];
  searchOnRestrictionGrid: Scalars['Boolean']['output'];
  searchOnRoomWebGrid: Scalars['Boolean']['output'];
  virtualAsNegativeOnRoomWebGrid: Scalars['Boolean']['output'];
  whatToShowOnAllotmentGrid: Maybe<AllotmentToShowEnumDto>;
};

export type OwnerGuestCardDto = {
  __typename?: 'OwnerGuestCardDTO';
  description: Scalars['String']['output'];
  guestCardDefaultType: Maybe<Scalars['String']['output']>;
  guestCardEncryptedPassword: Maybe<Scalars['String']['output']>;
  guestCardHotelCode: Maybe<Scalars['String']['output']>;
  guestCardProvider: GuestCardProviderDto;
  guestCardUsername: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
};

export type OwnerHousekeepingDto = {
  __typename?: 'OwnerHousekeepingDTO';
  active: Scalars['Boolean']['output'];
  consumptionActive: Scalars['Boolean']['output'];
  defaultDayDisplayed: Maybe<DayDisplayedDto>;
  displayedDayChangeEnabled: Scalars['Boolean']['output'];
  guestAnonymizationEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inspectionEnabled: Scalars['Boolean']['output'];
  laundryActive: Scalars['Boolean']['output'];
  mantainerActive: Scalars['Boolean']['output'];
  ownerId: Scalars['Int']['output'];
  primaryCategory: Maybe<ParameterValueDto>;
  primaryCategory2: Maybe<ParameterValueDto>;
  primaryCategory2Id: Maybe<Scalars['Int']['output']>;
  primaryCategoryId: Maybe<Scalars['Int']['output']>;
  secondaryCategory: Maybe<ParameterValueDto>;
  secondaryCategory2: Maybe<ParameterValueDto>;
  secondaryCategory2Id: Maybe<Scalars['Int']['output']>;
  secondaryCategoryId: Maybe<Scalars['Int']['output']>;
};

export type OwnerIstatDto = {
  __typename?: 'OwnerIstatDTO';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  istatBeds: Maybe<Scalars['String']['output']>;
  istatCode: Maybe<Scalars['String']['output']>;
  istatRooms: Maybe<Scalars['String']['output']>;
  istatToilets: Maybe<Scalars['String']['output']>;
  istatType: IstatTypeDto;
  istatUrl: Maybe<Scalars['String']['output']>;
  istatUser: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  paidCasualWorkers: Maybe<Scalars['Int']['output']>;
  paidRegularWorkers: Maybe<Scalars['Int']['output']>;
  psIstatGroup: Maybe<Scalars['Int']['output']>;
  sendFacilityClosure: Scalars['Boolean']['output'];
  sendIstatClosure: Scalars['Boolean']['output'];
  sendOnline: Scalars['Boolean']['output'];
  unpaidWorkers: Maybe<Scalars['Int']['output']>;
};

export type OwnerPaymentGatewayDto = {
  __typename?: 'OwnerPaymentGatewayDTO';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type OwnerPlannerDto = {
  __typename?: 'OwnerPlannerDTO';
  arrivingReservationBlue: Maybe<Scalars['Int']['output']>;
  arrivingReservationGreen: Maybe<Scalars['Int']['output']>;
  arrivingReservationRed: Maybe<Scalars['Int']['output']>;
  boldIfDifferentStay: Scalars['Boolean']['output'];
  borderIfRoomChange: Scalars['Boolean']['output'];
  calendarBlue: Maybe<Scalars['Int']['output']>;
  calendarGreen: Maybe<Scalars['Int']['output']>;
  calendarRed: Maybe<Scalars['Int']['output']>;
  checkInReservationBlue: Maybe<Scalars['Int']['output']>;
  checkInReservationGreen: Maybe<Scalars['Int']['output']>;
  checkInReservationRed: Maybe<Scalars['Int']['output']>;
  closeHour: Maybe<Scalars['Int']['output']>;
  defaultReservationBlue: Maybe<Scalars['Int']['output']>;
  defaultReservationGreen: Maybe<Scalars['Int']['output']>;
  defaultReservationRed: Maybe<Scalars['Int']['output']>;
  firstColumnBlue: Maybe<Scalars['Int']['output']>;
  firstColumnGreen: Maybe<Scalars['Int']['output']>;
  firstColumnRed: Maybe<Scalars['Int']['output']>;
  hoursOperatorMandatory: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  openHour: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['Int']['output'];
  roomOrderOnPlanner: Maybe<Scalars['Int']['output']>;
  saturdayBlue: Maybe<Scalars['Int']['output']>;
  saturdayGreen: Maybe<Scalars['Int']['output']>;
  saturdayHeaderBlue: Maybe<Scalars['Int']['output']>;
  saturdayHeaderGreen: Maybe<Scalars['Int']['output']>;
  saturdayHeaderRed: Maybe<Scalars['Int']['output']>;
  saturdayRed: Maybe<Scalars['Int']['output']>;
  showAvailableRooms: Scalars['Boolean']['output'];
  showDamages: Scalars['Boolean']['output'];
  showHousekeepingStatus: Scalars['Boolean']['output'];
  showRoomPreparation: Scalars['Boolean']['output'];
  showStay: Scalars['Boolean']['output'];
  sundayBlue: Maybe<Scalars['Int']['output']>;
  sundayGreen: Maybe<Scalars['Int']['output']>;
  sundayHeaderBlue: Maybe<Scalars['Int']['output']>;
  sundayHeaderGreen: Maybe<Scalars['Int']['output']>;
  sundayHeaderRed: Maybe<Scalars['Int']['output']>;
  sundayRed: Maybe<Scalars['Int']['output']>;
  todayBlue: Maybe<Scalars['Int']['output']>;
  todayGreen: Maybe<Scalars['Int']['output']>;
  todayHeaderBlue: Maybe<Scalars['Int']['output']>;
  todayHeaderGreen: Maybe<Scalars['Int']['output']>;
  todayHeaderRed: Maybe<Scalars['Int']['output']>;
  todayRed: Maybe<Scalars['Int']['output']>;
  visibilityDays: Maybe<Scalars['Int']['output']>;
};

export type OwnerPrivateDataDto = {
  __typename?: 'OwnerPrivateDataDTO';
  activationCode: Scalars['String']['output'];
  citiesCountryCode: Maybe<Scalars['String']['output']>;
  cityLanguageCode: Maybe<Scalars['String']['output']>;
  documentTypesCountryCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mixPanelEnabled: Scalars['Boolean']['output'];
  ownerId: Scalars['Int']['output'];
  stateLanguageCode: Maybe<Scalars['String']['output']>;
  webFunctionalitiesEnabled: Scalars['Boolean']['output'];
};

export type OwnerPublicSecurityDto = {
  __typename?: 'OwnerPublicSecurityDTO';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
  psCode: Maybe<Scalars['String']['output']>;
  psEncryptedPassword: Maybe<Scalars['String']['output']>;
  psIstatGroup: Maybe<Scalars['Int']['output']>;
  psKey: Maybe<Scalars['String']['output']>;
  psWithRoomId: Scalars['Boolean']['output'];
  publicSecurityType: PublicSecurityTypeDto;
  sendOnline: Scalars['Boolean']['output'];
};

export type PacketDto = ResourceDto & {
  __typename?: 'PacketDTO';
  ageAddedJuniorBed: Maybe<Scalars['Int']['output']>;
  allInclusive: Scalars['Boolean']['output'];
  applicateAllStay: Scalars['Boolean']['output'];
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  beginSell: Maybe<Scalars['LocalDate']['output']>;
  beginValidity: Maybe<Scalars['LocalDate']['output']>;
  breakfast: Scalars['Boolean']['output'];
  cancellationPolicyId: Maybe<Scalars['Int']['output']>;
  checkInFriday: Scalars['Boolean']['output'];
  checkInMonday: Scalars['Boolean']['output'];
  checkInSaturday: Scalars['Boolean']['output'];
  checkInSunday: Scalars['Boolean']['output'];
  checkInThursday: Scalars['Boolean']['output'];
  checkInTuesday: Scalars['Boolean']['output'];
  checkInWednesday: Scalars['Boolean']['output'];
  checkOutFriday: Scalars['Boolean']['output'];
  checkOutMonday: Scalars['Boolean']['output'];
  checkOutSaturday: Scalars['Boolean']['output'];
  checkOutSunday: Scalars['Boolean']['output'];
  checkOutThursday: Scalars['Boolean']['output'];
  checkOutTuesday: Scalars['Boolean']['output'];
  checkOutWednesday: Scalars['Boolean']['output'];
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  dinner: Scalars['Boolean']['output'];
  discount: Maybe<Scalars['BigDecimal']['output']>;
  discountDecimalsRounding: Maybe<Scalars['Int']['output']>;
  earlyBird: Maybe<Scalars['Int']['output']>;
  endSell: Maybe<Scalars['LocalDate']['output']>;
  endValidity: Maybe<Scalars['LocalDate']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  extraAllInclusive: Maybe<Scalars['BigDecimal']['output']>;
  extraBreakfast: Maybe<Scalars['BigDecimal']['output']>;
  extraDinner: Maybe<Scalars['BigDecimal']['output']>;
  extraLunch: Maybe<Scalars['BigDecimal']['output']>;
  extraParameters: Scalars['Boolean']['output'];
  firstAddedNight: Maybe<Scalars['BigDecimal']['output']>;
  hideDiscountOnBol: Scalars['Boolean']['output'];
  hideFullRateOnBol: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastMinute: Maybe<Scalars['Int']['output']>;
  lunch: Scalars['Boolean']['output'];
  maximumStay: Maybe<Scalars['Int']['output']>;
  minimumStay: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  numberOfNights: Maybe<Scalars['Int']['output']>;
  offerId: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['Int']['output'];
  priceAddedBed: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedJuniorBed: Maybe<Scalars['BigDecimal']['output']>;
  priceLists: Array<PriceListDto>;
  promoCode: Maybe<Scalars['String']['output']>;
  secondAddedNight: Maybe<Scalars['BigDecimal']['output']>;
  showInShowcase: Scalars['Boolean']['output'];
  stay: Maybe<StayDto>;
  stayId: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
  webAvailable: Scalars['Boolean']['output'];
  webOrder: Maybe<Scalars['Int']['output']>;
  weekendExtra: Maybe<Scalars['BigDecimal']['output']>;
};

export type PacketDataDto = {
  __typename?: 'PacketDataDTO';
  mainImageMaxHeight: Maybe<Scalars['Int']['output']>;
  mainImageMaxWidth: Maybe<Scalars['Int']['output']>;
  mainImageUrl: Maybe<Scalars['String']['output']>;
  packetId: Scalars['Int']['output'];
};

export type PaginationDto = {
  __typename?: 'PaginationDTO';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ParameterDto = {
  __typename?: 'ParameterDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parameterValues: Array<ParameterValueDto>;
};

export type ParameterValueDto = {
  __typename?: 'ParameterValueDTO';
  id: Scalars['Int']['output'];
  parameterId: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type PartialPaymentDto = {
  __typename?: 'PartialPaymentDTO';
  amount: Scalars['BigDecimal']['output'];
  date: Scalars['LocalDate']['output'];
  id: Scalars['Int']['output'];
  invoiceId: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  paymentId: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type PaymentTermsDto = {
  __typename?: 'PaymentTermsDTO';
  endOfMonth: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  numberOfDays: Scalars['Int']['output'];
  type: PaymentTermsEnumDto;
};

export enum PaymentTermsEnumDto {
  D14 = 'D14',
  D30 = 'D30',
  D30Eom = 'D30_EOM',
  D60 = 'D60',
  D60Eom = 'D60_EOM',
  D90 = 'D90',
  D90Eom = 'D90_EOM',
  D120 = 'D120',
  D120Eom = 'D120_EOM'
}

export enum PenaltyTypeEnumDto {
  Fixed = 'FIXED',
  Nights = 'NIGHTS',
  Percentage = 'PERCENTAGE'
}

export type PreauthorizeRequestDtoInput = {
  /** Amount to put on hold. getCreditCards suggests it in suggestedPreauthAmount and the user may change it before confirming */
  amount: Scalars['BigDecimal']['input'];
  /** Omit it to get the causalPreautorization of getOwnerCreditCard, which is what the form prefills. An empty string is stored as such: a user who clears the field wants no causal */
  causal?: InputMaybe<Scalars['String']['input']>;
  /** CreditCardRowDTO.id of the card to put the hold on */
  creditCardId: Scalars['Int']['input'];
  /** Free text, none by default */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Which active gateway to use, from getActiveOwnerPaymentGateways. Left out, the default gateway of the property is used */
  ownerPaymentGatewayId?: InputMaybe<Scalars['Int']['input']>;
  /** The resource the window was opened from, the same one passed to getCreditCards. Preauthorizing is offered on a reservation only */
  resource: GetCreditCardsRequestDtoInput;
};

export type PriceGetCalendarPriceRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  stayPriceInput: Array<StayPriceInputDtoInput>;
};

export type PriceInfoDtoInput = {
  price: Scalars['BigDecimal']['input'];
  priceListId: Scalars['Int']['input'];
  stayId: Scalars['Int']['input'];
};

export type PriceListDto = {
  __typename?: 'PriceListDTO';
  addedBedFixed: Scalars['Boolean']['output'];
  addedJuniorBedFixed: Scalars['Boolean']['output'];
  addedJuniorBedFixed2: Scalars['Boolean']['output'];
  addedJuniorBedFixed3: Scalars['Boolean']['output'];
  ageAddedCradle: Maybe<Scalars['Int']['output']>;
  ageAddedJuniorBed: Maybe<Scalars['Int']['output']>;
  ageAddedJuniorBed2: Maybe<Scalars['Int']['output']>;
  ageAddedJuniorBed3: Maybe<Scalars['Int']['output']>;
  allInclusive: Scalars['Boolean']['output'];
  breakfast: Scalars['Boolean']['output'];
  cancellationPolicyId: Maybe<Scalars['Int']['output']>;
  channelManagerCode: Maybe<Scalars['String']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  dinner: Scalars['Boolean']['output'];
  estimateAvailable: Scalars['Boolean']['output'];
  extraAllInclusive: Maybe<Scalars['BigDecimal']['output']>;
  extraAllInclusiveCradle: Maybe<Scalars['BigDecimal']['output']>;
  extraAllInclusiveJunior: Maybe<Scalars['BigDecimal']['output']>;
  extraAllInclusiveJunior2: Maybe<Scalars['BigDecimal']['output']>;
  extraAllInclusiveJunior3: Maybe<Scalars['BigDecimal']['output']>;
  extraBedDecimalsRounding: Maybe<Scalars['Int']['output']>;
  extraBedParameters: Scalars['Boolean']['output'];
  extraBreakfast: Maybe<Scalars['BigDecimal']['output']>;
  extraBreakfastCradle: Maybe<Scalars['BigDecimal']['output']>;
  extraBreakfastJunior: Maybe<Scalars['BigDecimal']['output']>;
  extraBreakfastJunior2: Maybe<Scalars['BigDecimal']['output']>;
  extraBreakfastJunior3: Maybe<Scalars['BigDecimal']['output']>;
  extraDinner: Maybe<Scalars['BigDecimal']['output']>;
  extraDinnerCradle: Maybe<Scalars['BigDecimal']['output']>;
  extraDinnerJunior: Maybe<Scalars['BigDecimal']['output']>;
  extraDinnerJunior2: Maybe<Scalars['BigDecimal']['output']>;
  extraDinnerJunior3: Maybe<Scalars['BigDecimal']['output']>;
  extraGuestParameters: Scalars['Boolean']['output'];
  extraLunch: Maybe<Scalars['BigDecimal']['output']>;
  extraLunchCradle: Maybe<Scalars['BigDecimal']['output']>;
  extraLunchJunior: Maybe<Scalars['BigDecimal']['output']>;
  extraLunchJunior2: Maybe<Scalars['BigDecimal']['output']>;
  extraLunchJunior3: Maybe<Scalars['BigDecimal']['output']>;
  extraMealParameters: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoiceDefaultBuilding: Maybe<InvoiceDefaultBuildingDto>;
  lunch: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  numberOfGuests: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['Int']['output'];
  perPerson: Scalars['Boolean']['output'];
  priceAddedBed: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedCradle: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedJuniorBed: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedJuniorBed2: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedJuniorBed3: Maybe<Scalars['BigDecimal']['output']>;
  publicDescriptionDe: Maybe<Scalars['String']['output']>;
  publicDescriptionEn: Maybe<Scalars['String']['output']>;
  publicDescriptionEs: Maybe<Scalars['String']['output']>;
  publicDescriptionFr: Maybe<Scalars['String']['output']>;
  publicDescriptionIt: Maybe<Scalars['String']['output']>;
  rateGroupId: Maybe<Scalars['Int']['output']>;
  rateManagerCode: Maybe<Scalars['String']['output']>;
  realPriceListId: Maybe<Scalars['Int']['output']>;
  releaseDays: Maybe<Scalars['Int']['output']>;
  releaseHour: Maybe<Scalars['Int']['output']>;
  sendChannelManagerPrice: Scalars['Boolean']['output'];
  sendChannelManagerRestrictions: Scalars['Boolean']['output'];
  showDescriptionOnInvoice: Scalars['Boolean']['output'];
  virtual: Scalars['Boolean']['output'];
  virtualDecimalsRounding: Maybe<Scalars['Int']['output']>;
  virtualModifier: Maybe<Scalars['BigDecimal']['output']>;
  virtualModifierPerPerson: Scalars['Boolean']['output'];
  virtualType: Maybe<Scalars['Int']['output']>;
  virtualTypeEnum: Maybe<VirtualTypeEnumDto>;
  webAvailable: Scalars['Boolean']['output'];
};

export enum PriceModeEnumDto {
  KeepCurrent = 'KEEP_CURRENT',
  RecalculateFromPriceList = 'RECALCULATE_FROM_PRICE_LIST',
  SetCustom = 'SET_CUSTOM'
}

export type ProductDto = ResourceDto & {
  __typename?: 'ProductDTO';
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  category2Id: Maybe<Scalars['Int']['output']>;
  categoryId: Maybe<Scalars['Int']['output']>;
  channelManagerCode: Maybe<Scalars['String']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  priceLists: Array<PriceListDto>;
  reorder: Maybe<Scalars['Int']['output']>;
  stock: Maybe<Scalars['Int']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
  webAvailable: Scalars['Boolean']['output'];
  /** deprecated - moved to ProductDataDTO */
  webMandatory: Scalars['Boolean']['output'];
  /** deprecated - moved to ProductDataDTO */
  webOrder: Maybe<Scalars['Int']['output']>;
};

export type ProductDataDto = {
  __typename?: 'ProductDataDTO';
  mainImageMaxHeight: Maybe<Scalars['Int']['output']>;
  mainImageMaxWidth: Maybe<Scalars['Int']['output']>;
  mainImageUrl: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  webMandatory: Maybe<Scalars['Boolean']['output']>;
  webMandatoryRule: Maybe<WebMandatoryRuleEnumDto>;
  webMaxPurchasableRule: Maybe<WebMaxPurchasableRuleEnumDto>;
  webOrder: Maybe<Scalars['Int']['output']>;
};

export type PsCustomerDto = {
  __typename?: 'PsCustomerDTO';
  EInvoicingCode: Maybe<Scalars['String']['output']>;
  /** the difference between the current date and the entered date must be >= 7 */
  birthDate: Maybe<Scalars['LocalDate']['output']>;
  birthDistrict: Maybe<Scalars['String']['output']>;
  birthPlace: Maybe<Scalars['String']['output']>;
  birthPlaceId: Maybe<Scalars['Int']['output']>;
  birthState: Maybe<Scalars['String']['output']>;
  birthStateId: Maybe<Scalars['Int']['output']>;
  checkIn: Scalars['LocalDate']['output'];
  checkOut: Scalars['LocalDate']['output'];
  creditCardId: Maybe<Scalars['Int']['output']>;
  customerCode: Maybe<Scalars['String']['output']>;
  customerData: CustomerDataDto;
  customerDataId: Maybe<Scalars['Int']['output']>;
  documentDeadlineDate: Maybe<Scalars['LocalDate']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  documentReleaseDate: Maybe<Scalars['LocalDate']['output']>;
  documentReleaser: Maybe<Scalars['String']['output']>;
  documentReleaserCityId: Maybe<Scalars['Int']['output']>;
  documentReleaserState: Scalars['Boolean']['output'];
  documentReleaserStateId: Maybe<Scalars['Int']['output']>;
  documentType: Maybe<Scalars['String']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  leader: Scalars['Boolean']['output'];
  /** if set it must be 8 characters long */
  lotteryCode: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  multidbDocumentTypeId: Maybe<Scalars['Int']['output']>;
  /** if set it must not contain: #, &, $, £, %, <, > */
  name: Maybe<Scalars['String']['output']>;
  nationality: Maybe<Scalars['String']['output']>;
  nationalityId: Maybe<Scalars['Int']['output']>;
  numberOfNights: Scalars['Int']['output'];
  password: Maybe<Scalars['String']['output']>;
  pec: Maybe<Scalars['String']['output']>;
  publicSecurityStatus: PublicSecurityStatusDto;
  purchasedStayToCustomer: PurchasedStayToCustomerDto;
  relatives: Array<CustomerDto>;
  room: Scalars['String']['output'];
  roomObj: RoomDto;
  sex: Scalars['Boolean']['output'];
  state: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  /** it must not contain: #, &, $, £, %, <, > */
  surname: Scalars['String']['output'];
  validationResults: Array<ResourceValidationResultDto>;
  vatCountryCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export enum PublicSecurityStatusDto {
  NotSent = 'NOT_SENT',
  SentError = 'SENT_ERROR',
  SentOk = 'SENT_OK'
}

export type PublicSecurityTypeDto = {
  __typename?: 'PublicSecurityTypeDTO';
  countryCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  printable: Scalars['Boolean']['output'];
  printableBlank: Scalars['Boolean']['output'];
  receipt: Scalars['Boolean']['output'];
  sendFile: Scalars['Boolean']['output'];
  sendOnline: Scalars['Boolean']['output'];
  type: PublicSecurityTypeEnum;
};

export enum PublicSecurityTypeEnum {
  AlloggiatiWeb = 'ALLOGGIATI_WEB',
  AlloggiatiWebSanMarino = 'ALLOGGIATI_WEB_SAN_MARINO',
  France = 'FRANCE',
  NotifichePernottamentiTicino = 'NOTIFICHE_PERNOTTAMENTI_TICINO',
  RegistreViatgers = 'REGISTRE_VIATGERS',
  RegistroViajeros = 'REGISTRO_VIAJEROS',
  Swiss = 'SWISS'
}

export type PurchasedOptionalDto = ServiceDto & {
  __typename?: 'PurchasedOptionalDTO';
  beginDate: Scalars['LocalDate']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endDate: Scalars['LocalDate']['output'];
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  optional: OptionalDto;
  optionalId: Scalars['Int']['output'];
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
  travelInsuranceCouponId: Maybe<Scalars['Int']['output']>;
};

export type PurchasedPacketDto = ServiceDto & {
  __typename?: 'PurchasedPacketDTO';
  beginDate: Scalars['LocalDate']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  packet: PacketDto;
  packetId: Scalars['Int']['output'];
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
};

export type PurchasedProductDto = ServiceDto & {
  __typename?: 'PurchasedProductDTO';
  beginDate: Maybe<Scalars['LocalDate']['output']>;
  chargeCode: Maybe<Scalars['String']['output']>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['LocalDate']['output']>;
  fromChannelManager: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  product: ProductDto;
  productId: Scalars['Int']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  reservation: Maybe<ReservationDto>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type PurchasedStayDto = ServiceDto & {
  __typename?: 'PurchasedStayDTO';
  addedBed: Maybe<Scalars['Int']['output']>;
  addedBedCharge: Maybe<Scalars['BigDecimal']['output']>;
  addedJuniorBed: Maybe<Scalars['Int']['output']>;
  addedJuniorBed2: Maybe<Scalars['Int']['output']>;
  addedJuniorBed2Charge: Maybe<Scalars['BigDecimal']['output']>;
  addedJuniorBed3: Maybe<Scalars['Int']['output']>;
  addedJuniorBed3Charge: Maybe<Scalars['BigDecimal']['output']>;
  addedJuniorBedCharge: Maybe<Scalars['BigDecimal']['output']>;
  agencyVoucher: Maybe<Scalars['String']['output']>;
  allInclusive: Scalars['Boolean']['output'];
  arrival: Maybe<Scalars['LocalTime']['output']>;
  beginDate: Scalars['LocalDate']['output'];
  breakfast: Scalars['Boolean']['output'];
  channelManagerIdForManualReservation: Maybe<Scalars['String']['output']>;
  checkInDone: Scalars['Boolean']['output'];
  checkInReady: Scalars['Boolean']['output'];
  checkOutDone: Scalars['Boolean']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  cradle: Maybe<Scalars['Int']['output']>;
  cradleCharge: Maybe<Scalars['BigDecimal']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  dayPrices: Array<DayPriceDto>;
  departure: Maybe<Scalars['LocalTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  dinner: Scalars['Boolean']['output'];
  discount: Maybe<Scalars['BigDecimal']['output']>;
  discountFixed: Scalars['Boolean']['output'];
  divideBed: Scalars['Boolean']['output'];
  doorLockCode: Maybe<Scalars['String']['output']>;
  endDate: Scalars['LocalDate']['output'];
  housekeeperNotes: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  lodgedCustomers: Scalars['String']['output'];
  lunch: Scalars['Boolean']['output'];
  masterServiceId: Maybe<Scalars['Int']['output']>;
  numberOfGuests: Scalars['Int']['output'];
  originalStay: Maybe<StayDto>;
  originalStayId: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  pricePerPerson: Maybe<Scalars['BigDecimal']['output']>;
  proposalId: Maybe<Scalars['Int']['output']>;
  purchasedPacket: Maybe<PurchasedPacketDto>;
  purchasedPacketId: Maybe<Scalars['Int']['output']>;
  purchasedStayPeriods: Array<PurchasedStayPeriodDto>;
  purchasedStayToCustomers: Array<PurchasedStayToCustomerDto>;
  rackMessage: Maybe<Scalars['String']['output']>;
  reservation: Maybe<ReservationDto>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
  restaurantNotes: Maybe<Scalars['String']['output']>;
  room: Maybe<RoomDto>;
  roomGadget2Id: Maybe<Scalars['Int']['output']>;
  roomGadgetId: Maybe<Scalars['Int']['output']>;
  roomId: Maybe<Scalars['Int']['output']>;
  roomLocked: Scalars['Boolean']['output'];
  roomPreparationId: Maybe<Scalars['Int']['output']>;
  startFbWithLunch: Scalars['Boolean']['output'];
  stay: StayDto;
  stayId: Scalars['Int']['output'];
  travelInsuranceCouponId: Maybe<Scalars['Int']['output']>;
  treatment: Scalars['String']['output'];
};

export type PurchasedStayExtendedDto = {
  __typename?: 'PurchasedStayExtendedDTO';
  agency: Maybe<AgencyDto>;
  company: Maybe<CompanyDto>;
  mainCustomer: Maybe<CustomerDto>;
  purchasedStay: Maybe<PurchasedStayDto>;
  status: Maybe<PurchasedStayStatusEnumDto>;
};

export type PurchasedStayExtendedListPaginatedDto = {
  __typename?: 'PurchasedStayExtendedListPaginatedDTO';
  pagination: PaginationDto;
  purchasedStays: Array<PurchasedStayExtendedDto>;
};

export type PurchasedStayMoveAndStretchRequestDtoInput = {
  addedBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed2Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed3Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  beginDate: Scalars['LocalDate']['input'];
  cradleCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  dayPrices?: InputMaybe<Array<InputMaybe<UpsertDayPriceDtoInput>>>;
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountFixed?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['LocalDate']['input'];
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  purchasedStayId: Scalars['Int']['input'];
  purchasedStayPeriods?: InputMaybe<Array<InputMaybe<UpsertPurchasedStayPeriodDtoInput>>>;
  roomId: Scalars['Int']['input'];
};

export type PurchasedStayPeriodDto = {
  __typename?: 'PurchasedStayPeriodDTO';
  allInclusive: Scalars['Boolean']['output'];
  beginDay: Scalars['Int']['output'];
  breakfast: Scalars['Boolean']['output'];
  dinner: Scalars['Boolean']['output'];
  endDay: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lunch: Scalars['Boolean']['output'];
  priceListId: Scalars['Int']['output'];
  purchasedStayId: Scalars['Int']['output'];
};

export type PurchasedStayPeriodPlannerDto = {
  __typename?: 'PurchasedStayPeriodPlannerDTO';
  allInclusive: Scalars['Boolean']['output'];
  beginDay: Scalars['Int']['output'];
  breakfast: Scalars['Boolean']['output'];
  dinner: Scalars['Boolean']['output'];
  endDay: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lunch: Scalars['Boolean']['output'];
  priceListId: Scalars['Int']['output'];
  purchasedStayId: Scalars['Int']['output'];
};

export type PurchasedStayPlannerDto = {
  __typename?: 'PurchasedStayPlannerDTO';
  beginDate: Scalars['LocalDate']['output'];
  checkInDone: Scalars['Boolean']['output'];
  checkOutDone: Scalars['Boolean']['output'];
  creation: Scalars['LocalDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  divideBed: Scalars['Boolean']['output'];
  endDate: Scalars['LocalDate']['output'];
  id: Scalars['Int']['output'];
  invoiced: Scalars['Boolean']['output'];
  numberOfGuests: Scalars['Int']['output'];
  originalStay: Maybe<StayPlannerDto>;
  price: Maybe<Scalars['BigDecimal']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  purchasedStayPeriods: Array<PurchasedStayPeriodPlannerDto>;
  purchasedStayToCustomers: Array<PurchasedStayToCustomerPlannerDto>;
  rackMessage: Maybe<Scalars['String']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  room: Maybe<RoomPlannerDto>;
  roomLocked: Scalars['Boolean']['output'];
  stay: StayPlannerDto;
  treatment: Maybe<Scalars['String']['output']>;
};

export enum PurchasedStayStatusEnumDto {
  Arrival = 'ARRIVAL',
  Checkin = 'CHECKIN',
  CheckinCheckoutFuture = 'CHECKIN_CHECKOUT_FUTURE',
  CheckoutInvoiced = 'CHECKOUT_INVOICED',
  CheckoutNotInvoiced = 'CHECKOUT_NOT_INVOICED',
  Future = 'FUTURE'
}

export type PurchasedStayToCustomerDto = {
  __typename?: 'PurchasedStayToCustomerDTO';
  /** when both dates are blank it means it is valid for the whole stay */
  beginDay: Maybe<Scalars['Int']['output']>;
  customer: CustomerDto;
  customerId: Scalars['Int']['output'];
  /** when both dates are blank it means it is valid for the whole stay */
  endDay: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  istatErrorCode: Maybe<Scalars['String']['output']>;
  istatErrorDescription: Maybe<Scalars['String']['output']>;
  istatErrorDetail: Maybe<Scalars['String']['output']>;
  istatStatus: Maybe<IstatStatusDto>;
  /** deprecated - use istatStatus instead */
  istatStatusId: Maybe<Scalars['Int']['output']>;
  psErrorCode: Maybe<Scalars['String']['output']>;
  psErrorDescription: Maybe<Scalars['String']['output']>;
  psErrorDetail: Maybe<Scalars['String']['output']>;
  psStatus: Maybe<PublicSecurityStatusDto>;
  /** deprecated - use psStatus instead */
  psStatusId: Maybe<Scalars['Int']['output']>;
  purchasedStayId: Scalars['Int']['output'];
};

export type PurchasedStayToCustomerPlannerDto = {
  __typename?: 'PurchasedStayToCustomerPlannerDTO';
  customer: CustomerPlannerDto;
  id: Scalars['Int']['output'];
  purchasedStayId: Scalars['Int']['output'];
};

export type PurchasedStayToCustomerWithValidationDto = {
  __typename?: 'PurchasedStayToCustomerWithValidationDTO';
  purchasedStayToCustomer: Maybe<PurchasedStayToCustomerDto>;
  validationResults: Maybe<Array<Maybe<ResourceValidationResultDto>>>;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  alignDayPricesToDates: Array<GeneratedDayPriceDto>;
  /** Build a credit note for cash register */
  buildCashRegisterCreditNote: Maybe<CashRegisterCreditNoteDto>;
  /** Build a receipt for cash register */
  buildCashRegisterReceipt: Maybe<CashRegisterReceiptDto>;
  buildCreditNote: BuildCreditNoteResponseDto;
  buildDepositInvoiceObject: GeneratedInvoiceDto;
  buildInvoiceObject: GeneratedInvoiceDto;
  calcDayPrices: Array<GeneratedDayPriceDto>;
  calcFiscalCode: Scalars['String']['output'];
  calculateCityTax: Array<GeneratedInvoicedCityTaxDto>;
  calculateCityTaxAmount: Scalars['BigDecimal']['output'];
  calculateCityTaxByList: Array<GeneratedInvoicedCityTaxDto>;
  calculatePrice: Scalars['BigDecimal']['output'];
  calculatePriceListPrice: Scalars['BigDecimal']['output'];
  calculatePurchasedProductPrice: Scalars['BigDecimal']['output'];
  calculateWebPacketPriceFromWeb: Scalars['BigDecimal']['output'];
  checkAskHolder: Scalars['Boolean']['output'];
  checkAstatDailyGuestsInClosurePeriod: CheckAstatDailyGuestsInClosurePeriodResponseDto;
  checkAvailability: Scalars['Boolean']['output'];
  checkAvailabilityRoom: Scalars['Boolean']['output'];
  checkFiscalDayNotClosed: Scalars['Boolean']['output'];
  /** Given a corpName and/or a VAT number, return a list of AgencyDTO with same corpName, excluding the one (if present) with the same id of idToExclude. At least one of corpName or vatNumber must be provided */
  checkForDuplicateAgency: Array<AgencyDto>;
  /** Given a corpName and/or a VAT number, return a list of CompanyDTO with same corpName, excluding the one (if present) with the same id of idToExclude. At least one of corpName or vatNumber must be provided */
  checkForDuplicateCompany: Array<CompanyDto>;
  /** Given a surname and a name (optional), return a list of CustomerDTO with same surname/name, excluding the one (if present) with the same id of idToExclude. Also idToExclude is optional */
  checkForDuplicateCustomers: Array<CustomerDto>;
  checkFullAvailabilityOwner: Array<RoomDto>;
  checkFullAvailabilityStay: Array<RoomDto>;
  checkLoginElectronicInvoice: Scalars['Boolean']['output'];
  checkProgressive: Scalars['Boolean']['output'];
  checkServicesOutsidePurchasedStayDates: Scalars['Boolean']['output'];
  checkShorterLinkedOptional: Scalars['Boolean']['output'];
  checkSimpleInventory: Array<StayDailyInventoryDto>;
  checkTransferService: Maybe<CheckTransferServiceResponseDto>;
  checkTransferServices: Array<CheckTransferServicesItemDto>;
  checkVat: CheckVatResponseDto;
  extractCustomersAndHolders: Array<InvoiceHolderDto>;
  findInvoicesByElementOrCityTaxServiceId: Array<InvoiceDto>;
  getAccountingMovementReportGenerationParameters: GetAccountingMovementReportGenerationParametersResponseDto;
  getAccountingReportGenerationParameters: GetAccountingReportGenerationParametersResponseDto;
  getActiveInvoiceBlocks: InvoiceBlockRulesDto;
  getActiveOwnerPaymentGateways: Array<OwnerPaymentGatewayDto>;
  /** URL of the page that acquires a new card, to be opened in an iframe. The card is registered by the tokenizer callback, not by this call: reload getCreditCards when the page signals that it is done */
  getAddCardUrl: CardUrlDto;
  getAgency: Maybe<AgencyDto>;
  /** deprecated - use getAllOwnerAvailableOptional instead */
  getAllAvailableOptional: Array<OptionalDto>;
  getAllCategories: Array<ParameterValueDto>;
  getAllCategories2: Array<ParameterValueDto>;
  getAllCityTaxExemption: Array<CityTaxExemptionDto>;
  getAllCostCenter: Array<CostCenterDto>;
  getAllDamageTypes: Array<ParameterValueDto>;
  getAllDepartment: Array<DepartmentDto>;
  getAllDocumentType: Array<DocumentTypeDto>;
  getAllFacilities: Array<ParameterValueDto>;
  getAllInterests: Array<ParameterValueDto>;
  getAllInvoiceBlocks: InvoiceBlockRulesDto;
  getAllLinens: Array<ParameterValueDto>;
  getAllManualCityTaxExemption: Array<CityTaxExemptionDto>;
  getAllModelTypes: Array<ParameterValueDto>;
  /** deprecated - use getAllOwnerNonWebPacket instead */
  getAllNonWebPacket: Array<PacketDto>;
  /** deprecated - use getAllOwnerOptional instead */
  getAllOptional: Array<OptionalDto>;
  getAllOwnerAvailableOptional: Array<OptionalDto>;
  getAllOwnerAvailablePacket: Array<PacketDto>;
  getAllOwnerAvailableProduct: Array<ProductDto>;
  getAllOwnerAvailableRealStay: Array<StayDto>;
  getAllOwnerAvailableStay: Array<StayDto>;
  getAllOwnerCityTax: Array<OwnerCityTaxDto>;
  getAllOwnerCorporateData: Array<OwnerCorporateDataDto>;
  getAllOwnerIstat: Array<OwnerIstatDto>;
  getAllOwnerNonWebPacket: Array<PacketDto>;
  getAllOwnerOptional: Array<OptionalDto>;
  getAllOwnerPacket: Array<PacketDto>;
  getAllOwnerPublicSecurity: Array<OwnerPublicSecurityDto>;
  getAllOwnerRoom: Array<RoomDto>;
  getAllOwnerStay: Array<StayDto>;
  getAllOwnerWebAvailableOptional: Array<OptionalDto>;
  getAllOwnerWebAvailableStay: Array<StayDto>;
  getAllParameters: Array<ParameterDto>;
  getAllPayments: Array<ParameterValueDto>;
  getAllPriceList: Maybe<Array<Maybe<PriceListDto>>>;
  getAllPrimaryCost: Array<CostCenterDto>;
  getAllProfessions: Array<ParameterValueDto>;
  getAllResStatus: Array<ResStatusDto>;
  getAllReservationWizardRateByOwner: Array<Maybe<ReservationWizardRateMapDto>>;
  getAllReservationWizardRateByStay: Array<Maybe<ReservationWizardRateDto>>;
  getAllRoomAmenity: Array<RoomAmenityDto>;
  getAllRoomGadgets: Array<ParameterValueDto>;
  getAllRoomPreparations: Array<ParameterValueDto>;
  getAllRoomStatus: Array<RoomStatusDto>;
  getAllSecondaryCost: Array<CostCenterDto>;
  getAllSegment: Array<SegmentDto>;
  getAllState: Array<StateDto>;
  getAllTitles: Array<ParameterValueDto>;
  getAllTransports: Array<ParameterValueDto>;
  getAllVatRate: Array<VatRateDto>;
  /** deprecated - use getAllOwnerWebAvailableOptional instead */
  getAllWebAvailableOptional: Array<OptionalDto>;
  getAstatDailyClosureDay: GetAstatDailyClosureDayResponseDto;
  getAstatDailyLocalTaxInfo: AstatDailyLocalTaxInfoDto;
  getCalendarPrice: Maybe<Array<StayToPriceListPricesDto>>;
  getCancellationPolicy: Maybe<CancellationPolicyDto>;
  getCancellationPolicyInitParameters: CancellationPolicyInitParametersResponseDto;
  getCashRegister: Maybe<CashRegisterDto>;
  getCashRegisterConfigurablePayments: Maybe<Array<Maybe<CashRegisterConfigurablePaymentDto>>>;
  getChannel: Maybe<ChannelDto>;
  getCity: CityDto;
  getCityTaxCheckInformation: Maybe<CityTaxCheckInformationDto>;
  getCompany: Maybe<CompanyDto>;
  getCostCenter: Maybe<CostCenterDto>;
  getCreditCardImageType: CreditCardImageTypeDto;
  getCreditCards: GetCreditCardsResponseDto;
  getCustomer: Maybe<CustomerDto>;
  getDailyAllotmentValues: GetDailyAllotmentValuesResponseDto;
  getDailyWebAvailabilities: GetDailyWebAvailabilitiesResponseDto;
  getDamage: Maybe<DamageDto>;
  getDeposit: Maybe<DepositDto>;
  getFiscalClosureParameters: Maybe<GetFiscalClosureParametersResponseDto>;
  /** deprecated - use getAllDocumentType instead */
  getGenericDocumentType: Array<DocumentTypeDto>;
  getGridPricesRevenueValues: Maybe<Array<GridPricesRevenueValuesDto>>;
  getInvoice: InvoiceDto;
  /** deprecated */
  getInvoiceBlocks: Array<Scalars['String']['output']>;
  getInvoiceData: Maybe<InvoiceDataDto>;
  getInvoiceDataFromInvoiceId: Maybe<InvoiceDataDto>;
  getInvoiceHolder: Maybe<InvoiceHolderDto>;
  getIstatCustomer: Array<IstatCustomerDto>;
  getIstatGenerationParameters: Maybe<IstatGenerationParametersDto>;
  /** Given a customer id, return all Customers that have been in the same Room */
  getLinkedCustomers: Array<CustomerDto>;
  getLinkedInvoices: Array<InvoiceToDepositDto>;
  getLinkedReceipts: Array<InvoiceDto>;
  getNaturaTypes: Array<NaturaTypeEnumDto>;
  getNotIncludedDeposits: Array<DepositDto>;
  getOpenSubAccountHolders: Array<InvoiceHolderDto>;
  getOptional: Maybe<OptionalDto>;
  getOptionalData: Maybe<OptionalDataDto>;
  getOwner: Maybe<OwnerDto>;
  getOwnerCorporateData: OwnerCorporateDataDto;
  getOwnerCreditCard: Maybe<OwnerCreditCardDto>;
  getOwnerGrid: OwnerGridDto;
  getOwnerGuestCard: Maybe<OwnerGuestCardDto>;
  getOwnerHousekeeping: Maybe<OwnerHousekeepingDto>;
  getOwnerPlanner: Maybe<OwnerPlannerDto>;
  getOwnerPrivateData: Maybe<OwnerPrivateDataDto>;
  getPacket: Maybe<PacketDto>;
  getPacketData: Maybe<PacketDataDto>;
  getParameter: Maybe<ParameterDto>;
  getParameterValue: Maybe<ParameterValueDto>;
  getPriceList: Maybe<PriceListDto>;
  getPriceListIncludedResources: Maybe<Array<Maybe<IncludedResourceDto>>>;
  getProduct: Maybe<ProductDto>;
  getProductData: Maybe<ProductDataDto>;
  getPsCustomer: Array<PsCustomerDto>;
  getPurchasedProduct: Maybe<PurchasedProductDto>;
  getPurchasedStay: Maybe<PurchasedStayDto>;
  getPurchasedStayCustomers: Array<PurchasedStayToCustomerWithValidationDto>;
  getPurchasedStayToCustomer: PurchasedStayToCustomerDto;
  getResStatus: Maybe<ResStatusDto>;
  getReservation: Maybe<ReservationDto>;
  getReservationDeposits: Array<DepositDto>;
  getResource: Maybe<ResourceReferenceDto>;
  getRoom: Maybe<RoomDto>;
  getRoomInStillOutReportGenerationParameters: GetRoomInStillOutReportGenerationParametersResponseDto;
  getRoomPrepareReportGenerationParameters: GetRoomPrepareReportGenerationParametersResponseDto;
  getRoomStatus: Maybe<RoomStatusDto>;
  getRoomTaken: Array<PurchasedStayDto>;
  getSegment: Maybe<SegmentDto>;
  getSellReportGenerationParameters: GetSellReportGenerationParametersResponseDto;
  /** deprecated - use checkTransferService instead */
  getServiceTransferInfo: Maybe<GetServiceTransferInfoResponseDto>;
  getSoldRoomsInOption: Array<DayToSoldRoomsDto>;
  /** deprecated - use getAllDocumentType instead */
  getStateDocumentType: Array<DocumentTypeDto>;
  getStay: Maybe<StayDto>;
  getStayData: Maybe<StayDataDto>;
  getStayRoomAmenity: Array<Scalars['Int']['output']>;
  getUserPreferences: Maybe<UserPreferencesDto>;
  /** URL of the page that shows an existing card, to be opened in an iframe. creditCardId is CreditCardRowDTO.id, the row the user picked in getCreditCards. Whether the page includes the CVV is decided by the server from the owner configuration: when getOwnerCreditCard reports viewCardsCvv, warn the user that the CVV is erased after the first time it is shown */
  getViewCardUrl: CardUrlDto;
  hasBlockPriceListEdit: Scalars['Boolean']['output'];
  hasBlockStayEdit: Scalars['Boolean']['output'];
  health: Maybe<HealthDto>;
  integrationHealth: Scalars['Boolean']['output'];
  invoiceGenerateProgressive: Maybe<Scalars['Int']['output']>;
  isBookingEngineActive: Scalars['Boolean']['output'];
  isErpZucchettiExportActive: Scalars['Boolean']['output'];
  isInvoiceAlreadyPrinted: Scalars['Boolean']['output'];
  isInvoiceDeletable: Scalars['Boolean']['output'];
  isPurchasedStayToCustomerDeletable: Scalars['Boolean']['output'];
  isRoomTaken: Scalars['Boolean']['output'];
  purchasedPacketGetCalendarPrice: Array<CalendarPriceDto>;
  purchasedStayCalculatePrice: Scalars['BigDecimal']['output'];
  purchasedStayGetCalendarPrice: Array<CalendarPriceDto>;
  /** Get cash register resolved by its filters */
  resolveCashRegister: Maybe<CashRegisterDto>;
  resolveOwnerCorporateData: OwnerCorporateDataDto;
  /** deprecated - use searchAgencyPaginated instead */
  searchAgency: Array<AgencyDto>;
  searchAgencyPaginated: AgencyListPaginatedDto;
  searchCancellationPolicy: Array<CancellationPolicyDto>;
  searchCashRegister: Array<CashRegisterDto>;
  searchChannel: Array<ChannelDto>;
  searchCity: Array<CityDto>;
  /** deprecated - use searchCompanyPaginated instead */
  searchCompany: Array<CompanyDto>;
  searchCompanyPaginated: CompanyListPaginatedDto;
  searchCostCenter: Array<CostCenterDto>;
  /** deprecated - use searchCustomerPaginated instead */
  searchCustomer: Array<CustomerDto>;
  searchCustomerPaginated: CustomerListPaginatedDto;
  searchDamage: Array<DamageDto>;
  searchDeposit: Array<DepositDto>;
  searchElectronicInvoiceDataPaginated: SearchElectronicInvoiceDataPaginatedResponseDto;
  /** deprecated - use searchInvoicePaginated instead */
  searchInvoice: Array<InvoiceDto>;
  searchInvoiceData: Array<InvoiceDataDto>;
  searchInvoicePaginated: InvoiceListPaginatedDto;
  searchOptional: Array<OptionalDto>;
  searchPacket: Array<PacketDto>;
  searchPriceList: Array<PriceListDto>;
  searchProduct: Array<ProductDto>;
  searchPurchasedProduct: Array<PurchasedProductDto>;
  searchPurchasedStay: Array<PurchasedStayDto>;
  searchPurchasedStayExtended: Array<PurchasedStayExtendedDto>;
  searchPurchasedStayExtendedPaginated: PurchasedStayExtendedListPaginatedDto;
  searchResStatus: Array<ResStatusDto>;
  /** deprecated - use searchReservationPaginated instead */
  searchReservation: Array<ReservationDto>;
  searchReservationPaginated: ReservationListPaginatedDto;
  searchReservationPlanner: Array<ReservationPlannerDto>;
  searchResource: Array<ResourceReferenceDto>;
  searchResourcePaginated: ResourceListPaginatedDto;
  searchRoom: Array<RoomDto>;
  searchRoomStatus: Array<RoomStatusDto>;
  searchSegment: Array<SegmentDto>;
  searchStay: Array<StayDto>;
  /** Returns a list of validation errors, if any */
  validateCustomerForIstat: Array<ResourceValidationResultDto>;
  /** Returns a list of validation errors, if any */
  validateCustomerForPs: Array<ResourceValidationResultDto>;
  validateElectronicInvoice: ValidateElectronicInvoiceResponseDto;
  validateElectronicInvoices: ValidateElectronicInvoicesResponseDto;
  validatePurchasedStayPeriods: Scalars['Boolean']['output'];
};


/** Query root */
export type QueryAlignDayPricesToDatesArgs = {
  dayPrices: Array<InputMaybe<UpsertDayPriceDtoInput>>;
  newCheckIn: Scalars['LocalDate']['input'];
  newCheckOut: Scalars['LocalDate']['input'];
  oldCheckIn: Scalars['LocalDate']['input'];
  oldCheckOut: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryBuildCashRegisterCreditNoteArgs = {
  buildCashRegisterCreditNoteRequestDTO: BuildCashRegisterCreditNoteRequestDtoInput;
};


/** Query root */
export type QueryBuildCashRegisterReceiptArgs = {
  buildCashRegisterReceiptRequestDTO: BuildCashRegisterReceiptRequestDtoInput;
};


/** Query root */
export type QueryBuildCreditNoteArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Query root */
export type QueryBuildDepositInvoiceObjectArgs = {
  request: InputMaybe<BuildDepositInvoiceObjectRequestDtoInput>;
};


/** Query root */
export type QueryBuildInvoiceObjectArgs = {
  request: InputMaybe<BuildInvoiceObjectRequestDtoInput>;
};


/** Query root */
export type QueryCalcDayPricesArgs = {
  upsertPurchasedStayDTO: InputMaybe<UpsertPurchasedStayDtoInput>;
};


/** Query root */
export type QueryCalcFiscalCodeArgs = {
  calcFiscalCodeRequestDTO: CalcFiscalCodeRequestDtoInput;
};


/** Query root */
export type QueryCalculateCityTaxArgs = {
  purchasedStayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCalculateCityTaxAmountArgs = {
  calculateCityTaxAmountRequestDTO: CalculateCityTaxAmountRequestDtoInput;
};


/** Query root */
export type QueryCalculateCityTaxByListArgs = {
  purchasedStayIds: Array<Scalars['Int']['input']>;
};


/** Query root */
export type QueryCalculatePriceArgs = {
  calculatePriceRequestDTO: CalculatePriceRequestDtoInput;
};


/** Query root */
export type QueryCalculatePriceListPriceArgs = {
  calculatePriceListPriceRequestDTO: CalculatePriceListPriceRequestDtoInput;
};


/** Query root */
export type QueryCalculatePurchasedProductPriceArgs = {
  calculatePurchasedProductPriceRequestDTO: CalculatePurchasedProductPriceRequestDtoInput;
};


/** Query root */
export type QueryCalculateWebPacketPriceFromWebArgs = {
  upsertPurchasedPacketDTO: UpsertPurchasedPacketDtoInput;
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Query root */
export type QueryCheckAskHolderArgs = {
  purchasedStayId: InputMaybe<Scalars['Int']['input']>;
  reservationId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCheckAstatDailyGuestsInClosurePeriodArgs = {
  checkAstatDailyGuestsInClosurePeriodRequestDTO: InputMaybe<CheckAstatDailyGuestsInClosurePeriodRequestDtoInput>;
};


/** Query root */
export type QueryCheckAvailabilityArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  purchasedStayId: InputMaybe<Scalars['Int']['input']>;
  roomId: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryCheckAvailabilityRoomArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  roomId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCheckFiscalDayNotClosedArgs = {
  documentType: InputMaybe<InvoiceDocumentTypeDto>;
  invoiceDate: InputMaybe<Scalars['LocalDate']['input']>;
  ownerCorporateDataId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCheckForDuplicateAgencyArgs = {
  corpName: InputMaybe<Scalars['String']['input']>;
  idToExclude: InputMaybe<Scalars['Int']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryCheckForDuplicateCompanyArgs = {
  corpName: InputMaybe<Scalars['String']['input']>;
  idToExclude: InputMaybe<Scalars['Int']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryCheckForDuplicateCustomersArgs = {
  idToExclude: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
};


/** Query root */
export type QueryCheckFullAvailabilityOwnerArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  includeVirtual?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Query root */
export type QueryCheckFullAvailabilityStayArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  stayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCheckLoginElectronicInvoiceArgs = {
  upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDtoInput;
};


/** Query root */
export type QueryCheckProgressiveArgs = {
  invoiceCheckProgressiveRequestDTO: InvoiceCheckProgressiveRequestDtoInput;
};


/** Query root */
export type QueryCheckServicesOutsidePurchasedStayDatesArgs = {
  newBeginDate: Scalars['LocalDate']['input'];
  newEndDate: Scalars['LocalDate']['input'];
  purchasedStayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCheckShorterLinkedOptionalArgs = {
  newBeginDate: Scalars['LocalDate']['input'];
  newEndDate: Scalars['LocalDate']['input'];
  purchasedStayId: Scalars['Int']['input'];
  roomId: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryCheckSimpleInventoryArgs = {
  checkSimpleInventoryRequestDTO: CheckSimpleInventoryRequestDtoInput;
};


/** Query root */
export type QueryCheckTransferServiceArgs = {
  request: InputMaybe<CheckTransferServiceRequestDtoInput>;
};


/** Query root */
export type QueryCheckTransferServicesArgs = {
  request: CheckTransferServicesRequestDtoInput;
};


/** Query root */
export type QueryCheckVatArgs = {
  checkVatRequestDTO: CheckVatRequestDtoInput;
};


/** Query root */
export type QueryExtractCustomersAndHoldersArgs = {
  reservationId: Scalars['Int']['input'];
};


/** Query root */
export type QueryFindInvoicesByElementOrCityTaxServiceIdArgs = {
  request: InputMaybe<FindInvoicesByElementOrCityTaxServiceIdRequestDtoInput>;
};


/** Query root */
export type QueryGetAddCardUrlArgs = {
  request: GetCreditCardsRequestDtoInput;
};


/** Query root */
export type QueryGetAgencyArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetAllOwnerAvailableProductArgs = {
  categoryId: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryGetAllReservationWizardRateByOwnerArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryGetAllReservationWizardRateByStayArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  stayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetAstatDailyClosureDayArgs = {
  getAstatDailyClosureDayRequestDTO: InputMaybe<GetAstatDailyClosureDayRequestDtoInput>;
};


/** Query root */
export type QueryGetAstatDailyLocalTaxInfoArgs = {
  getAstatDailyLocalTaxInfoRequestDTO: InputMaybe<GetAstatDailyLocalTaxInfoRequestDtoInput>;
};


/** Query root */
export type QueryGetCalendarPriceArgs = {
  priceGetCalendarPriceRequestDTO: PriceGetCalendarPriceRequestDtoInput;
};


/** Query root */
export type QueryGetCancellationPolicyArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCashRegisterArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetChannelArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCityArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCityTaxCheckInformationArgs = {
  cityTaxCheckInformationRequestDTO: InputMaybe<GetCityTaxCheckInformationRequestDtoInput>;
};


/** Query root */
export type QueryGetCompanyArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCostCenterArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCreditCardImageTypeArgs = {
  reservationId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetCreditCardsArgs = {
  request: GetCreditCardsRequestDtoInput;
};


/** Query root */
export type QueryGetCustomerArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetDailyAllotmentValuesArgs = {
  request: InputMaybe<GetDailyAllotmentValuesRequestDtoInput>;
};


/** Query root */
export type QueryGetDailyWebAvailabilitiesArgs = {
  request: GetDailyWebAvailabilitiesRequestDtoInput;
};


/** Query root */
export type QueryGetDamageArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetGridPricesRevenueValuesArgs = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryGetInvoiceArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetInvoiceDataArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetInvoiceDataFromInvoiceIdArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetInvoiceHolderArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetIstatCustomerArgs = {
  getIstatCustomerRequestDTO: InputMaybe<GetIstatCustomerRequestDtoInput>;
};


/** Query root */
export type QueryGetIstatGenerationParametersArgs = {
  ownerIstatId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetLinkedCustomersArgs = {
  customerId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetLinkedInvoicesArgs = {
  depositId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetLinkedReceiptsArgs = {
  masterInvoiceId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetNaturaTypesArgs = {
  request: InputMaybe<GetNaturaTypesRequestDtoInput>;
};


/** Query root */
export type QueryGetNotIncludedDepositsArgs = {
  getNotIncludedDepositsRequestDTO: InputMaybe<GetNotIncludedDepositsRequestDtoInput>;
};


/** Query root */
export type QueryGetOpenSubAccountHoldersArgs = {
  reservationId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetOptionalArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetOptionalDataArgs = {
  optionalId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetOwnerCorporateDataArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetOwnerGuestCardArgs = {
  ownerGuestCardId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPacketArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPacketDataArgs = {
  packetId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetParameterArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetParameterValueArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPriceListArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPriceListIncludedResourcesArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetProductArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetProductDataArgs = {
  productId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPsCustomerArgs = {
  date: Scalars['LocalDate']['input'];
  ownerPublicSecurityId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPurchasedProductArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPurchasedStayArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPurchasedStayCustomersArgs = {
  purchasedStayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetPurchasedStayToCustomerArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetResStatusArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetReservationArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetReservationDepositsArgs = {
  reservationId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetResourceArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetRoomArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetRoomStatusArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetRoomTakenArgs = {
  purchasedStayId: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetSegmentArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetServiceTransferInfoArgs = {
  request: InputMaybe<GetServiceTransferInfoRequestDtoInput>;
};


/** Query root */
export type QueryGetSoldRoomsInOptionArgs = {
  getSoldRoomsInOptionRequestDTO: GetSoldRoomsInOptionRequestDtoInput;
};


/** Query root */
export type QueryGetStateDocumentTypeArgs = {
  stateId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetStayArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetStayDataArgs = {
  stayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetStayRoomAmenityArgs = {
  stayId: Scalars['Int']['input'];
};


/** Query root */
export type QueryGetViewCardUrlArgs = {
  creditCardId: Scalars['Int']['input'];
};


/** Query root */
export type QueryInvoiceGenerateProgressiveArgs = {
  invoiceGenerateProgressiveRequestDTO: InvoiceGenerateProgressiveRequestDtoInput;
};


/** Query root */
export type QueryIsInvoiceAlreadyPrintedArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Query root */
export type QueryIsInvoiceDeletableArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Query root */
export type QueryIsPurchasedStayToCustomerDeletableArgs = {
  purchasedStayToCustomerId: Scalars['Int']['input'];
};


/** Query root */
export type QueryIsRoomTakenArgs = {
  purchasedStayId: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['Int']['input'];
};


/** Query root */
export type QueryPurchasedPacketGetCalendarPriceArgs = {
  upsertPurchasedPacketDTO: UpsertPurchasedPacketDtoInput;
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Query root */
export type QueryPurchasedStayCalculatePriceArgs = {
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Query root */
export type QueryPurchasedStayGetCalendarPriceArgs = {
  upsertPurchasedStayDTO: UpsertPurchasedStayDtoInput;
};


/** Query root */
export type QueryResolveCashRegisterArgs = {
  resolveCashRegisterRequestDTO: ResolveCashRegisterRequestDtoInput;
};


/** Query root */
export type QueryResolveOwnerCorporateDataArgs = {
  request: InputMaybe<ResolveOwnerCorporateDataRequestDtoInput>;
};


/** Query root */
export type QuerySearchAgencyArgs = {
  queryAgencyDTO: QueryAgencyDtoInput;
};


/** Query root */
export type QuerySearchAgencyPaginatedArgs = {
  queryAgencyDTO: QueryAgencyDtoInput;
};


/** Query root */
export type QuerySearchCancellationPolicyArgs = {
  queryCancellationPolicyDTO: QueryCancellationPolicyDtoInput;
};


/** Query root */
export type QuerySearchCashRegisterArgs = {
  queryCashRegisterDTO: QueryCashRegisterDtoInput;
};


/** Query root */
export type QuerySearchChannelArgs = {
  queryChannelDTO: QueryChannelDtoInput;
};


/** Query root */
export type QuerySearchCityArgs = {
  cityNameStart: Scalars['String']['input'];
  stateId: Scalars['Int']['input'];
  validityDate: InputMaybe<Scalars['LocalDate']['input']>;
};


/** Query root */
export type QuerySearchCompanyArgs = {
  queryCompanyDTO: QueryCompanyDtoInput;
};


/** Query root */
export type QuerySearchCompanyPaginatedArgs = {
  queryCompanyDTO: QueryCompanyDtoInput;
};


/** Query root */
export type QuerySearchCostCenterArgs = {
  queryCostCenterDTO: QueryCostCenterDtoInput;
};


/** Query root */
export type QuerySearchCustomerArgs = {
  queryCustomerDTO: QueryCustomerDtoInput;
};


/** Query root */
export type QuerySearchCustomerPaginatedArgs = {
  queryCustomerDTO: QueryCustomerDtoInput;
};


/** Query root */
export type QuerySearchDamageArgs = {
  queryDamageDTO: QueryDamageDtoInput;
};


/** Query root */
export type QuerySearchDepositArgs = {
  queryDepositDTO: QueryDepositDtoInput;
};


/** Query root */
export type QuerySearchElectronicInvoiceDataPaginatedArgs = {
  request: SearchElectronicInvoiceDataPaginatedRequestDtoInput;
};


/** Query root */
export type QuerySearchInvoiceArgs = {
  queryInvoiceDTO: QueryInvoiceDtoInput;
};


/** Query root */
export type QuerySearchInvoiceDataArgs = {
  queryInvoiceDataDTO: QueryInvoiceDataDtoInput;
};


/** Query root */
export type QuerySearchInvoicePaginatedArgs = {
  queryInvoiceDTO: QueryInvoiceDtoInput;
};


/** Query root */
export type QuerySearchOptionalArgs = {
  queryOptionalDTO: QueryOptionalDtoInput;
};


/** Query root */
export type QuerySearchPacketArgs = {
  queryPacketDTO: QueryPacketDtoInput;
};


/** Query root */
export type QuerySearchPriceListArgs = {
  queryPriceListDTO: QueryPriceListDtoInput;
};


/** Query root */
export type QuerySearchProductArgs = {
  queryProductDTO: QueryProductDtoInput;
};


/** Query root */
export type QuerySearchPurchasedProductArgs = {
  queryPurchasedProductDTO: QueryPurchasedProductDtoInput;
};


/** Query root */
export type QuerySearchPurchasedStayArgs = {
  queryPurchasedStayDTO: QueryPurchasedStayDtoInput;
};


/** Query root */
export type QuerySearchPurchasedStayExtendedArgs = {
  queryPurchasedStayExtendedDTO: QueryPurchasedStayExtendedDtoInput;
};


/** Query root */
export type QuerySearchPurchasedStayExtendedPaginatedArgs = {
  queryPurchasedStayExtendedPaginatedDTO: QueryPurchasedStayExtendedPaginatedDtoInput;
};


/** Query root */
export type QuerySearchResStatusArgs = {
  queryResStatusDTO: QueryResStatusDtoInput;
};


/** Query root */
export type QuerySearchReservationArgs = {
  queryReservationDTO: QueryReservationDtoInput;
};


/** Query root */
export type QuerySearchReservationPaginatedArgs = {
  queryReservationDTO: QueryReservationDtoInput;
};


/** Query root */
export type QuerySearchReservationPlannerArgs = {
  searchReservationPlannerRequestDTO: SearchReservationPlannerRequestDtoInput;
};


/** Query root */
export type QuerySearchResourceArgs = {
  queryResourceDTO: QueryResourceDtoInput;
};


/** Query root */
export type QuerySearchResourcePaginatedArgs = {
  queryResourceDTO: QueryResourceDtoInput;
};


/** Query root */
export type QuerySearchRoomArgs = {
  queryRoomDTO: QueryRoomDtoInput;
};


/** Query root */
export type QuerySearchRoomStatusArgs = {
  queryRoomStatusDTO: QueryRoomStatusDtoInput;
};


/** Query root */
export type QuerySearchSegmentArgs = {
  querySegmentDTO: QuerySegmentDtoInput;
};


/** Query root */
export type QuerySearchStayArgs = {
  queryStayDTO: QueryStayDtoInput;
};


/** Query root */
export type QueryValidateCustomerForIstatArgs = {
  upsertCustomerDTO: UpsertCustomerDtoInput;
};


/** Query root */
export type QueryValidateCustomerForPsArgs = {
  upsertCustomerDTO: UpsertCustomerDtoInput;
};


/** Query root */
export type QueryValidateElectronicInvoiceArgs = {
  invoiceId: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryValidateElectronicInvoicesArgs = {
  invoiceIds: Array<Scalars['Int']['input']>;
};


/** Query root */
export type QueryValidatePurchasedStayPeriodsArgs = {
  validatePurchasedStayPeriodsRequest: InputMaybe<ValidatePurchasedStayPeriodsRequestDtoInput>;
};

export type QueryAgencyDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLike?: InputMaybe<Scalars['String']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  cityStart?: InputMaybe<Scalars['String']['input']>;
  /** commission equal to */
  commission?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** commission greater than or equal to */
  commissionLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** commission less than or equal to */
  commissionUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  corpName?: InputMaybe<Scalars['String']['input']>;
  corpNameStart?: InputMaybe<Scalars['String']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerCodeStart?: InputMaybe<Scalars['String']['input']>;
  /** discount greater than or equal to */
  discountLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** discount less than or equal to */
  discountUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  eInvoicingCode?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  fiscalCodeStart?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  invoiceType?: InputMaybe<InvoiceDocumentTypeDto>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mailNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: customerCode, corpName, district, state */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  /** 1: D14, 2: D30, 3: D30_EOM, 4: D60, 5: D60_EOM, 6: D90, 7: D90_EOM, 8: D120, 9: D120_EOM */
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  pec?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publicAdministration?: InputMaybe<Scalars['Boolean']['input']>;
  referringName?: InputMaybe<Scalars['String']['input']>;
  referringNameStart?: InputMaybe<Scalars['String']['input']>;
  referringSurname?: InputMaybe<Scalars['String']['input']>;
  referringSurnameStart?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumberStart?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCancellationPolicyDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  bnplStatus?: InputMaybe<BnplStatusEnumDto>;
  chargeType?: InputMaybe<ChargeTypeEnumDto>;
  chargeValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  condition?: InputMaybe<CancellationPolicyConditionEnumDto>;
  creditCardPolicy?: InputMaybe<CreditCardPolicyEnumDto>;
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  descriptionDeStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEsStart?: InputMaybe<Scalars['String']['input']>;
  descriptionFrStart?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  fullRefundableDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastInstalment?: InputMaybe<LastInstalmentEnumDto>;
  maxInstalments?: InputMaybe<Scalars['Int']['input']>;
  minInstalments?: InputMaybe<Scalars['Int']['input']>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, name */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partialRefundableDays?: InputMaybe<Scalars['Int']['input']>;
  partialRefundableValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  penaltyType?: InputMaybe<PenaltyTypeEnumDto>;
  penaltyValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  showDescriptionOnWeb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCashRegisterDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  cashRegisterType?: InputMaybe<CashRegisterTypeEnumDto>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  doubleCopy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  localAddress?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, description */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChannelDtoInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  blue?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeStart?: InputMaybe<Scalars['String']['input']>;
  /** commission equal to */
  commission?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** commission greater than or equal to */
  commissionLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** commission less than or equal to */
  commissionUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** list of channelId */
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  internalCode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, name */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  red?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  typeOfBusinessId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCompanyDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLike?: InputMaybe<Scalars['String']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  cityStart?: InputMaybe<Scalars['String']['input']>;
  corpName?: InputMaybe<Scalars['String']['input']>;
  corpNameStart?: InputMaybe<Scalars['String']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerCodeStart?: InputMaybe<Scalars['String']['input']>;
  /** discount greater than or equal to */
  discountLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** discount less than or equal to */
  discountUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  eInvoicingCode?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  fiscalCodeStart?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  invoiceType?: InputMaybe<InvoiceDocumentTypeDto>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mailNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: customerCode, corpName, district, state */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  /** 1: D14, 2: D30, 3: D30_EOM, 4: D60, 5: D60_EOM, 6: D90, 7: D90_EOM, 8: D120, 9: D120_EOM */
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  pec?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publicAdministration?: InputMaybe<Scalars['Boolean']['input']>;
  referringName?: InputMaybe<Scalars['String']['input']>;
  referringNameStart?: InputMaybe<Scalars['String']['input']>;
  referringSurname?: InputMaybe<Scalars['String']['input']>;
  referringSurnameStart?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumberStart?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCostCenterDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** allowed values: id, description */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** when unset, matches both PRIMARY_COST and SECONDARY_COST */
  type?: InputMaybe<CostCenterTypeDto>;
};

export type QueryCustomerDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLike?: InputMaybe<Scalars['String']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** birthDate equal to - format: YYYY-MM-DD */
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** birthDate greater than or equal to - format: YYYY-MM-DD */
  birthDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** birthDate less than or equal to - format: YYYY-MM-DD */
  birthDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** format: YYYY-MM-DD - day of the year in which one's birthday occurs. Only month and day are considered */
  birthDay?: InputMaybe<Scalars['LocalDate']['input']>;
  birthDistrict?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  birthPlaceId?: InputMaybe<Scalars['Int']['input']>;
  birthState?: InputMaybe<Scalars['String']['input']>;
  birthStateId?: InputMaybe<Scalars['Int']['input']>;
  blacklist?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  cityStart?: InputMaybe<Scalars['String']['input']>;
  cityTaxExemptionId?: InputMaybe<Scalars['Int']['input']>;
  clubMember?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creditCardNumber?: InputMaybe<Scalars['String']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerCodeStart?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  districtStart?: InputMaybe<Scalars['String']['input']>;
  doNotPreauthorize?: InputMaybe<Scalars['Boolean']['input']>;
  /** documentDeadlineDate greater than or equal to - format: YYYY-MM-DD */
  documentDeadlineDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** documentDeadlineDate less than or equal to - format: YYYY-MM-DD */
  documentDeadlineDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** documentReleaseDate greater than or equal to - format: YYYY-MM-DD */
  documentReleaseDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** documentReleaseDate less than or equal to - format: YYYY-MM-DD */
  documentReleaseDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  documentReleaser?: InputMaybe<Scalars['String']['input']>;
  documentReleaserCityId?: InputMaybe<Scalars['Int']['input']>;
  documentReleaserState?: InputMaybe<Scalars['Boolean']['input']>;
  documentReleaserStateId?: InputMaybe<Scalars['Int']['input']>;
  eInvoicingCode?: InputMaybe<Scalars['String']['input']>;
  familyRepId?: InputMaybe<Scalars['Int']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  fiscalCodeStart?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  interestId?: InputMaybe<Scalars['Int']['input']>;
  /** lastStay equal to - format: YYYY-MM-DD */
  lastStay?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastStayEnd equal to - format: YYYY-MM-DD */
  lastStayEnd?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastStayEnd greater than or equal to - format: YYYY-MM-DD */
  lastStayEndLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastStayEnd less than or equal to - format: YYYY-MM-DD */
  lastStayEndUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastStay greater than or equal to - format: YYYY-MM-DD */
  lastStayLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastStay less than or equal to - format: YYYY-MM-DD */
  lastStayUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  lotteryCode?: InputMaybe<Scalars['String']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mailNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  multidbDocumentTypeId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  numberplate?: InputMaybe<Scalars['String']['input']>;
  numberplateStart?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, customerCode, surname, district, state, lastStay */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pec?: InputMaybe<Scalars['String']['input']>;
  privacyAuth?: InputMaybe<Scalars['Boolean']['input']>;
  privacyAuth2?: InputMaybe<Scalars['Boolean']['input']>;
  privacyAuth3?: InputMaybe<Scalars['Boolean']['input']>;
  professionId?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  sendCheckInMail?: InputMaybe<Scalars['Boolean']['input']>;
  sendCheckOutMail?: InputMaybe<Scalars['Boolean']['input']>;
  sex?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surnameStart?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  titleId?: InputMaybe<Scalars['Int']['input']>;
  transportId?: InputMaybe<Scalars['Int']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumberStart?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDamageDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  closedBy?: InputMaybe<Scalars['String']['input']>;
  /** closureDate equal to - format: YYYY-MM-DD */
  closureDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** closureDate greater than or equal to - format: YYYY-MM-DD */
  closureDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  closureDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  closureDateNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** closureDate less than or equal to - format: YYYY-MM-DD */
  closureDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  damageTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** date equal to - format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date greater than or equal to - format: YYYY-MM-DD */
  dateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date less than or equal to - format: YYYY-MM-DD */
  dateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insertedBy?: InputMaybe<Scalars['String']['input']>;
  notesStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, description, date, closureDate */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  reportedBy?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDepositDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  blockNullOrEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** date equal to - format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date greater than or equal to - format: YYYY-MM-DD */
  dateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date less than or equal to - format: YYYY-MM-DD */
  dateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  depositInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  depositInvoiceIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  depositInvoiceIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  depositUseId?: InputMaybe<Scalars['Int']['input']>;
  holderId?: InputMaybe<Scalars['Int']['input']>;
  holderIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  holderIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** list of depositId */
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  invoiceIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed values: id, date */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  /** list of reservationId */
  reservationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reservationIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  reservationIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  reservationOwnerId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInvoiceDtoInput = {
  amountLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  /** deprecated */
  blockEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated */
  blockNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNullOrEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  cityTaxNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  creditNote?: InputMaybe<Scalars['Boolean']['input']>;
  creditNoteInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  creditNoteVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** date equal to - format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date greater than or equal to - format: YYYY-MM-DD */
  dateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date less than or equal to - format: YYYY-MM-DD */
  dateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  depositInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  depositInvoiceDepartmentId?: InputMaybe<Scalars['Int']['input']>;
  depositInvoiceNaturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  depositInvoiceReferenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  depositInvoiceTypeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  depositInvoiceVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  depositLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  depositUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  documentType?: InputMaybe<InvoiceDocumentTypeDto>;
  elementOrCityTaxServiceId?: InputMaybe<Scalars['Int']['input']>;
  holderId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** list of invoiceId */
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceDataId?: InputMaybe<Scalars['Int']['input']>;
  invoiceElementServiceId?: InputMaybe<Scalars['Int']['input']>;
  invoiceExtraDisplayMode?: InputMaybe<InvoiceExtraDisplayModeDto>;
  invoiceRoomDisplayMode?: InputMaybe<InvoiceRoomDisplayModeDto>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoiceTypeIsNull?: InputMaybe<Scalars['Boolean']['input']>;
  invoicedCityTaxServiceId?: InputMaybe<Scalars['Int']['input']>;
  invoicedDepositId?: InputMaybe<Scalars['Int']['input']>;
  /** lastModification greater than or equal to - format: YYYY-MM-DD */
  lastModificationLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** lastModification less than or equal to - format: YYYY-MM-DD */
  lastModificationUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  masterInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  masterInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  masterInvoiceIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** excludes receipts not to pay and self-invoices, forces paymentEffective as null */
  onlySuspended?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed values: id, progressive, amount, date */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  paidLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  paidUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  payment2Id?: InputMaybe<Scalars['Int']['input']>;
  paymentCityTaxId?: InputMaybe<Scalars['Int']['input']>;
  /** paymentEffective greater than or equal to - format: YYYY-MM-DD */
  paymentEffectiveLower?: InputMaybe<Scalars['LocalDate']['input']>;
  paymentEffectiveNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  paymentEffectiveNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** paymentEffective less than or equal to - format: YYYY-MM-DD */
  paymentEffectiveUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  paymentEffectiveUsername?: InputMaybe<Scalars['String']['input']>;
  /** paymentExpected greater than or equal to - format: YYYY-MM-DD */
  paymentExpectedLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** paymentExpected less than or equal to - format: YYYY-MM-DD */
  paymentExpectedUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  progressive?: InputMaybe<Scalars['Int']['input']>;
  progressiveLower?: InputMaybe<Scalars['Int']['input']>;
  progressiveUpper?: InputMaybe<Scalars['Int']['input']>;
  selfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  selfInvoiceNaturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  selfInvoiceReferenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  selfInvoiceSellerId?: InputMaybe<Scalars['Int']['input']>;
  selfInvoiceTypeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  selfInvoiceVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  showCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  showExtra?: InputMaybe<Scalars['Int']['input']>;
  showId?: InputMaybe<Scalars['Boolean']['input']>;
  showRooms?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  wizardInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInvoiceDataDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  cashRegisterClosure?: InputMaybe<Scalars['String']['input']>;
  cashRegisterCode?: InputMaybe<Scalars['String']['input']>;
  cashRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  eInvoiceStatus?: InputMaybe<EInvoiceStatusEnumDto>;
  externalCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlock?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  invoiceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** format: YYYY-MM-DD */
  invoiceDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** format: YYYY-MM-DD */
  invoiceDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  invoiceIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceIsInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceOwnerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  invoiceProgressive?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, date */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  relatedDocumentTypeId?: InputMaybe<Scalars['Int']['input']>;
  vatChargeability?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOptionalDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** basePrice greater than or equal to */
  basePriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** basePrice less than or equal to */
  basePriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  category2Id?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  defaultPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEnLike?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  notesEnLike?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPacketDtoInput = {
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  applicateAllStay?: InputMaybe<Scalars['Boolean']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** basePrice greater than or equal to */
  basePriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** basePrice less than or equal to */
  basePriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** beginSell greater than or equal to */
  beginSellLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginSell less than or equal to */
  beginSellUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginValidity greater than or equal to */
  beginValidityLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginValidity less than or equal to */
  beginValidityUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationPolicyId?: InputMaybe<Scalars['Int']['input']>;
  checkInFriday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInMonday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInSunday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInThursday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFriday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutMonday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutSunday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutThursday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEnLike?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  discountDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  /** discount greater than or equal to */
  discountLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** discount less than or equal to */
  discountUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  earlyBird?: InputMaybe<Scalars['Int']['input']>;
  /** endSell greater than or equal to */
  endSellLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endSell less than or equal to */
  endSellUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endValidity greater than or equal to */
  endValidityLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endValidity less than or equal to */
  endValidityUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  extraParameters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastMinute?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  minimumStay?: InputMaybe<Scalars['Int']['input']>;
  notesEnLike?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  offerId?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description, webOrder */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  stayId?: InputMaybe<Scalars['Int']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  /** true = pacchetto web, false = pacchetto turistico */
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
  /** weekendExtra greater than or equal to */
  weekendExtraLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** weekendExtra less than or equal to */
  weekendExtraUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type QueryPriceListDtoInput = {
  addedBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed2?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed3?: InputMaybe<Scalars['Boolean']['input']>;
  ageAddedCradle?: InputMaybe<Scalars['Int']['input']>;
  ageAddedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  ageAddedJuniorBed2?: InputMaybe<Scalars['Int']['input']>;
  ageAddedJuniorBed3?: InputMaybe<Scalars['Int']['input']>;
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationPolicyId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  estimateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  extraAllInclusive?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraBedDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  extraBedParameters?: InputMaybe<Scalars['Boolean']['input']>;
  extraBreakfast?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinner?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraGuestParameters?: InputMaybe<Scalars['Boolean']['input']>;
  extraLunch?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraMealParameters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  notesDeStart?: InputMaybe<Scalars['String']['input']>;
  notesEnStart?: InputMaybe<Scalars['String']['input']>;
  notesEsStart?: InputMaybe<Scalars['String']['input']>;
  notesFrStart?: InputMaybe<Scalars['String']['input']>;
  notesStart?: InputMaybe<Scalars['String']['input']>;
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description, price, beginDate, endDate */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  perPerson?: InputMaybe<Scalars['Boolean']['input']>;
  priceAddedBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedJuniorBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedJuniorBed2?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedJuniorBed3?: InputMaybe<Scalars['BigDecimal']['input']>;
  rateGroupId?: InputMaybe<Scalars['Int']['input']>;
  rateManagerCode?: InputMaybe<Scalars['String']['input']>;
  realPriceListId?: InputMaybe<Scalars['Int']['input']>;
  releaseDays?: InputMaybe<Scalars['Int']['input']>;
  releaseHour?: InputMaybe<Scalars['Int']['input']>;
  sendChannelManagerPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showDescriptionOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  validityIndexId?: InputMaybe<Scalars['Int']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  virtualDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  virtualModifier?: InputMaybe<Scalars['BigDecimal']['input']>;
  virtualModifierPerPerson?: InputMaybe<Scalars['Boolean']['input']>;
  virtualType?: InputMaybe<Scalars['Int']['input']>;
  virtualTypeEnum?: InputMaybe<VirtualTypeEnumDto>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProductDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** basePrice greater than or equal to */
  basePriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** basePrice less than or equal to */
  basePriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  category2Id?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  defaultPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEnLike?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  notesEnLike?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reorder?: InputMaybe<Scalars['Int']['input']>;
  reorderLower?: InputMaybe<Scalars['Int']['input']>;
  reorderNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  reorderUpper?: InputMaybe<Scalars['Int']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  stockLower?: InputMaybe<Scalars['Int']['input']>;
  stockNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  stockUnderReorder?: InputMaybe<Scalars['Boolean']['input']>;
  stockUpper?: InputMaybe<Scalars['Int']['input']>;
  upperDescription?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPurchasedProductDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate equal to - format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginDate greater than or equal to - format: YYYY-MM-DD */
  beginDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  beginDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate less than or equal to - format: YYYY-MM-DD */
  beginDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  category2Id?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** creation greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  creationLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** creation less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  creationUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** endDate equal to - format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endDate greater than or equal to - format: YYYY-MM-DD */
  endDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  endDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  endDateNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** endDate less than or equal to - format: YYYY-MM-DD */
  endDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  fromChannelManager?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** To have a query excluding an object */
  idNotEqualTo?: InputMaybe<Scalars['Int']['input']>;
  inclusionMode?: InputMaybe<InclusionModeDto>;
  /** deprecated - use inclusionMode instead */
  inclusionModeId?: InputMaybe<Scalars['Int']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag that indicates if this Service has been completely invoiced. NB: completely, the Service could be divided in several invoices! */
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated - use fromChannelManager instead */
  isFromChannelManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** lastModification greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  lastModificationLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** lastModification less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  lastModificationUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  masterServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description, price, beginDate, endDate, date */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag that indicates if the price of this Service it's locked or must be recalculated each time something changes */
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  proposalIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  quantityLower?: InputMaybe<Scalars['Int']['input']>;
  quantityUpper?: InputMaybe<Scalars['Int']['input']>;
  reservationChannelManagerId?: InputMaybe<Scalars['String']['input']>;
  /** reservationDate equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** reservationDate greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDateLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** reservationDate less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDateUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  /** true for reservation services, false for estimate proposals services */
  reservationIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  reservationOtaId?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPurchasedStayDtoInput = {
  /** addedBed greater than or equal to */
  addedBedLower?: InputMaybe<Scalars['Int']['input']>;
  /** addedBed less than or equal to */
  addedBedUpper?: InputMaybe<Scalars['Int']['input']>;
  /** addedJuniorBed greater than or equal to */
  addedJuniorBedLower?: InputMaybe<Scalars['Int']['input']>;
  /** addedJuniorBed less than or equal to */
  addedJuniorBedUpper?: InputMaybe<Scalars['Int']['input']>;
  agencyCorpNameStart?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['Int']['input']>;
  agencyVoucher?: InputMaybe<Scalars['String']['input']>;
  agencyVoucherStart?: InputMaybe<Scalars['String']['input']>;
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** arrival greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  arrivalLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** arrival less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  arrivalUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate equal to - format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginDate greater than or equal to - format: YYYY-MM-DD */
  beginDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  beginDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate less than or equal to - format: YYYY-MM-DD */
  beginDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerIdForManualReservation?: InputMaybe<Scalars['String']['input']>;
  checkInDone?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutDone?: InputMaybe<Scalars['Boolean']['input']>;
  companyCorpNameStart?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** cradle greater than or equal to */
  cradleLower?: InputMaybe<Scalars['Int']['input']>;
  /** cradle less than or equal to */
  cradleUpper?: InputMaybe<Scalars['Int']['input']>;
  /** creation greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  creationLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** creation less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  creationUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** departure greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  departureLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** departure less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  departureUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  discountFixed?: InputMaybe<Scalars['Boolean']['input']>;
  divideBed?: InputMaybe<Scalars['Boolean']['input']>;
  doorLockCode?: InputMaybe<Scalars['String']['input']>;
  /** endDate equal to - format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endDate greater than or equal to - format: YYYY-MM-DD */
  endDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  endDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  endDateNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** endDate less than or equal to - format: YYYY-MM-DD */
  endDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  groupDescriptionStart?: InputMaybe<Scalars['String']['input']>;
  housekeeperNotesLike?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** To have a query excluding an object */
  idNotEqualTo?: InputMaybe<Scalars['Int']['input']>;
  inclusionMode?: InputMaybe<InclusionModeDto>;
  /** deprecated - use inclusionMode instead */
  inclusionModeId?: InputMaybe<Scalars['Int']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag that indicates if this Service has been completely invoiced. NB: completely, the Service could be divided in several invoices! */
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** lastModification greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  lastModificationLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** lastModification less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  lastModificationUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  mainCustomerId?: InputMaybe<Scalars['Int']['input']>;
  mainCustomerName?: InputMaybe<Scalars['String']['input']>;
  mainCustomerNameStart?: InputMaybe<Scalars['String']['input']>;
  mainCustomerSurname?: InputMaybe<Scalars['String']['input']>;
  mainCustomerSurnameStart?: InputMaybe<Scalars['String']['input']>;
  masterServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** numberOfGuests greater than or equal to */
  numberOfGuestsLower?: InputMaybe<Scalars['Int']['input']>;
  /** numberOfGuests less than or equal to */
  numberOfGuestsUpper?: InputMaybe<Scalars['Int']['input']>;
  optionNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed values: id, description, price, beginDate, endDate, date, arrival */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  originalStayId?: InputMaybe<Scalars['Int']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag that indicates if the price of this Service it's locked or must be recalculated each time something changes */
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  proposalIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  purchasedPacketId?: InputMaybe<Scalars['Int']['input']>;
  purchasedStayIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rackMessageLike?: InputMaybe<Scalars['String']['input']>;
  reservationChannelManagerId?: InputMaybe<Scalars['String']['input']>;
  /** reservationDate equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** reservationDate greater than or equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDateLower?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** reservationDate less than or equal to - format: YYYY-MM-DDThh:mm:ss */
  reservationDateUpper?: InputMaybe<Scalars['LocalDateTime']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  /** true for reservation services, false for estimate proposals services */
  reservationIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  reservationOtaId?: InputMaybe<Scalars['String']['input']>;
  restaurantNotesLike?: InputMaybe<Scalars['String']['input']>;
  roomFloor?: InputMaybe<Scalars['Int']['input']>;
  roomGadget2Id?: InputMaybe<Scalars['Int']['input']>;
  roomGadgetId?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  roomIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  roomIp?: InputMaybe<Scalars['String']['input']>;
  roomLocked?: InputMaybe<Scalars['Boolean']['input']>;
  roomPsIstatGroup?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  startFbWithLunch?: InputMaybe<Scalars['Boolean']['input']>;
  stayId?: InputMaybe<Scalars['Int']['input']>;
  stayIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  travelInsuranceCouponId?: InputMaybe<Scalars['Int']['input']>;
  virtualOrNullRoom?: InputMaybe<Scalars['Boolean']['input']>;
  virtualRoom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPurchasedStayExtendedDtoInput = {
  /** beginDate greater than or equal to - format: YYYY-MM-DD, max days between beginDateLower and endDateUpper is 31 */
  beginDateLower: Scalars['LocalDate']['input'];
  /** endDate less than or equal to - format: YYYY-MM-DD, max days between beginDateLower and endDateUpper is 31 */
  endDateUpper: Scalars['LocalDate']['input'];
  /** text to search across room and invoice holder fields */
  searchTerm: Scalars['String']['input'];
  status?: InputMaybe<PurchasedStayStatusEnumDto>;
  statuses?: InputMaybe<Array<InputMaybe<PurchasedStayStatusEnumDto>>>;
};

export type QueryPurchasedStayExtendedPaginatedDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate greater than or equal to - format: YYYY-MM-DD */
  beginDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endDate less than or equal to - format: YYYY-MM-DD */
  endDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description, price, beginDate, endDate, date, arrival */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  reservationInvoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PurchasedStayStatusEnumDto>;
};

export type QueryResStatusDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  blue?: InputMaybe<Scalars['Int']['input']>;
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, name */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  red?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryReservationDtoInput = {
  agencyCorpNameStart?: InputMaybe<Scalars['String']['input']>;
  agencyCustomerCodeNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  agencyId?: InputMaybe<Scalars['Int']['input']>;
  agencyIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** beginDate equal to - format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginDate greater than or equal to - format: YYYY-MM-DD */
  beginDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** beginDate less than or equal to - format: YYYY-MM-DD */
  beginDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  channelIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  channelManagerId?: InputMaybe<Scalars['String']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  companyCorpNameStart?: InputMaybe<Scalars['String']['input']>;
  companyCustomerCodeNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** date greater than or equal to - format: YYYY-MM-DD */
  dateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date less than or equal to - format: YYYY-MM-DD */
  dateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endDate equal to - format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** endDate greater than or equal to - format: YYYY-MM-DD */
  endDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  endDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  endDateNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** endDate less than or equal to - format: YYYY-MM-DD */
  endDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  groupIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  groupIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** list of reservationId */
  idIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Invoiced services */
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainCustomerCustomerCodeNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  mainCustomerId?: InputMaybe<Scalars['Int']['input']>;
  mainCustomerIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  mainCustomerSurnameStart?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Search only for active and future Reservation: reservations that have begun or that have to begin in the future */
  onlyActiveAndFutureReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search only for active Reservation. A Reservation is active if has a Service that has begun or that is not yet finished */
  onlyActiveReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** optionDate equal to - format: YYYY-MM-DD */
  optionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** optionDate greater than or equal to - format: YYYY-MM-DD */
  optionDateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  optionDateNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** optionDate less than or equal to - format: YYYY-MM-DD */
  optionDateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** allowed values: id, beginDate, owner, date */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  otaId?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  resStatus?: InputMaybe<Scalars['String']['input']>;
  resStatusId?: InputMaybe<Scalars['Int']['input']>;
  /** ReservationOwnerId is the OR between mainCustomerId, companyId and agencyId */
  reservationOwnerId?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryResourceDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** basePrice greater than or equal to */
  basePriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** basePrice less than or equal to */
  basePriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEnLike?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  notesEnLike?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** allowed values: id, description */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<ResourceReferenceTypeDto>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRoomDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  /** assignmentOrder equal to */
  assignmentOrder?: InputMaybe<Scalars['Int']['input']>;
  /** assignmentOrder greater than or equal to */
  assignmentOrderLower?: InputMaybe<Scalars['Int']['input']>;
  /** assignmentOrder less than or equal to */
  assignmentOrderUpper?: InputMaybe<Scalars['Int']['input']>;
  divisibleBed?: InputMaybe<Scalars['Boolean']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  housekeepingStatus?: InputMaybe<HousekeepingStatusDto>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlockGroup?: InputMaybe<Scalars['Int']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ipNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  istatId?: InputMaybe<Scalars['String']['input']>;
  maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  numberStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, number, assignmentOrder, plannerOrder */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  plannerOrder?: InputMaybe<Scalars['Int']['input']>;
  psId?: InputMaybe<Scalars['String']['input']>;
  psIstatGroup?: InputMaybe<Scalars['Int']['input']>;
  ready?: InputMaybe<Scalars['Boolean']['input']>;
  roomGroup?: InputMaybe<Scalars['Int']['input']>;
  roomStatusId?: InputMaybe<Scalars['Int']['input']>;
  stayId?: InputMaybe<Scalars['Int']['input']>;
  stayIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRoomStatusDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  blue?: InputMaybe<Scalars['Int']['input']>;
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, name */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  red?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySegmentDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameStart?: InputMaybe<Scalars['String']['input']>;
  /** allowed values: id, name */
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStayDtoInput = {
  addedBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  ageAddedCradle?: InputMaybe<Scalars['Int']['input']>;
  ageAddedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** basePrice greater than or equal to */
  basePriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** basePrice less than or equal to */
  basePriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  channelManagerPriceListId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  channelManagerPriceListIdNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  channelManagerPriceListIdNull?: InputMaybe<Scalars['Boolean']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEnLike?: InputMaybe<Scalars['String']['input']>;
  descriptionEnStart?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  descriptionStart?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  extraBreakfast?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinner?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunch?: InputMaybe<Scalars['BigDecimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** maxNumberOfGuests equal to */
  maxNumberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  /** maxNumberOfGuests greater than or equal to */
  maxNumberOfGuestsLower?: InputMaybe<Scalars['Int']['input']>;
  /** maxNumberOfGuests less than or equal to */
  maxNumberOfGuestsUpper?: InputMaybe<Scalars['Int']['input']>;
  /** maxPrice greater than or equal to */
  maxPriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** maxPrice less than or equal to */
  maxPriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** minPrice greater than or equal to */
  minPriceLower?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** minPrice less than or equal to */
  minPriceUpper?: InputMaybe<Scalars['BigDecimal']['input']>;
  notesEnLike?: InputMaybe<Scalars['String']['input']>;
  notesLike?: InputMaybe<Scalars['String']['input']>;
  /** numberOfGuests equal to */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  /** numberOfGuests greater than or equal to */
  numberOfGuestsLower?: InputMaybe<Scalars['Int']['input']>;
  /** numberOfGuests less than or equal to */
  numberOfGuestsUpper?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyOta?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed values: id, description, numberOfGuests, basePrice, webOrder */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceAddedBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedJuniorBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  /** list of priceListId */
  priceListIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rateManagerCode?: InputMaybe<Scalars['String']['input']>;
  realStayId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export enum RackMessageModeDto {
  RackMessageModeCheckOut = 'RACK_MESSAGE_MODE_CHECK_OUT',
  RackMessageModeCreateInvoice = 'RACK_MESSAGE_MODE_CREATE_INVOICE',
  RackMessageModeInvoice = 'RACK_MESSAGE_MODE_INVOICE',
  RackMessageModePlanner = 'RACK_MESSAGE_MODE_PLANNER',
  RackMessageModeStandard = 'RACK_MESSAGE_MODE_STANDARD'
}

export enum RelatedDocumentTypeDto {
  Contratto = 'CONTRATTO',
  Convenzione = 'CONVENZIONE',
  FattureCollegate = 'FATTURE_COLLEGATE',
  OrdineAcquisto = 'ORDINE_ACQUISTO',
  Ricezione = 'RICEZIONE'
}

export type RemoveStayImageRequestDtoInput = {
  bolImage: BolImageEnumDto;
  stayId: Scalars['Int']['input'];
};

export type ResStatusDto = {
  __typename?: 'ResStatusDTO';
  blue: Maybe<Scalars['Int']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export type ResStatusPlannerDto = {
  __typename?: 'ResStatusPlannerDTO';
  blue: Maybe<Scalars['Int']['output']>;
  green: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  red: Maybe<Scalars['Int']['output']>;
};

export type ReservationDto = {
  __typename?: 'ReservationDTO';
  /** at least one of mainCustomer, agency and company is always set */
  agency: Maybe<AgencyDto>;
  agencyId: Maybe<Scalars['Int']['output']>;
  channel: Maybe<ChannelDto>;
  channelId: Maybe<Scalars['Int']['output']>;
  channelManagerId: Maybe<Scalars['String']['output']>;
  /** at least one of mainCustomer, agency and company is always set */
  company: Maybe<CompanyDto>;
  companyId: Maybe<Scalars['Int']['output']>;
  contactPhones: Scalars['String']['output'];
  /** deprecated - use getCreditCardImageType instead */
  creditCardImageType: CreditCardImageTypeDto;
  dailyActivities: Array<DailyActivityDto>;
  /** date and time the reservation was created */
  date: Scalars['LocalDateTime']['output'];
  documentFolder: Maybe<Scalars['String']['output']>;
  group: Maybe<GroupDto>;
  groupId: Maybe<Scalars['Int']['output']>;
  hoursActivities: Array<HoursActivityDto>;
  id: Scalars['Int']['output'];
  isAllInvoiced: Scalars['Boolean']['output'];
  /** at least one of mainCustomer, agency and company is always set */
  mainCustomer: Maybe<CustomerDto>;
  mainCustomerId: Maybe<Scalars['Int']['output']>;
  optionDate: Maybe<Scalars['LocalDate']['output']>;
  otaId: Maybe<Scalars['String']['output']>;
  /** identifies the property in a corporate installation */
  ownerId: Scalars['Int']['output'];
  purchasedOptionals: Array<PurchasedOptionalDto>;
  purchasedPackets: Array<PurchasedPacketDto>;
  purchasedProducts: Array<PurchasedProductDto>;
  purchasedStays: Array<PurchasedStayDto>;
  resStatus: Maybe<ResStatusDto>;
  resStatusId: Maybe<Scalars['Int']['output']>;
  segment: Maybe<SegmentDto>;
  segmentId: Maybe<Scalars['Int']['output']>;
  totalPrice: Scalars['BigDecimal']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type ReservationListPaginatedDto = {
  __typename?: 'ReservationListPaginatedDTO';
  pagination: PaginationDto;
  reservations: Array<ReservationDto>;
};

export type ReservationPlannerDto = {
  __typename?: 'ReservationPlannerDTO';
  agency: Maybe<AgencyPlannerDto>;
  channel: Maybe<ChannelPlannerDto>;
  company: Maybe<CompanyPlannerDto>;
  contactPhones: Maybe<Scalars['String']['output']>;
  date: Scalars['LocalDate']['output'];
  group: Maybe<GroupPlannerDto>;
  id: Scalars['Int']['output'];
  isAllInvoiced: Scalars['Boolean']['output'];
  mainCustomer: Maybe<CustomerPlannerDto>;
  purchasedStays: Array<PurchasedStayPlannerDto>;
  resStatus: Maybe<ResStatusPlannerDto>;
  segment: Maybe<SegmentPlannerDto>;
  totalPrice: Scalars['BigDecimal']['output'];
};

export type ReservationWizardRateDto = {
  __typename?: 'ReservationWizardRateDTO';
  description: Maybe<Scalars['String']['output']>;
  packet: Maybe<PacketDto>;
  priceList: Maybe<PriceListDto>;
};

export type ReservationWizardRateMapDto = {
  __typename?: 'ReservationWizardRateMapDTO';
  rates: Array<ReservationWizardRateDto>;
  stayId: Scalars['Int']['output'];
};

export type ResolveCashRegisterRequestDtoInput = {
  invoiceId: Scalars['Int']['input'];
  localIpAddress: Scalars['String']['input'];
};

export type ResolveOwnerCorporateDataRequestDtoInput = {
  block?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceDto = {
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  priceLists: Array<PriceListDto>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
};

export type ResourceListPaginatedDto = {
  __typename?: 'ResourceListPaginatedDTO';
  pagination: PaginationDto;
  resources: Array<ResourceReferenceDto>;
};

export type ResourceReferenceDto = {
  __typename?: 'ResourceReferenceDTO';
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  exportCode: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
  priceLists: Array<PriceListDto>;
  type: ResourceReferenceTypeDto;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
};

export enum ResourceReferenceTypeDto {
  DailyResource = 'DAILY_RESOURCE',
  HoursResource = 'HOURS_RESOURCE',
  Optional = 'OPTIONAL',
  Packet = 'PACKET',
  Product = 'PRODUCT',
  Stay = 'STAY'
}

export type ResourceValidationResultDto = {
  __typename?: 'ResourceValidationResultDTO';
  resourceId: Scalars['Int']['output'];
  validationErrors: Maybe<Array<Maybe<ValidationErrorDto>>>;
};

export type RoomAmenityDto = {
  __typename?: 'RoomAmenityDTO';
  descriptionDE: Maybe<Scalars['String']['output']>;
  descriptionEN: Maybe<Scalars['String']['output']>;
  descriptionES: Maybe<Scalars['String']['output']>;
  descriptionFR: Maybe<Scalars['String']['output']>;
  descriptionIT: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type RoomDto = {
  __typename?: 'RoomDTO';
  assignmentOrder: Scalars['Int']['output'];
  divisibleBed: Scalars['Boolean']['output'];
  facilities: Array<ParameterValueDto>;
  floor: Maybe<Scalars['Int']['output']>;
  housekeepingStatus: Maybe<HousekeepingStatusDto>;
  id: Scalars['Int']['output'];
  invoiceBlockGroup: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  istatId: Maybe<Scalars['String']['output']>;
  maintenance: Maybe<Scalars['Boolean']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  plannerOrder: Maybe<Scalars['Int']['output']>;
  psId: Maybe<Scalars['String']['output']>;
  psIstatGroup: Maybe<Scalars['Int']['output']>;
  roomGroup: Maybe<Scalars['Int']['output']>;
  roomPreparationId: Maybe<Scalars['Int']['output']>;
  roomStatus: Maybe<RoomStatusDto>;
  roomStatusId: Maybe<Scalars['Int']['output']>;
  stay: StayDto;
  stayId: Scalars['Int']['output'];
  telephone: Maybe<Scalars['String']['output']>;
  virtual: Scalars['Boolean']['output'];
};

export enum RoomInStillOutReportNoteDisplayModeEnumDto {
  Generic = 'GENERIC',
  Housekeeper = 'HOUSEKEEPER',
  RackMessage = 'RACK_MESSAGE',
  Restaurant = 'RESTAURANT'
}

export enum RoomInStillOutReportOrderByEnumDto {
  BeginDate = 'BEGIN_DATE',
  Room = 'ROOM',
  Surname = 'SURNAME'
}

export enum RoomInStillOutReportPriceDisplayModeEnumDto {
  None = 'NONE',
  NotInvoiced = 'NOT_INVOICED',
  Reservation = 'RESERVATION',
  Room = 'ROOM'
}

export type RoomInStillOutReportTypeDto = {
  __typename?: 'RoomInStillOutReportTypeDTO';
  endDate: Scalars['Boolean']['output'];
  holder: Scalars['Boolean']['output'];
  onlyNotAlreadyIn: Scalars['Boolean']['output'];
  onlyNotAlreadyOut: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  ordering: Scalars['Boolean']['output'];
  printNotes: Scalars['Boolean']['output'];
  showAllGuests: Scalars['Boolean']['output'];
  showChannel: Scalars['Boolean']['output'];
  showCheckInReady: Scalars['Boolean']['output'];
  showCompanyAgency: Scalars['Boolean']['output'];
  showContactPhone: Scalars['Boolean']['output'];
  showGroup: Scalars['Boolean']['output'];
  showId: Scalars['Boolean']['output'];
  showIn: Scalars['Boolean']['output'];
  showMeal: Scalars['Boolean']['output'];
  showNumberPlates: Scalars['Boolean']['output'];
  showOut: Scalars['Boolean']['output'];
  showPrice: Scalars['Boolean']['output'];
  showRoomChanges: Scalars['Boolean']['output'];
  showStill: Scalars['Boolean']['output'];
  type: RoomInStillOutReportTypeEnumDto;
};

export enum RoomInStillOutReportTypeEnumDto {
  RoomBillIn = 'ROOM_BILL_IN',
  RoomBillOut = 'ROOM_BILL_OUT',
  RoomBillStill = 'ROOM_BILL_STILL',
  RoomIn = 'ROOM_IN',
  RoomInFree = 'ROOM_IN_FREE',
  RoomInStillOut = 'ROOM_IN_STILL_OUT',
  RoomInStillOut_1Day = 'ROOM_IN_STILL_OUT_1_DAY',
  RoomInStillOutPlanning = 'ROOM_IN_STILL_OUT_PLANNING',
  RoomOut = 'ROOM_OUT',
  RoomStill = 'ROOM_STILL'
}

export type RoomPlannerDto = {
  __typename?: 'RoomPlannerDTO';
  id: Scalars['Int']['output'];
  virtual: Scalars['Boolean']['output'];
};

export enum RoomPrepareReportNoteDisplayModeEnumDto {
  Generic = 'GENERIC',
  Housekeeper = 'HOUSEKEEPER',
  RackMessage = 'RACK_MESSAGE',
  Restaurant = 'RESTAURANT'
}

export type RoomPrepareReportTypeDto = {
  __typename?: 'RoomPrepareReportTypeDTO';
  endDate: Scalars['Boolean']['output'];
  floor: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  printNotes: Scalars['Boolean']['output'];
  showRoomOwner: Scalars['Boolean']['output'];
  showVoidRooms: Scalars['Boolean']['output'];
  type: RoomPrepareReportTypeEnumDto;
};

export enum RoomPrepareReportTypeEnumDto {
  DailyActivity = 'DAILY_ACTIVITY',
  DiningHallPrepare = 'DINING_HALL_PREPARE',
  HoursActivity = 'HOURS_ACTIVITY',
  MealGroup = 'MEAL_GROUP',
  MealInStillOut = 'MEAL_IN_STILL_OUT',
  MealPlanning = 'MEAL_PLANNING',
  RoomActual = 'ROOM_ACTUAL',
  RoomMeal = 'ROOM_MEAL',
  RoomMeal_1Day = 'ROOM_MEAL_1_DAY',
  RoomPrepare = 'ROOM_PREPARE',
  RoomPrepare_1Day = 'ROOM_PREPARE_1_DAY',
  RoomPrepareNew = 'ROOM_PREPARE_NEW',
  RoomPrepareSmart = 'ROOM_PREPARE_SMART'
}

export type RoomStatusDto = {
  __typename?: 'RoomStatusDTO';
  blue: Scalars['Int']['output'];
  green: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  red: Scalars['Int']['output'];
};

export type SaveCustomersWithFamilyRepRequestDtoInput = {
  customerIds: Array<Scalars['Int']['input']>;
  familyRepId: Scalars['Int']['input'];
};

export type SaveGridPricesRequestDtoInput = {
  stayToPriceListPrices: Array<StayToPriceListPricesDtoInput>;
};

export type SaveGridWebAvailabilitiesRequestDtoInput = {
  stayToDailyWebAvailabilities: Array<StayToDailyWebAvailabilitiesDtoInput>;
};

export type SavePricesRequestDtoInput = {
  beginDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
  priceInfos: Array<PriceInfoDtoInput>;
  weekDays: Array<WeekDayEnumDto>;
};

export type SavePrintedDocumentDataRequestDtoInput = {
  cashRegisterNumber: Scalars['String']['input'];
  closure: Scalars['String']['input'];
  documentNumber: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
};

export type SaveWebAvailabilitiesRequestDtoInput = {
  /** begin date of the range to update (inclusive) */
  beginDate: Scalars['LocalDate']['input'];
  /** end date of the range to update (inclusive) */
  endDate: Scalars['LocalDate']['input'];
  webAvailabilityInfos: Array<WebAvailabilityInfoDtoInput>;
  weekDays: Array<WeekDayEnumDto>;
};

export type SearchElectronicInvoiceDataPaginatedRequestDtoInput = {
  /** default true */
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  blockNullOrEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** date greater than or equal to - format: YYYY-MM-DD */
  dateLower?: InputMaybe<Scalars['LocalDate']['input']>;
  /** date less than or equal to - format: YYYY-MM-DD */
  dateUpper?: InputMaybe<Scalars['LocalDate']['input']>;
  /** eInvoice send status. Mutually exclusive with eInvoiceStatusNull: setting both is rejected */
  eInvoiceStatus?: InputMaybe<EInvoiceStatusEnumDto>;
  /** true to get only the invoices never sent, that is with no eInvoice send status. Mutually exclusive with eInvoiceStatus: setting both is rejected */
  eInvoiceStatusNull?: InputMaybe<Scalars['Boolean']['input']>;
  holderId?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return (pagination limit). Example: with offset=1 and limit=2, you'll get items 2 and 3. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results to skip (offset-based pagination). Use 0 to start from the beginning. Example: if offset=2 and limit=3, you'll get items 3, 4, and 5. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** default ID */
  orderBy?: InputMaybe<ElectronicInvoiceDataOrderByEnumDto>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchElectronicInvoiceDataPaginatedResponseDto = {
  __typename?: 'SearchElectronicInvoiceDataPaginatedResponseDTO';
  pagination: PaginationDto;
  results: Array<ElectronicInvoiceDataDto>;
};

export type SearchReservationPlannerRequestDtoInput = {
  from: Scalars['LocalDate']['input'];
  reservationIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roomIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to: Scalars['LocalDate']['input'];
};

export type SegmentDto = {
  __typename?: 'SegmentDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SegmentPlannerDto = {
  __typename?: 'SegmentPlannerDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SellReportTypeDto = {
  __typename?: 'SellReportTypeDTO';
  category: Scalars['Boolean']['output'];
  category2: Scalars['Boolean']['output'];
  channel: Scalars['Boolean']['output'];
  excludeOptions: Scalars['Boolean']['output'];
  excludeVat: Scalars['Boolean']['output'];
  holder: Scalars['Boolean']['output'];
  mealDeduction: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  psIstatGroup: Scalars['Boolean']['output'];
  resource: Scalars['Boolean']['output'];
  segment: Scalars['Boolean']['output'];
  stay: Scalars['Boolean']['output'];
  type: SellReportTypeEnumDto;
  yearAndMonth: Scalars['Boolean']['output'];
};

export enum SellReportTypeEnumDto {
  AggregateSellReport = 'AGGREGATE_SELL_REPORT',
  Channel = 'CHANNEL',
  DailyCategoryProduction = 'DAILY_CATEGORY_PRODUCTION',
  DailyChannelPeopleProduction = 'DAILY_CHANNEL_PEOPLE_PRODUCTION',
  DailyChannelProduction = 'DAILY_CHANNEL_PRODUCTION',
  DailyChannelRealStayProduction = 'DAILY_CHANNEL_REAL_STAY_PRODUCTION',
  DailyChannelStayProduction = 'DAILY_CHANNEL_STAY_PRODUCTION',
  DailyPeopleProduction = 'DAILY_PEOPLE_PRODUCTION',
  DailyPeopleStayProduction = 'DAILY_PEOPLE_STAY_PRODUCTION',
  DailyProduction = 'DAILY_PRODUCTION',
  DailyStayProduction = 'DAILY_STAY_PRODUCTION',
  DailyStayProductionOriginalStay = 'DAILY_STAY_PRODUCTION_ORIGINAL_STAY',
  DailyStayProductionRealStay = 'DAILY_STAY_PRODUCTION_REAL_STAY',
  NationalityReport = 'NATIONALITY_REPORT',
  Resource = 'RESOURCE',
  StayByCheckInDate = 'STAY_BY_CHECK_IN_DATE',
  StayByReservationDate = 'STAY_BY_RESERVATION_DATE'
}

export type SendAllResponseDto = {
  __typename?: 'SendAllResponseDTO';
  results: Array<SendResultDto>;
};

export type SendAstatDailyFacilityClosureRequestDtoInput = {
  closureBeginDate: Scalars['LocalDate']['input'];
  closureEndDate: Scalars['LocalDate']['input'];
  ownerIstatId: Scalars['Int']['input'];
};

export type SendAstatDailyIstatClosureRequestDtoInput = {
  month: Scalars['Int']['input'];
  ownerIstatId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type SendIstatRequestDtoInput = {
  availableBeds?: InputMaybe<Scalars['Int']['input']>;
  availableRooms?: InputMaybe<Scalars['Int']['input']>;
  istatCustomerIdsToInclude: Array<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  ownerIstatId: Scalars['Int']['input'];
  referenceDate?: InputMaybe<Scalars['LocalDate']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SendPsCustomersRequestDtoInput = {
  date: Scalars['LocalDate']['input'];
  ownerPublicSecurityId: Scalars['Int']['input'];
  purchasedStayToCustomerIdsToInclude: Array<Scalars['Int']['input']>;
};

export type SendResultDto = {
  __typename?: 'SendResultDTO';
  error: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['Int']['output'];
};

export type ServiceDto = {
  beginDate: Maybe<Scalars['LocalDate']['output']>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  creation: Maybe<Scalars['LocalDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  /** it's mandatory with masterServiceId set */
  inclusionMode: Maybe<InclusionModeDto>;
  inclusionModeId: Maybe<Scalars['Int']['output']>;
  invoiceHolderId: Maybe<Scalars['Int']['output']>;
  invoiced: Scalars['Boolean']['output'];
  lastModification: Maybe<Scalars['LocalDateTime']['output']>;
  masterServiceId: Maybe<Scalars['Int']['output']>;
  price: Scalars['BigDecimal']['output'];
  priceList: Maybe<PriceListDto>;
  priceListId: Maybe<Scalars['Int']['output']>;
  priceLocked: Scalars['Boolean']['output'];
  proposalId: Maybe<Scalars['Int']['output']>;
  reservationId: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['Int']['output'];
};

export enum SexDto {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type StateDto = {
  __typename?: 'StateDTO';
  alpha3Code: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['Int']['output']>;
  /** State id (in Italy => codice catasto) */
  fiscalCodeId: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  languageCode: Maybe<Scalars['String']['output']>;
  nameDE: Maybe<Scalars['String']['output']>;
  nameEN: Maybe<Scalars['String']['output']>;
  nameES: Maybe<Scalars['String']['output']>;
  nameFR: Maybe<Scalars['String']['output']>;
  nameIT: Maybe<Scalars['String']['output']>;
  numericCode: Maybe<Scalars['String']['output']>;
  /** International phone prefix */
  phoneCode: Maybe<Scalars['String']['output']>;
  psId: Maybe<Scalars['String']['output']>;
  teamSystemCode: Maybe<Scalars['String']['output']>;
  validFrom: Maybe<Scalars['LocalDate']['output']>;
  validTo: Maybe<Scalars['LocalDate']['output']>;
  /** International vehicle registration code */
  vehicleRegistrationCode: Maybe<Scalars['String']['output']>;
};

export type StayDto = ResourceDto & {
  __typename?: 'StayDTO';
  addedBedFixed: Scalars['Boolean']['output'];
  addedJuniorBedFixed: Scalars['Boolean']['output'];
  ageAddedCradle: Maybe<Scalars['Int']['output']>;
  ageAddedJuniorBed: Maybe<Scalars['Int']['output']>;
  available: Scalars['Boolean']['output'];
  basePrice: Scalars['BigDecimal']['output'];
  breakfast: Scalars['Boolean']['output'];
  channelManagerCode: Maybe<Scalars['String']['output']>;
  channelManagerPriceList: Maybe<PriceListDto>;
  channelManagerPriceListId: Maybe<Scalars['Int']['output']>;
  costCenter: Maybe<CostCenterDto>;
  costCenterId: Maybe<Scalars['Int']['output']>;
  defaultPriceListId: Maybe<Scalars['Int']['output']>;
  departmentId: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  descriptionDe: Maybe<Scalars['String']['output']>;
  descriptionEn: Maybe<Scalars['String']['output']>;
  descriptionEs: Maybe<Scalars['String']['output']>;
  descriptionFr: Maybe<Scalars['String']['output']>;
  dinner: Scalars['Boolean']['output'];
  /** deprecated */
  endpointCode: Maybe<Scalars['String']['output']>;
  exportCode: Maybe<Scalars['String']['output']>;
  extraBreakfast: Maybe<Scalars['BigDecimal']['output']>;
  extraDinner: Maybe<Scalars['BigDecimal']['output']>;
  extraLunch: Maybe<Scalars['BigDecimal']['output']>;
  id: Scalars['Int']['output'];
  lunch: Scalars['Boolean']['output'];
  maxNumberOfGuests: Scalars['Int']['output'];
  maxPrice: Maybe<Scalars['BigDecimal']['output']>;
  minPrice: Maybe<Scalars['BigDecimal']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  notesDe: Maybe<Scalars['String']['output']>;
  notesEn: Maybe<Scalars['String']['output']>;
  notesEs: Maybe<Scalars['String']['output']>;
  notesFr: Maybe<Scalars['String']['output']>;
  numberOfGuests: Scalars['Int']['output'];
  onlyOta: Scalars['Boolean']['output'];
  ownerId: Scalars['Int']['output'];
  priceAddedBed: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedCradle: Maybe<Scalars['BigDecimal']['output']>;
  priceAddedJuniorBed: Maybe<Scalars['BigDecimal']['output']>;
  priceLists: Array<PriceListDto>;
  rateManagerCode: Maybe<Scalars['String']['output']>;
  realStay: Maybe<StayDto>;
  realStayId: Maybe<Scalars['Int']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['BigDecimal']['output']>;
  vatRateId: Maybe<Scalars['Int']['output']>;
  virtual: Scalars['Boolean']['output'];
  webOrder: Maybe<Scalars['Int']['output']>;
};

export type StayDailyInventoryDto = {
  __typename?: 'StayDailyInventoryDTO';
  dayToInventories: Array<DayToInventoryDto>;
  stayId: Scalars['Int']['output'];
};

export type StayDailyWebAvailabilityDto = {
  __typename?: 'StayDailyWebAvailabilityDTO';
  dailyAvailabilities: Array<DailyWebAvailabilityDto>;
  stayId: Scalars['Int']['output'];
};

export type StayDataDto = {
  __typename?: 'StayDataDTO';
  fullImage1Url: Maybe<Scalars['String']['output']>;
  fullImage2Url: Maybe<Scalars['String']['output']>;
  fullImage3Url: Maybe<Scalars['String']['output']>;
  fullImage4Url: Maybe<Scalars['String']['output']>;
  fullImage5Url: Maybe<Scalars['String']['output']>;
  fullImage6Url: Maybe<Scalars['String']['output']>;
  fullImage7Url: Maybe<Scalars['String']['output']>;
  fullImage8Url: Maybe<Scalars['String']['output']>;
  fullImage9Url: Maybe<Scalars['String']['output']>;
  fullImage10Url: Maybe<Scalars['String']['output']>;
  mainImageMaxHeight: Maybe<Scalars['Int']['output']>;
  mainImageMaxWidth: Maybe<Scalars['Int']['output']>;
  mainImageUrl: Maybe<Scalars['String']['output']>;
  onlineIdentificationCode: Maybe<Scalars['String']['output']>;
  smallImage1Url: Maybe<Scalars['String']['output']>;
  smallImage2Url: Maybe<Scalars['String']['output']>;
  smallImage3Url: Maybe<Scalars['String']['output']>;
  smallImage4Url: Maybe<Scalars['String']['output']>;
  smallImage5Url: Maybe<Scalars['String']['output']>;
  smallImage6Url: Maybe<Scalars['String']['output']>;
  smallImage7Url: Maybe<Scalars['String']['output']>;
  smallImage8Url: Maybe<Scalars['String']['output']>;
  smallImage9Url: Maybe<Scalars['String']['output']>;
  smallImage10Url: Maybe<Scalars['String']['output']>;
  stayId: Scalars['Int']['output'];
  staySize: Maybe<Scalars['Int']['output']>;
};

export enum StayOrderByDto {
  Alphabetical = 'ALPHABETICAL',
  BasePrice = 'BASE_PRICE',
  NumberOfGuests = 'NUMBER_OF_GUESTS'
}

export type StayPlannerDto = {
  __typename?: 'StayPlannerDTO';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type StayPriceInputDtoInput = {
  priceListIds: Array<Scalars['Int']['input']>;
  stayId: Scalars['Int']['input'];
};

export type StayToDailyWebAvailabilitiesDtoInput = {
  dailyWebAvailabilities: Array<DailyWebAvailabilityInfoDtoInput>;
  stayId: Scalars['Int']['input'];
};

export type StayToPriceListPricesDto = {
  __typename?: 'StayToPriceListPricesDTO';
  dayToPrices: Array<DayToPriceDto>;
  priceListId: Scalars['Int']['output'];
  stayId: Scalars['Int']['output'];
};

export type StayToPriceListPricesDtoInput = {
  dayToPrices: Array<DayToPriceDtoInput>;
  priceListId: Scalars['Int']['input'];
  stayId: Scalars['Int']['input'];
};

export type StaysSelectionDto = {
  __typename?: 'StaysSelectionDTO';
  maxNumberOfStays: Scalars['Int']['output'];
  onlyAvailableRealStay: Scalars['Boolean']['output'];
  showStaysSelection: Scalars['Boolean']['output'];
  type: SellReportTypeEnumDto;
};

export enum TokenSourceDto {
  BookingEngine = 'BOOKING_ENGINE',
  ChannelManager = 'CHANNEL_MANAGER',
  EstimateConfirm = 'ESTIMATE_CONFIRM',
  External = 'EXTERNAL',
  PaymentLink = 'PAYMENT_LINK',
  PaymentTerminal = 'PAYMENT_TERMINAL',
  PmsIframe = 'PMS_IFRAME',
  SelfCheckout = 'SELF_CHECKOUT'
}

export enum TransactionChargeTypeDto {
  Delayed = 'DELAYED',
  NoShow = 'NO_SHOW'
}

export enum TransactionStatusDto {
  InternalError = 'INTERNAL_ERROR',
  InvalidProcessor = 'INVALID_PROCESSOR',
  Ok = 'OK',
  ScaRequired = 'SCA_REQUIRED',
  TransactionFailed = 'TRANSACTION_FAILED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export enum TransactionTypeDto {
  CancelCharge = 'CANCEL_CHARGE',
  CancelConfirm = 'CANCEL_CONFIRM',
  CancelPreauth = 'CANCEL_PREAUTH',
  CancelRefund = 'CANCEL_REFUND',
  CancelTopUp = 'CANCEL_TOP_UP',
  Charge = 'CHARGE',
  Confirm = 'CONFIRM',
  Preauth = 'PREAUTH',
  Refund = 'REFUND',
  TopUp = 'TOP_UP'
}

export type TransferServiceRequestDtoInput = {
  serviceId: Scalars['Int']['input'];
  sourceReservationId?: InputMaybe<Scalars['Int']['input']>;
  targetReservationId: Scalars['Int']['input'];
};

export type TransferServicesRequestDtoInput = {
  serviceIds: Array<Scalars['Int']['input']>;
  sourceReservationId: Scalars['Int']['input'];
  targetReservationId: Scalars['Int']['input'];
};

export type TransferServicesResultItemDto = {
  __typename?: 'TransferServicesResultItemDTO';
  error: Maybe<BulkItemErrorDto>;
  serviceId: Scalars['Int']['output'];
  transferred: Scalars['Boolean']['output'];
};

export enum TreatmentEnumDto {
  Bb = 'BB',
  Fb = 'FB',
  FbAi = 'FB_AI',
  Hb = 'HB',
  HbAi = 'HB_AI',
  Ro = 'RO'
}

export type UpdateReservationDtoInput = {
  agencyId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  mainCustomerId?: InputMaybe<Scalars['Int']['input']>;
  /** format: YYYY-MM-DD */
  optionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  otaId?: InputMaybe<Scalars['String']['input']>;
  resStatusId?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStatusAllResponseDto = {
  __typename?: 'UpdateStatusAllResponseDTO';
  results: Array<UpdateStatusResultDto>;
};

export type UpdateStatusResultDto = {
  __typename?: 'UpdateStatusResultDTO';
  eInvoiceStatus: Maybe<EInvoiceStatusEnumDto>;
  invoiceId: Scalars['Int']['output'];
};

export type UpsertAgencyDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  blue?: InputMaybe<Scalars['Int']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  commission?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY) */
  corpName?: InputMaybe<Scalars['String']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  district?: InputMaybe<Scalars['String']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  einvoicingCode?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  invoiceType?: InputMaybe<InvoiceDocumentTypeDto>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<PaymentTermsEnumDto>;
  pec?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  publicAdministration?: InputMaybe<Scalars['Boolean']['input']>;
  red?: InputMaybe<Scalars['Int']['input']>;
  referringName?: InputMaybe<Scalars['String']['input']>;
  referringSurname?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** deprecated - use stateId instead. */
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCancellationPolicyDtoInput = {
  bnplStatus?: InputMaybe<BnplStatusEnumDto>;
  /** (MANDATORY if creditCardPolicy is CHARGE or PREAUTH) */
  chargeType?: InputMaybe<ChargeTypeEnumDto>;
  /** Must be greater or equal than 0. If chargeType is PERCENTAGE, must be lesser or equal than 1. (MANDATORY if creditCardPolicy is CHARGE or PREAUTH) */
  chargeValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  condition?: InputMaybe<CancellationPolicyConditionEnumDto>;
  /** (MANDATORY) */
  creditCardPolicy?: InputMaybe<CreditCardPolicyEnumDto>;
  /** Must be greater or equal than 0. (MANDATORY if condition is GUARANTEED) */
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  /** Must be greater or equal than 0 */
  fullRefundableDays?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY if minInstalments or maxInstalments is set) */
  lastInstalment?: InputMaybe<LastInstalmentEnumDto>;
  /** Must be greater or equal than minInstalments, if both are set */
  maxInstalments?: InputMaybe<Scalars['Int']['input']>;
  /** Must be lesser or equal than maxInstalments, if both are set */
  minInstalments?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Must be greater or equal than 0 */
  partialRefundableDays?: InputMaybe<Scalars['Int']['input']>;
  partialRefundableValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY if condition is GUARANTEED) */
  penaltyType?: InputMaybe<PenaltyTypeEnumDto>;
  /** Must be greater or equal than 0. If penaltyType is PERCENTAGE, must be lesser or equal than 1. (MANDATORY if condition is GUARANTEED) */
  penaltyValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  showDescriptionOnWeb?: InputMaybe<Scalars['Boolean']['input']>;
  travelInsurancePolicyId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCashRegisterDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cashRegisterType?: InputMaybe<CashRegisterTypeEnumDto>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleCopy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlocks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localAddress?: InputMaybe<Scalars['String']['input']>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertChannelDtoInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  blue?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** value 0-1 */
  commission?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalCode?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  red?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  typeOfBusinessId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCompanyDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  blue?: InputMaybe<Scalars['Int']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  corpName?: InputMaybe<Scalars['String']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  district?: InputMaybe<Scalars['String']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  einvoicingCode?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  invoiceType?: InputMaybe<InvoiceDocumentTypeDto>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<PaymentTermsEnumDto>;
  pec?: InputMaybe<Scalars['String']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  privacyAuth?: InputMaybe<Scalars['Boolean']['input']>;
  publicAdministration?: InputMaybe<Scalars['Boolean']['input']>;
  red?: InputMaybe<Scalars['Int']['input']>;
  referringName?: InputMaybe<Scalars['String']['input']>;
  referringSurname?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** deprecated - use stateId instead. */
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCostAttributionDtoInput = {
  /** (MANDATORY) between 0 (exclusive) and 100 */
  percentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY) */
  primaryCostId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCustomerDtoInput = {
  /** the difference between the current date and the entered date must be >= 7 */
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** use only for non-Italian places and as an alternative to birthPlaceId */
  birthDistrict?: InputMaybe<Scalars['String']['input']>;
  /** use only for non-Italian places and as an alternative to birthPlaceId */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  birthPlaceId?: InputMaybe<Scalars['Int']['input']>;
  /** deprecated - use birthStateId instead. */
  birthState?: InputMaybe<Scalars['String']['input']>;
  birthStateId?: InputMaybe<Scalars['Int']['input']>;
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerData?: InputMaybe<UpsertCustomerDataDtoInput>;
  documentDeadlineDate?: InputMaybe<Scalars['LocalDate']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentReleaseDate?: InputMaybe<Scalars['LocalDate']['input']>;
  documentReleaser?: InputMaybe<Scalars['String']['input']>;
  documentReleaserCityId?: InputMaybe<Scalars['Int']['input']>;
  documentReleaserState?: InputMaybe<Scalars['Boolean']['input']>;
  documentReleaserStateId?: InputMaybe<Scalars['Int']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  einvoicingCode?: InputMaybe<Scalars['String']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** if set it must be 8 characters long */
  lotteryCode?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  multidbDocumentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** if set it must not contain: #, &, $, £, %, <, > */
  name?: InputMaybe<Scalars['String']['input']>;
  /** deprecated - use nationalityId instead. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pec?: InputMaybe<Scalars['String']['input']>;
  /** Male: false, female: true. Default: male  */
  sex?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated - use stateId instead. */
  state?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) - it must not contain: #, &, $, £, %, <, > */
  surname?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCustomerDataDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  blacklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  cityTaxExemptionId?: InputMaybe<Scalars['Int']['input']>;
  clubMember?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** if present it is always > 0 */
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** use only for non-Italian places and as an alternative to cityId */
  district?: InputMaybe<Scalars['String']['input']>;
  doNotPreauthorize?: InputMaybe<Scalars['Boolean']['input']>;
  documentFolder?: InputMaybe<Scalars['String']['input']>;
  /** must differ from customerId */
  familyRepId?: InputMaybe<Scalars['Int']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  /** list of parameterValues (ParameterId = 11) */
  interests?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** must be <= lastStayEnd - format: YYYY-MM-DD */
  lastStay?: InputMaybe<Scalars['LocalDate']['input']>;
  /** must be >= lastStay - format: YYYY-MM-DD */
  lastStayEnd?: InputMaybe<Scalars['LocalDate']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberplate?: InputMaybe<Scalars['String']['input']>;
  privacyAuth?: InputMaybe<Scalars['Boolean']['input']>;
  privacyAuth2?: InputMaybe<Scalars['Boolean']['input']>;
  privacyAuth3?: InputMaybe<Scalars['Boolean']['input']>;
  /** parameterValueId (ParameterId = 2) */
  professionId?: InputMaybe<Scalars['Int']['input']>;
  sendCheckInMail?: InputMaybe<Scalars['Boolean']['input']>;
  sendCheckOutMail?: InputMaybe<Scalars['Boolean']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** parameterValueId (ParameterId = 3) */
  titleId?: InputMaybe<Scalars['Int']['input']>;
  /** parameterValueId (ParameterId = 14) */
  transportId?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDamageDtoInput = {
  /** insert a valid pms user */
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  /** insert a valid pms user */
  closedBy?: InputMaybe<Scalars['String']['input']>;
  /** closure date - format: YYYY-MM-DD */
  closureDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** parameterValue (ParameterId = 13) */
  damageTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** creation date - format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** insert a valid pms user */
  insertedBy?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reportedBy?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertDayPriceDtoInput = {
  /** (MANDATORY) - index of the day from 0 */
  day: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  price: Scalars['BigDecimal']['input'];
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertDepositDtoInput = {
  /** (MANDATORY) */
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  depositInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  depositUseId?: InputMaybe<Scalars['Int']['input']>;
  /** (deprecated) */
  holder?: InputMaybe<UpsertInvoiceHolderDtoInput>;
  holderId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY: only if payment is mandatory in owner settings 'paymentMandatoryOnInvoice') */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertIncludedResourceDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  inclusionMode?: InputMaybe<InclusionModeDto>;
  perPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  resourceId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertInvoiceAdditionalProductDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  naturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  partiallyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['BigDecimal']['input'];
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  referenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['Int']['input'];
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpsertInvoiceBlockRulesDtoInput = {
  blockOptional?: InputMaybe<Scalars['Boolean']['input']>;
  blocks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpsertInvoiceDtoInput = {
  /** (MANDATORY) */
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  cityTax?: InputMaybe<Scalars['BigDecimal']['input']>;
  creditNote?: InputMaybe<Scalars['Boolean']['input']>;
  creditNoteInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  creditNoteVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** negative value allowed only for Credit Note */
  deposit?: InputMaybe<Scalars['BigDecimal']['input']>;
  depositInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  depositInvoiceDepartmentId?: InputMaybe<Scalars['Int']['input']>;
  depositInvoiceNaturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  depositInvoiceReferenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated - use `depositInvoiceNaturaTypeOnZeroVat` instead */
  depositInvoiceTypeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  depositInvoiceVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  documentType?: InputMaybe<InvoiceDocumentTypeDto>;
  holder?: InputMaybe<UpsertInvoiceHolderDtoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceExtraDisplayMode?: InputMaybe<InvoiceExtraDisplayModeDto>;
  invoicePurchasedProducts?: InputMaybe<Array<InputMaybe<UpsertInvoiceToPurchasedProductDtoInput>>>;
  invoicePurchasedStays?: InputMaybe<Array<InputMaybe<UpsertInvoiceToPurchasedStayDtoInput>>>;
  invoiceRoomDisplayMode?: InputMaybe<InvoiceRoomDisplayModeDto>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  invoicedCityTaxes?: InputMaybe<Array<InputMaybe<UpsertInvoicedCityTaxDtoInput>>>;
  invoicedDepositId?: InputMaybe<Scalars['Int']['input']>;
  linkedDeposits?: InputMaybe<Array<InputMaybe<UpsertInvoiceToDepositDtoInput>>>;
  masterInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  masterInvoiceId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) */
  ownerCorporateDataId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) In absolute value, total paid amounts must not be > that invoice amount */
  paid?: InputMaybe<Scalars['BigDecimal']['input']>;
  partialPayments?: InputMaybe<Array<InputMaybe<UpsertPartialPaymentDtoInput>>>;
  /** (MANDATORY - if payment2Id is set) - the invoice paid + payment2Amount must not be > that invoice amount */
  payment2Amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  payment2Id?: InputMaybe<Scalars['Int']['input']>;
  paymentCityTaxId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY - If null = outstanding -> A standard receipt can't be outstanding if CashRegister is active, a "RECEIPT_NOT_TO_PAY" IS outstanding) format: YYYY-MM-DD */
  paymentEffective?: InputMaybe<Scalars['LocalDate']['input']>;
  /** format: YYYY-MM-DD */
  paymentExpected?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (MANDATORY - if owner.paymentMandatoryOnInvoice and only for RECEIPT and INVOICE not outstanding) */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  progressive?: InputMaybe<Scalars['Int']['input']>;
  selfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  selfInvoiceNaturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  selfInvoiceReferenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  /** deprecated */
  selfInvoiceSeller?: InputMaybe<UpsertInvoiceHolderDtoInput>;
  selfInvoiceSellerId?: InputMaybe<Scalars['Int']['input']>;
  /** Deprecated - use `selfInvoiceNaturaTypeOnZeroVat` instead */
  selfInvoiceTypeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  selfInvoiceVat?: InputMaybe<Scalars['BigDecimal']['input']>;
  showCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated - use invoiceRoomDisplayMode instead */
  showExtra?: InputMaybe<Scalars['Int']['input']>;
  showId?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated - use invoiceExtraDisplayMode instead */
  showRooms?: InputMaybe<Scalars['Int']['input']>;
  wizardInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertInvoiceDataDtoInput = {
  bolloAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** next cash closure */
  cashRegisterClosure?: InputMaybe<Scalars['String']['input']>;
  /** receipt number */
  cashRegisterCode?: InputMaybe<Scalars['String']['input']>;
  /** cash serial number */
  cashRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DDThh:mm:ss */
  cashRegisterPrintTimestamp?: InputMaybe<Scalars['LocalDateTime']['input']>;
  cigCode?: InputMaybe<Scalars['String']['input']>;
  codiceCommessaConvenzione?: InputMaybe<Scalars['String']['input']>;
  cupCode?: InputMaybe<Scalars['String']['input']>;
  dataDocumento?: InputMaybe<Scalars['LocalDate']['input']>;
  einvoiceSendTimestamp?: InputMaybe<Scalars['LocalDateTime']['input']>;
  einvoiceStatus?: InputMaybe<EInvoiceStatusEnumDto>;
  externalCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idDocumento?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) */
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  relatedDocumentType?: InputMaybe<RelatedDocumentTypeDto>;
  vatChargeability?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertInvoiceHolderDtoInput = {
  id: Scalars['Int']['input'];
  type: InvoiceHolderTypeDto;
};

export type UpsertInvoiceToDepositDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  depositId?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertInvoiceToPurchasedProductDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  naturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  /** format: YYYY-MM-DD */
  originalBeginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  originalDescription?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  originalEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  originalQuantity?: InputMaybe<Scalars['Int']['input']>;
  originalResourceId?: InputMaybe<Scalars['Int']['input']>;
  partiallyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY */
  purchasedProductId?: InputMaybe<Scalars['Int']['input']>;
  referenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated - use `naturaTypeOnZeroVat` instead */
  typeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpsertInvoiceToPurchasedStayDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  naturaTypeOnZeroVat?: InputMaybe<NaturaTypeEnumDto>;
  /** format: YYYY-MM-DD */
  originalBeginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  originalDescription?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  originalEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  originalQuantity?: InputMaybe<Scalars['Int']['input']>;
  originalResourceId?: InputMaybe<Scalars['Int']['input']>;
  partiallyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY */
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
  referenceOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated - use `naturaTypeOnZeroVat` instead */
  typeOnZeroVat?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpsertInvoicedCityTaxDtoInput = {
  /** (MANDATORY */
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  beginNights?: InputMaybe<Scalars['Int']['input']>;
  cityTaxExemptionDescription?: InputMaybe<Scalars['String']['input']>;
  cityTaxExemptionId?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY - if owner.cityTaxMandatoryFields) */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endNights?: InputMaybe<Scalars['Int']['input']>;
  freeGroupLeader?: InputMaybe<Scalars['Boolean']['input']>;
  freeGroupMember?: InputMaybe<Scalars['Boolean']['input']>;
  freeSameCity?: InputMaybe<Scalars['Boolean']['input']>;
  fullExemption?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxNightsInMonth?: InputMaybe<Scalars['Int']['input']>;
  maxNightsInYear?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['BigDecimal']['input']>;
  newAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  ownerCityTaxAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  ownerCityTaxAmountFixed?: InputMaybe<Scalars['Boolean']['input']>;
  ownerCityTaxDescription?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY - if owner.cityTaxMandatoryFields) */
  ownerCityTaxId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY - if owner.cityTaxMandatoryFields) */
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
  purchasedStayToCustomerId?: InputMaybe<Scalars['Int']['input']>;
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UpsertOptionalDtoInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  basePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  category2Id?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with at least one price list) */
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  priceLists?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  travelInsurancePolicyId?: InputMaybe<Scalars['Int']['input']>;
  /** value 0-100 */
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated */
  webMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated */
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertOptionalDataDtoInput = {
  /** (MANDATORY) */
  optionalId?: InputMaybe<Scalars['Int']['input']>;
  webMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  webMandatoryPerNight?: InputMaybe<Scalars['Boolean']['input']>;
  webMandatoryRule?: InputMaybe<WebMandatoryRuleEnumDto>;
  webMaxPurchasableRule?: InputMaybe<WebMaxPurchasableRuleEnumDto>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
  webPurchasableWithCustomDates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertOwnerCorporateDataDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  cashRegisterMode?: InputMaybe<CashRegisterModeDto>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  cityTaxDepartmentId?: InputMaybe<Scalars['Int']['input']>;
  cityTaxVatReference?: InputMaybe<Scalars['String']['input']>;
  cityTaxVatType?: InputMaybe<CityTaxVatTypeEnumDto>;
  /** (MANDATORY) */
  corpName?: InputMaybe<Scalars['String']['input']>;
  /** only one ownerCorporateData can be set as default in the same owner */
  defaultOwnerCorporateData?: InputMaybe<Scalars['Boolean']['input']>;
  defaultVatChargeability?: InputMaybe<DefaultVatChargeabilityEnumDto>;
  depositDepartmentId?: InputMaybe<Scalars['Int']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  einvoiceManagerAncillaryField1?: InputMaybe<Scalars['String']['input']>;
  einvoiceManagerAncillaryField2?: InputMaybe<Scalars['String']['input']>;
  einvoiceManagerHotelCode?: InputMaybe<Scalars['String']['input']>;
  einvoiceManagerPassword?: InputMaybe<Scalars['String']['input']>;
  einvoiceManagerProvider?: InputMaybe<EInvoiceManagerProviderEnumDto>;
  einvoiceManagerUsername?: InputMaybe<Scalars['String']['input']>;
  einvoiceNotificationThreshold?: InputMaybe<Scalars['BigDecimal']['input']>;
  einvoiceTransmitterMail?: InputMaybe<Scalars['String']['input']>;
  einvoiceTransmitterState?: InputMaybe<Scalars['String']['input']>;
  einvoiceTransmitterStateId?: InputMaybe<Scalars['Int']['input']>;
  einvoiceTransmitterTelephone?: InputMaybe<Scalars['String']['input']>;
  einvoiceTransmitterVATNumber?: InputMaybe<Scalars['String']['input']>;
  einvoicingAutoCheck?: InputMaybe<Scalars['Boolean']['input']>;
  einvoicingMode?: InputMaybe<EInvoicingModeEnumDto>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fiscalAddress?: InputMaybe<Scalars['String']['input']>;
  fiscalCity?: InputMaybe<Scalars['String']['input']>;
  fiscalCityId?: InputMaybe<Scalars['Int']['input']>;
  /** if state equals to Italy, must be a valid fiscal code */
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  fiscalDistrict?: InputMaybe<Scalars['String']['input']>;
  fiscalStateId?: InputMaybe<Scalars['Int']['input']>;
  fiscalSystem?: InputMaybe<FiscalSystemEnumDto>;
  fiscalZip?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlockRules?: InputMaybe<UpsertInvoiceBlockRulesDtoInput>;
  liquidationProcess?: InputMaybe<LiquidationProcessEnumDto>;
  /** if set must be a valid mail address */
  mail?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  reaNumber?: InputMaybe<Scalars['String']['input']>;
  reaOffice?: InputMaybe<Scalars['String']['input']>;
  shareCapital?: InputMaybe<Scalars['BigDecimal']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** if set must be greater than or equal to 0 */
  stars?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** if state equals to Italy, must be a valid VAT number */
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  visualizationOrder?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPacketDtoInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) must be greater than 0: a 0 base price is only valid together with a discount, which this mutation does not expose */
  basePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with at least one price list) */
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  priceLists?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** value 0-100 */
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertParameterDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parameterValues?: InputMaybe<Array<InputMaybe<UpsertParameterValueDtoInput>>>;
};

export type UpsertParameterValueDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parameterId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPartialPaymentDtoInput = {
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY) format: YYYY-MM-DD */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY - if owner.paymentMandatoryOnInvoice */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPriceListDtoInput = {
  addedBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed2?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed3?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY with priceAddedCradle) - Must be greater than 0 */
  ageAddedCradle?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with priceAddedJuniorBed) - Must be greater than 0 and greater than ageAddedCradle */
  ageAddedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with priceAddedJuniorBed2) - Must be greater than 0 and greater than ageAddedJuniorBed */
  ageAddedJuniorBed2?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with priceAddedJuniorBed3) - Must be greater than 0 and greater than ageAddedJuniorBed2 */
  ageAddedJuniorBed3?: InputMaybe<Scalars['Int']['input']>;
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationPolicyId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  estimateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  extraAllInclusive?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraAllInclusiveCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraAllInclusiveJunior?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraAllInclusiveJunior2?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraAllInclusiveJunior3?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater or equal than 0 */
  extraBedDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  extraBedParameters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must be greater than 0 */
  extraBreakfast?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraBreakfastCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraBreakfastJunior?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraBreakfastJunior2?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraBreakfastJunior3?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater than 0 */
  extraDinner?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinnerCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinnerJunior?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinnerJunior2?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinnerJunior3?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraGuestParameters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must be greater than 0 */
  extraLunch?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunchCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunchJunior?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunchJunior2?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunchJunior3?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraMealParameters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includedResources?: InputMaybe<Array<InputMaybe<UpsertIncludedResourceDtoInput>>>;
  invoiceDefaultBuilding?: InputMaybe<InvoiceDefaultBuildingDto>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY with extraGuestParameters = true) - Must be greater than 0 */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  perPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must be greater or equal than 0 */
  priceAddedBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater or equal than 0 */
  priceAddedCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater or equal than 0 */
  priceAddedJuniorBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater or equal than 0 */
  priceAddedJuniorBed2?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Must be greater or equal than 0 */
  priceAddedJuniorBed3?: InputMaybe<Scalars['BigDecimal']['input']>;
  publicDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEn?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionEs?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionFr?: InputMaybe<Scalars['String']['input']>;
  publicDescriptionIt?: InputMaybe<Scalars['String']['input']>;
  rateGroupId?: InputMaybe<Scalars['Int']['input']>;
  rateManagerCode?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY with virtual = true) */
  realPriceListId?: InputMaybe<Scalars['Int']['input']>;
  /** Must be greater or equal than 0 */
  releaseDays?: InputMaybe<Scalars['Int']['input']>;
  /** Must be greater or equal than 0 */
  releaseHour?: InputMaybe<Scalars['Int']['input']>;
  sendChannelManagerPrice?: InputMaybe<Scalars['Boolean']['input']>;
  sendChannelManagerRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  showDescriptionOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  virtualDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with virtual = true) - Must be greater or equal than 0 */
  virtualModifier?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY with virtual = true) */
  virtualModifierPerPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated - use `virtualTypeEnum` instead. (MANDATORY with virtual = true) */
  virtualType?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with virtual = true) */
  virtualTypeEnum?: InputMaybe<VirtualTypeEnumDto>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertPrimaryCostDtoInput = {
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertProductDtoInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  basePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  category2Id?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with at least one price list) */
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  priceLists?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reorder?: InputMaybe<Scalars['Int']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  /** value 0-100 */
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  webAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated */
  webMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated */
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertProductDataDtoInput = {
  /** (MANDATORY) */
  productId?: InputMaybe<Scalars['Int']['input']>;
  webMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  webMandatoryRule?: InputMaybe<WebMandatoryRuleEnumDto>;
  webMaxPurchasableRule?: InputMaybe<WebMaxPurchasableRuleEnumDto>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPurchasedPacketDtoInput = {
  /** (MANDATORY) format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** format: YYYY-MM-DDThh:mm:ss */
  creation?: InputMaybe<Scalars['LocalDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY if masterServiceId is set) */
  inclusionMode?: InputMaybe<InclusionModeDto>;
  /** deprecated - use inclusionMode instead */
  inclusionModeId?: InputMaybe<Scalars['Int']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** format: YYYY-MM-DDThh:mm:ss */
  lastModification?: InputMaybe<Scalars['LocalDateTime']['input']>;
  masterServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  packetId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY for estimate proposal - NULL for reservation) */
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY for reservation - NULL for estimate proposal) */
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPurchasedProductDtoInput = {
  /** (MANDATORY) format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  chargeCode?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  fromChannelManager?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY if masterServiceId is set) */
  inclusionMode?: InputMaybe<InclusionModeDto>;
  /** deprecated - use inclusionMode instead */
  inclusionModeId?: InputMaybe<Scalars['Int']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  masterServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY for estimate proposal - NULL for reservation) */
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY for reservation - NULL for estimate proposal) */
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPurchasedStayDtoInput = {
  addedBed?: InputMaybe<Scalars['Int']['input']>;
  addedBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  addedJuniorBed2?: InputMaybe<Scalars['Int']['input']>;
  addedJuniorBed2Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBed3?: InputMaybe<Scalars['Int']['input']>;
  addedJuniorBed3Charge?: InputMaybe<Scalars['BigDecimal']['input']>;
  addedJuniorBedCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  agencyVoucher?: InputMaybe<Scalars['String']['input']>;
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** format: hh:mm */
  arrival?: InputMaybe<Scalars['LocalTime']['input']>;
  /** (MANDATORY) check-in date - format: YYYY-MM-DD */
  beginDate?: InputMaybe<Scalars['LocalDate']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  channelManagerIdForManualReservation?: InputMaybe<Scalars['String']['input']>;
  checkInDone?: InputMaybe<Scalars['Boolean']['input']>;
  checkInReady?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutDone?: InputMaybe<Scalars['Boolean']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  cradle?: InputMaybe<Scalars['Int']['input']>;
  cradleCharge?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** format: YYYY-MM-DDThh:mm:ss */
  creation?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** if dayPrices are present, the record number must equal the number of nights and the sum of single day prices must be equal to the price field of purchasedStay */
  dayPrices?: InputMaybe<Array<InputMaybe<UpsertDayPriceDtoInput>>>;
  /** format: hh:mm */
  departure?: InputMaybe<Scalars['LocalTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountFixed?: InputMaybe<Scalars['Boolean']['input']>;
  divideBed?: InputMaybe<Scalars['Boolean']['input']>;
  doorLockCode?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) check-out date - format: YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  housekeeperNotes?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY if masterServiceId is set) */
  inclusionMode?: InputMaybe<InclusionModeDto>;
  /** deprecated - use inclusionMode instead */
  inclusionModeId?: InputMaybe<Scalars['Int']['input']>;
  invoiceHolderId?: InputMaybe<Scalars['Int']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** format: YYYY-MM-DDThh:mm:ss */
  lastModification?: InputMaybe<Scalars['LocalDateTime']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  masterServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) must be equal to the standard number of beds + all added bed, cradles included */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  originalStayId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) if dayPrices are present, the sum of single day prices must be equal to the price field of purchasedStay */
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceListId?: InputMaybe<Scalars['Int']['input']>;
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerPerson?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY for estimate proposal - NULL for reservation) */
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  purchasedPacketId?: InputMaybe<Scalars['Int']['input']>;
  /** contains elements only if the purchasedStay has treatment change, otherwise empty */
  purchasedStayPeriods?: InputMaybe<Array<InputMaybe<UpsertPurchasedStayPeriodDtoInput>>>;
  /** always an item for each guest in the room */
  purchasedStayToCustomers?: InputMaybe<Array<InputMaybe<UpsertPurchasedStayToCustomerDtoInput>>>;
  rackMessage?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY for reservation - NULL for estimate proposal) */
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  restaurantNotes?: InputMaybe<Scalars['String']['input']>;
  roomGadget2Id?: InputMaybe<Scalars['Int']['input']>;
  roomGadgetId?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomLocked?: InputMaybe<Scalars['Boolean']['input']>;
  roomPreparationId?: InputMaybe<Scalars['Int']['input']>;
  startFbWithLunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  stayId?: InputMaybe<Scalars['Int']['input']>;
  travelInsuranceCouponId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPurchasedStayPeriodDtoInput = {
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) - index of the begin day from 0 */
  beginDay: Scalars['Int']['input'];
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) - index of the end day from 0. Must be greater than beginDay */
  endDay: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  priceListId: Scalars['Int']['input'];
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPurchasedStayToCustomerDtoInput = {
  /** (Set only if the period is shorter than the purchasedStay) - index of the begin day from 0 */
  beginDay?: InputMaybe<Scalars['Int']['input']>;
  /** MANDATORY */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** (Set only if the period is shorter than the purchasedStay) - index of the end day from 0. Must be greater than beginDay */
  endDay?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  istatErrorCode?: InputMaybe<Scalars['String']['input']>;
  istatErrorDescription?: InputMaybe<Scalars['String']['input']>;
  istatErrorDetail?: InputMaybe<Scalars['String']['input']>;
  istatStatus?: InputMaybe<IstatStatusDto>;
  /** deprecated - use istatStatus instead */
  istatStatusId?: InputMaybe<Scalars['Int']['input']>;
  psErrorCode?: InputMaybe<Scalars['String']['input']>;
  psErrorDescription?: InputMaybe<Scalars['String']['input']>;
  psErrorDetail?: InputMaybe<Scalars['String']['input']>;
  psStatus?: InputMaybe<PublicSecurityStatusDto>;
  /** deprecated - use psStatus instead */
  psStatusId?: InputMaybe<Scalars['Int']['input']>;
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertResStatusDtoInput = {
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  blue?: InputMaybe<Scalars['Int']['input']>;
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  green?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** if red, green, and blue are all null it's ok, which means the user wants no color, if one is set all must be set (0-255) */
  red?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertRoomDtoInput = {
  /** (MANDATORY) - Must be greater than 0 */
  assignmentOrder?: InputMaybe<Scalars['Int']['input']>;
  divisibleBed?: InputMaybe<Scalars['Boolean']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  housekeepingStatus?: InputMaybe<HousekeepingStatusDto>;
  /** Internal ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlockGroup?: InputMaybe<Scalars['Int']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  istatId?: InputMaybe<Scalars['String']['input']>;
  maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) - Real number of the room (101, 204 ...) */
  number?: InputMaybe<Scalars['String']['input']>;
  plannerOrder?: InputMaybe<Scalars['Int']['input']>;
  psId?: InputMaybe<Scalars['String']['input']>;
  psIstatGroup?: InputMaybe<Scalars['Int']['input']>;
  roomGroup?: InputMaybe<Scalars['Int']['input']>;
  roomPreparationId?: InputMaybe<Scalars['Int']['input']>;
  roomStatusId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  stayId?: InputMaybe<Scalars['Int']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertRoomStatusDtoInput = {
  /** (MANDATORY if at least one color is set) if set must be from 0 to 255 */
  blue?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY if at least one color is set) if set must be from 0 to 255 */
  green?: InputMaybe<Scalars['Int']['input']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY if at least one color is set) if set must be from 0 to 255 */
  red?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertSecondaryCostDtoInput = {
  /** The distribution of this secondary cost over a set of primary costs, by percentage (must sum to 100). */
  costAttributions?: InputMaybe<Array<InputMaybe<UpsertCostAttributionDtoInput>>>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertSegmentDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertStayDtoInput = {
  addedBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  addedJuniorBedFixed?: InputMaybe<Scalars['Boolean']['input']>;
  ageAddedCradle?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) with priceAddedJuniorBed. Must be greater than ageAddedCradle if set */
  ageAddedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) */
  basePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  channelManagerCode?: InputMaybe<Scalars['String']['input']>;
  channelManagerPriceListId?: InputMaybe<Scalars['Int']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with at least one price list) */
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  /** (deprecated) */
  endpointCode?: InputMaybe<Scalars['String']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  extraBreakfast?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraDinner?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraLunch?: InputMaybe<Scalars['BigDecimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) Must be greater or equals than numberOfGuests */
  maxNumberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  minPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  onlyOta?: InputMaybe<Scalars['Boolean']['input']>;
  priceAddedBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY with ageAddedCradle) */
  priceAddedCradle?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceAddedJuniorBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceLists?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rateManagerCode?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY with virtual = true) */
  realStayId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** value 0-100 */
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertStayDataDtoInput = {
  onlineIdentificationCode?: InputMaybe<Scalars['String']['input']>;
  /** (MANDATORY) */
  stayId?: InputMaybe<Scalars['Int']['input']>;
  staySize?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertUserPreferencesDtoInput = {
  addExtraCategoryId?: InputMaybe<Scalars['Int']['input']>;
  askConfirmOnCashMovements?: InputMaybe<Scalars['Boolean']['input']>;
  /** deprecated - use addExtraCategoryId instead */
  categoryAddExtra?: InputMaybe<Scalars['String']['input']>;
  /** deprecated - use restaurantCategoryId instead */
  categoryRestaurant?: InputMaybe<Scalars['String']['input']>;
  checkOptions?: InputMaybe<Scalars['Int']['input']>;
  defaultDailyPlannerDetailId?: InputMaybe<Scalars['Int']['input']>;
  defaultFiscalPrinter?: InputMaybe<Scalars['String']['input']>;
  defaultFiscalTray?: InputMaybe<Scalars['Int']['input']>;
  defaultHoursPlannerDetailId?: InputMaybe<Scalars['Int']['input']>;
  defaultInvoicePrinter?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTray?: InputMaybe<Scalars['Int']['input']>;
  defaultPrinter?: InputMaybe<Scalars['String']['input']>;
  defaultTray?: InputMaybe<Scalars['Int']['input']>;
  enableAdvancedLog?: InputMaybe<Scalars['Boolean']['input']>;
  floorShownForHousekeeper?: InputMaybe<Scalars['Int']['input']>;
  formTitleFontHeight?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceBlockLimit?: InputMaybe<Scalars['String']['input']>;
  invoiceBlockRestaurant?: InputMaybe<Scalars['String']['input']>;
  lockCategory?: InputMaybe<Scalars['Boolean']['input']>;
  moveHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  moveVertical?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantCategoryId?: InputMaybe<Scalars['Int']['input']>;
  roomGroupShownForHousekeeper?: InputMaybe<Scalars['Int']['input']>;
  sectionFontHeight?: InputMaybe<Scalars['Int']['input']>;
  showInvoiceReport?: InputMaybe<Scalars['Int']['input']>;
  showOnlyAssignedDamagesForMantainer?: InputMaybe<Scalars['Boolean']['input']>;
  standardFontBlue?: InputMaybe<Scalars['Int']['input']>;
  standardFontGreen?: InputMaybe<Scalars['Int']['input']>;
  standardFontHeight?: InputMaybe<Scalars['Int']['input']>;
  standardFontRed?: InputMaybe<Scalars['Int']['input']>;
  tableau3DBars?: InputMaybe<Scalars['Boolean']['input']>;
  tableauElementFontHeight?: InputMaybe<Scalars['Int']['input']>;
  tableauEventBorder?: InputMaybe<Scalars['Boolean']['input']>;
  tableauEventDistance?: InputMaybe<Scalars['Int']['input']>;
  tableauEventFontBold?: InputMaybe<Scalars['Boolean']['input']>;
  tableauEventFontHeight?: InputMaybe<Scalars['Int']['input']>;
  tableauEventGradient?: InputMaybe<Scalars['Boolean']['input']>;
  tableauEventHeight?: InputMaybe<Scalars['Int']['input']>;
  tableauHeaderFontHeight?: InputMaybe<Scalars['Int']['input']>;
  tableauHorLines?: InputMaybe<Scalars['Boolean']['input']>;
  uiLanguage?: InputMaybe<DisplayLanguageDto>;
  uiSettings?: InputMaybe<Scalars['String']['input']>;
  uiTheme?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  verticalZoomLevel?: InputMaybe<Scalars['Int']['input']>;
  visibilityInvoiceReport?: InputMaybe<Scalars['Int']['input']>;
  welcomeEditor?: InputMaybe<Scalars['Int']['input']>;
  zoomHourLevel?: InputMaybe<Scalars['Int']['input']>;
  zoomLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertWebPacketDtoInput = {
  /** (MANDATORY greater than 0, if priceAddedJuniorBed is set) */
  ageAddedJuniorBed?: InputMaybe<Scalars['Int']['input']>;
  allInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** if true, stayId is not required */
  applicateAllStay?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY) if 0, discount must also be set, otherwise must be greater than 0 */
  basePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** (MANDATORY) */
  beginSell?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (MANDATORY) */
  beginValidity?: InputMaybe<Scalars['LocalDate']['input']>;
  breakfast?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationPolicyId?: InputMaybe<Scalars['Int']['input']>;
  checkInFriday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInMonday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInSunday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInThursday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkInWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFriday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutMonday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutSunday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutThursday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  costCenterId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY with at least one price list, or if discount is set) */
  defaultPriceListId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionEs?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  dinner?: InputMaybe<Scalars['Boolean']['input']>;
  /** must be greater than or equal to 0. This is a multiplier applied to the referenced defaultPriceList's price, NOT a 0-100 percentage: 1 = no discount, 0.9 = 10% off, 0 = 100% off. percentage-to-multiplier: multiplier = 1 - (percentage / 100) */
  discount?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountDecimalsRounding?: InputMaybe<Scalars['Int']['input']>;
  /** must be greater than 0. Number of days of advance booking required for this packet to be purchasable: valid only when (checkIn - today) >= earlyBird */
  earlyBird?: InputMaybe<Scalars['Int']['input']>;
  /** (MANDATORY) */
  endSell?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (MANDATORY) */
  endValidity?: InputMaybe<Scalars['LocalDate']['input']>;
  exportCode?: InputMaybe<Scalars['String']['input']>;
  /** must be greater than 0 */
  extraAllInclusive?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** must be greater than 0 */
  extraBreakfast?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** must be greater than 0 */
  extraDinner?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** must be greater than 0 */
  extraLunch?: InputMaybe<Scalars['BigDecimal']['input']>;
  extraParameters?: InputMaybe<Scalars['Boolean']['input']>;
  /** must be greater than 0 */
  firstAddedNight?: InputMaybe<Scalars['BigDecimal']['input']>;
  hideDiscountOnBol?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullRateOnBol?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** must be greater than or equal to 0. Number of days before check-in within which this packet becomes purchasable: valid only when (checkIn - today) <= lastMinute. 0 means available only on the check-in day itself */
  lastMinute?: InputMaybe<Scalars['Int']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** must be greater than 0 */
  maximumStay?: InputMaybe<Scalars['Int']['input']>;
  /** must be greater than 0 */
  minimumStay?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesDe?: InputMaybe<Scalars['String']['input']>;
  notesEn?: InputMaybe<Scalars['String']['input']>;
  notesEs?: InputMaybe<Scalars['String']['input']>;
  notesFr?: InputMaybe<Scalars['String']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  /** must be greater than or equal to 0 */
  priceAddedBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** must be greater than or equal to 0 */
  priceAddedJuniorBed?: InputMaybe<Scalars['BigDecimal']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** must be greater than 0 */
  secondAddedNight?: InputMaybe<Scalars['BigDecimal']['input']>;
  showInShowcase?: InputMaybe<Scalars['Boolean']['input']>;
  /** (MANDATORY unless applicateAllStay) */
  stayId?: InputMaybe<Scalars['Int']['input']>;
  /** value 0-100 */
  vat?: InputMaybe<Scalars['BigDecimal']['input']>;
  vatRateId?: InputMaybe<Scalars['Int']['input']>;
  webOrder?: InputMaybe<Scalars['Int']['input']>;
  /** must be greater than 0 */
  weekendExtra?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type UserPreferencesDto = {
  __typename?: 'UserPreferencesDTO';
  addExtraCategoryId: Maybe<Scalars['Int']['output']>;
  askConfirmOnCashMovements: Scalars['Boolean']['output'];
  /** deprecated - use `addExtraCategoryId` instead */
  categoryAddExtra: Maybe<Scalars['String']['output']>;
  /** deprecated - use `restaurantCategoryId` instead */
  categoryRestaurant: Maybe<Scalars['String']['output']>;
  checkOptions: Maybe<Scalars['Int']['output']>;
  defaultDailyPlannerDetailId: Maybe<Scalars['Int']['output']>;
  defaultFiscalPrinter: Maybe<Scalars['String']['output']>;
  defaultFiscalTray: Maybe<Scalars['Int']['output']>;
  defaultHoursPlannerDetailId: Maybe<Scalars['Int']['output']>;
  defaultInvoicePrinter: Maybe<Scalars['String']['output']>;
  defaultInvoiceTray: Maybe<Scalars['Int']['output']>;
  defaultPrinter: Maybe<Scalars['String']['output']>;
  defaultTray: Maybe<Scalars['Int']['output']>;
  enableAdvancedLog: Scalars['Boolean']['output'];
  floorShownForHousekeeper: Maybe<Scalars['Int']['output']>;
  formTitleFontHeight: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoiceBlockLimit: Maybe<Scalars['String']['output']>;
  invoiceBlockRestaurant: Maybe<Scalars['String']['output']>;
  lockCategory: Scalars['Boolean']['output'];
  moveHorizontal: Scalars['Boolean']['output'];
  moveVertical: Scalars['Boolean']['output'];
  restaurantCategoryId: Maybe<Scalars['Int']['output']>;
  roomGroupShownForHousekeeper: Maybe<Scalars['Int']['output']>;
  sectionFontHeight: Maybe<Scalars['Int']['output']>;
  showInvoiceReport: Maybe<Scalars['Int']['output']>;
  showOnlyAssignedDamagesForMantainer: Scalars['Boolean']['output'];
  standardFontBlue: Maybe<Scalars['Int']['output']>;
  standardFontGreen: Maybe<Scalars['Int']['output']>;
  standardFontHeight: Maybe<Scalars['Int']['output']>;
  standardFontRed: Maybe<Scalars['Int']['output']>;
  tableau3DBars: Scalars['Boolean']['output'];
  tableauElementFontHeight: Maybe<Scalars['Int']['output']>;
  tableauEventBorder: Scalars['Boolean']['output'];
  tableauEventDistance: Maybe<Scalars['Int']['output']>;
  tableauEventFontBold: Scalars['Boolean']['output'];
  tableauEventFontHeight: Maybe<Scalars['Int']['output']>;
  tableauEventGradient: Scalars['Boolean']['output'];
  tableauEventHeight: Maybe<Scalars['Int']['output']>;
  tableauHeaderFontHeight: Maybe<Scalars['Int']['output']>;
  tableauHorLines: Scalars['Boolean']['output'];
  uiLanguage: Maybe<DisplayLanguageDto>;
  /** All UI settings structured in JSON */
  uiSettings: Maybe<Scalars['String']['output']>;
  /** deprecated - use `uiSettings` instead */
  uiTheme: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  verticalZoomLevel: Maybe<Scalars['Int']['output']>;
  visibilityInvoiceReport: Maybe<Scalars['Int']['output']>;
  /** 0: None, 1: Planner, 2: Tableau, 3: Dashboard */
  welcomeEditor: Scalars['Int']['output'];
  zoomHourLevel: Maybe<Scalars['Int']['output']>;
  zoomLevel: Maybe<Scalars['Int']['output']>;
};

export type ValidateElectronicInvoiceResponseDto = {
  __typename?: 'ValidateElectronicInvoiceResponseDTO';
  resourceValidationResults: Array<ResourceValidationResultDto>;
  xsdValidationError: Maybe<Scalars['String']['output']>;
};

export type ValidateElectronicInvoicesResponseDto = {
  __typename?: 'ValidateElectronicInvoicesResponseDTO';
  results: Array<ValidationResultDto>;
};

export type ValidatePurchasedStayPeriodsRequestDtoInput = {
  newBeginDate: Scalars['LocalDate']['input'];
  newEndDate: Scalars['LocalDate']['input'];
  newPeriods: Array<InputMaybe<UpsertPurchasedStayPeriodDtoInput>>;
  purchasedStayId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidationErrorDto = {
  __typename?: 'ValidationErrorDTO';
  errorCode: Scalars['String']['output'];
  fieldName: Maybe<Scalars['String']['output']>;
  translationKey: Scalars['String']['output'];
};

export type ValidationResultDto = {
  __typename?: 'ValidationResultDTO';
  invoiceId: Scalars['Int']['output'];
  resourceValidationResults: Array<ResourceValidationResultDto>;
  xsdValidationError: Maybe<Scalars['String']['output']>;
};

export type VatRateDto = {
  __typename?: 'VatRateDTO';
  atecoCode: Maybe<AtecoCodeDto>;
  atecoCodeId: Maybe<Scalars['Int']['output']>;
  cashRegisterCode: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  naturaTypeOnZeroVat: Maybe<NaturaTypeEnumDto>;
  ownerId: Scalars['Int']['output'];
  rate: Scalars['BigDecimal']['output'];
  referenceOnZeroVat: Maybe<Scalars['String']['output']>;
  typeOnZeroVat: Maybe<Scalars['String']['output']>;
};

export enum VirtualTypeEnumDto {
  Min = 'MIN',
  Perc = 'PERC',
  Plus = 'PLUS'
}

export type WebAvailabilityInfoDtoInput = {
  availability?: InputMaybe<Scalars['Int']['input']>;
  availabilityOta?: InputMaybe<Scalars['Int']['input']>;
  mode: WebAvailabilityUpdateModeEnumDto;
  stayId: Scalars['Int']['input'];
};

export enum WebAvailabilityModeEnumDto {
  Closed = 'CLOSED',
  Custom = 'CUSTOM',
  FreeSell = 'FREE_SELL'
}

export enum WebAvailabilityUpdateModeEnumDto {
  Availability = 'AVAILABILITY',
  AvailabilityAndOta = 'AVAILABILITY_AND_OTA',
  Close = 'CLOSE',
  FreeSell = 'FREE_SELL'
}

export enum WebMandatoryRuleEnumDto {
  PerPerson = 'PER_PERSON',
  PerReservation = 'PER_RESERVATION',
  PerRoom = 'PER_ROOM'
}

export enum WebMaxPurchasableRuleEnumDto {
  PerPerson = 'PER_PERSON',
  PerPersonPerNight = 'PER_PERSON_PER_NIGHT',
  PerRoom = 'PER_ROOM'
}

export enum WeekDayEnumDto {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/* eslint-enable */